var Qa = (m, x, y) => {
  if (!x.has(m))
    throw TypeError("Cannot " + y);
};
var g1 = (m, x, y) => {
  if (x.has(m))
    throw TypeError("Cannot add the same private member more than once");
  x instanceof WeakSet ? x.add(m) : x.set(m, y);
};
var ee = (m, x, y) => (Qa(m, x, "access private method"), y);
function Aa(m, x, y, K, i0, P, z, D) {
  var W = typeof m == "function" ? m.options : m;
  x && (W.render = x, W.staticRenderFns = y, W._compiled = !0), K && (W.functional = !0), P && (W._scopeId = "data-v-" + P);
  var f0;
  if (z ? (f0 = function(H) {
    H = H || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !H && typeof __VUE_SSR_CONTEXT__ < "u" && (H = __VUE_SSR_CONTEXT__), i0 && i0.call(this, H), H && H._registeredComponents && H._registeredComponents.add(z);
  }, W._ssrRegister = f0) : i0 && (f0 = D ? function() {
    i0.call(
      this,
      (W.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i0), f0)
    if (W.functional) {
      W._injectStyles = f0;
      var R = W.render;
      W.render = function(n0, Q) {
        return f0.call(Q), R(n0, Q);
      };
    } else {
      var c = W.beforeCreate;
      W.beforeCreate = c ? [].concat(c, f0) : [f0];
    }
  return {
    exports: m,
    options: W
  };
}
const za = {
  name: "AudioPlayer",
  props: {
    src: {
      type: String,
      default: void 0
    }
  },
  data() {
    return {
      player: null,
      isPlaying: !1
    };
  },
  watch: {
    isPlaying(m) {
      this.$emit("update:isPlaying", m);
    },
    src() {
      this.stop();
    }
  },
  methods: {
    play() {
      if (this.isPlaying) {
        this.stop();
        return;
      }
      if (!this.player) {
        this.player = new Audio();
        const m = () => {
          this.player.removeEventListener("ended", m), this.player.removeEventListener("pause", m), this.player.removeEventListener("error", m), this.player = null, this.isPlaying = !1;
        };
        this.player.addEventListener("ended", m), this.player.addEventListener("pause", m), this.player.addEventListener("error", m);
      }
      this.player.pause(), this.player.src = this.src, this.player.play(), this.isPlaying = !0;
    },
    stop() {
      this.isPlaying = !1, this.player && this.player.pause();
    }
  }
};
var ja = function() {
  var x = this, y = x._self._c;
  return y("div", [x._t("default", null, null, {
    play: x.play,
    stop: x.stop,
    isPlaying: x.isPlaying
  })], 2);
}, Wa = [], Ja = /* @__PURE__ */ Aa(
  za,
  ja,
  Wa,
  !1,
  null,
  null,
  null,
  null
);
const ga = Ja.exports;
let er = class Ra {
  constructor(x) {
    this.stream = x, this.state = "inactive", this.onAudioProcess = null, this.onStart = null, this.onStop = null, this.audioContext = new AudioContext({
      latencyHint: "interactive"
    });
  }
  /**
   * ~100ms at 44.1 kHz sample rate
   * @return {number}
   */
  static get bufferSize() {
    return 4096;
  }
  get currentTime() {
    return this.audioContext.currentTime;
  }
  get sampleRate() {
    return this.audioContext.sampleRate;
  }
  start() {
    this.state = "recording", this.input = this.audioContext.createMediaStreamSource(this.stream), this.processor = this.audioContext.createScriptProcessor(Ra.bufferSize, 1, 1), this.input.connect(this.processor), this.processor.connect(this.audioContext.destination), this.processor.onaudioprocess = (x) => {
      const K = x.inputBuffer.getChannelData(0);
      this.onAudioProcess(K);
    }, this.onStart && this.onStart();
  }
  pause() {
    this.state = "paused", this.input.disconnect(), this.processor.disconnect();
  }
  async stop() {
    this.state = "inactive", this.input.disconnect(), this.processor.disconnect(), await this.audioContext.close(), this.onStop && this.onStop();
  }
};
function ar(m) {
  return new Int8Array(m);
}
function xa(m) {
  return new Int16Array(m);
}
function Ma(m) {
  return new Int32Array(m);
}
function Ea(m) {
  return new Float32Array(m);
}
function rr(m) {
  return new Float64Array(m);
}
function Ba(m) {
  if (m.length == 1)
    return Ea(m[0]);
  var x = m[0];
  m = m.slice(1);
  for (var y = [], K = 0; K < x; K++)
    y.push(Ba(m));
  return y;
}
function Ta(m) {
  if (m.length == 1)
    return Ma(m[0]);
  var x = m[0];
  m = m.slice(1);
  for (var y = [], K = 0; K < x; K++)
    y.push(Ta(m));
  return y;
}
function ya(m) {
  if (m.length == 1)
    return xa(m[0]);
  var x = m[0];
  m = m.slice(1);
  for (var y = [], K = 0; K < x; K++)
    y.push(ya(m));
  return y;
}
function wa(m) {
  if (m.length == 1)
    return new Array(m[0]);
  var x = m[0];
  m = m.slice(1);
  for (var y = [], K = 0; K < x; K++)
    y.push(wa(m));
  return y;
}
var pa = {};
pa.fill = function(m, x, y, K) {
  if (arguments.length == 2)
    for (var i0 = 0; i0 < m.length; i0++)
      m[i0] = arguments[1];
  else
    for (var i0 = x; i0 < y; i0++)
      m[i0] = K;
};
var z1 = {};
z1.arraycopy = function(m, x, y, K, i0) {
  for (var P = x + i0; x < P; )
    y[K++] = m[x++];
};
z1.out = {};
z1.out.println = function(m) {
  console.log(m);
};
z1.out.printf = function() {
  console.log.apply(console, arguments);
};
var oe = {};
oe.SQRT2 = 1.4142135623730951;
oe.FAST_LOG10 = function(m) {
  return Math.log10(m);
};
oe.FAST_LOG10_X = function(m, x) {
  return Math.log10(m) * x;
};
function B1(m) {
  this.ordinal = m;
}
B1.short_block_allowed = new B1(0);
B1.short_block_coupled = new B1(1);
B1.short_block_dispensed = new B1(2);
B1.short_block_forced = new B1(3);
var Ia = {};
Ia.MAX_VALUE = 34028235e31;
function h1(m) {
  this.ordinal = m;
}
h1.vbr_off = new h1(0);
h1.vbr_mt = new h1(1);
h1.vbr_rh = new h1(2);
h1.vbr_abr = new h1(3);
h1.vbr_mtrh = new h1(4);
h1.vbr_default = h1.vbr_mtrh;
var tr = function(m) {
}, Q0 = {
  System: z1,
  VbrMode: h1,
  Float: Ia,
  ShortBlock: B1,
  Util: oe,
  Arrays: pa,
  new_array_n: wa,
  new_byte: ar,
  new_double: rr,
  new_float: Ea,
  new_float_n: Ba,
  new_int: Ma,
  new_int_n: Ta,
  new_short: xa,
  new_short_n: ya,
  assert: tr
}, xe, Ke;
function nr() {
  if (Ke)
    return xe;
  Ke = 1;
  var m = Q0, x = m.System, y = m.Util, K = m.Arrays, i0 = m.new_float, P = t1();
  function z() {
    var D = [
      -0.1482523854003001,
      32.308141959636465,
      296.40344946382766,
      883.1344870032432,
      11113.947376231741,
      1057.2713659324597,
      305.7402417275812,
      30.825928907280012,
      /* 15 */
      3.8533188138216365,
      59.42900443849514,
      709.5899960123345,
      5281.91112291017,
      -5829.66483675846,
      -817.6293103748613,
      -76.91656988279972,
      -4.594269939176596,
      0.9063471690191471,
      0.1960342806591213,
      -0.15466694054279598,
      34.324387823855965,
      301.8067566458425,
      817.599602898885,
      11573.795901679885,
      1181.2520595540152,
      321.59731579894424,
      31.232021761053772,
      /* 14 */
      3.7107095756221318,
      53.650946155329365,
      684.167428119626,
      5224.56624370173,
      -6366.391851890084,
      -908.9766368219582,
      -89.83068876699639,
      -5.411397422890401,
      0.8206787908286602,
      0.3901806440322567,
      -0.16070888947830023,
      36.147034243915876,
      304.11815768187864,
      732.7429163887613,
      11989.60988270091,
      1300.012278487897,
      335.28490093152146,
      31.48816102859945,
      /* 13 */
      3.373875931311736,
      47.232241542899175,
      652.7371796173471,
      5132.414255594984,
      -6909.087078780055,
      -1001.9990371107289,
      -103.62185754286375,
      -6.104916304710272,
      0.7416505462720353,
      0.5805693545089249,
      -0.16636367662261495,
      37.751650073343995,
      303.01103387567713,
      627.9747488785183,
      12358.763425278165,
      1412.2779918482834,
      346.7496836825721,
      31.598286663170416,
      /* 12 */
      3.1598635433980946,
      40.57878626349686,
      616.1671130880391,
      5007.833007176154,
      -7454.040671756168,
      -1095.7960341867115,
      -118.24411666465777,
      -6.818469345853504,
      0.6681786379192989,
      0.7653668647301797,
      -0.1716176790982088,
      39.11551877123304,
      298.3413246578966,
      503.5259106886539,
      12679.589408408976,
      1516.5821921214542,
      355.9850766329023,
      31.395241710249053,
      /* 11 */
      2.9164211881972335,
      33.79716964664243,
      574.8943997801362,
      4853.234992253242,
      -7997.57021486075,
      -1189.7624067269965,
      -133.6444792601766,
      -7.7202770609839915,
      0.5993769336819237,
      0.9427934736519954,
      -0.17645823955292173,
      40.21879108166477,
      289.9982036694474,
      359.3226160751053,
      12950.259102786438,
      1612.1013903507662,
      362.85067106591504,
      31.045922092242872,
      /* 10 */
      2.822222032597987,
      26.988862316190684,
      529.8996541764288,
      4671.371946949588,
      -8535.899136645805,
      -1282.5898586244496,
      -149.58553632943463,
      -8.643494270763135,
      0.5345111359507916,
      1.111140466039205,
      -0.36174739330527045,
      41.04429910497807,
      277.5463268268618,
      195.6386023135583,
      13169.43812144731,
      1697.6433561479398,
      367.40983966190305,
      30.557037410382826,
      /* 9 */
      2.531473372857427,
      20.070154905927314,
      481.50208566532336,
      4464.970341588308,
      -9065.36882077239,
      -1373.62841526722,
      -166.1660487028118,
      -9.58289321133207,
      0.4729647758913199,
      1.268786568327291,
      -0.36970682634889585,
      41.393213350082036,
      261.2935935556502,
      12.935476055240873,
      13336.131683328815,
      1772.508612059496,
      369.76534388639965,
      29.751323653701338,
      2.4023193045459172,
      13.304795348228817,
      430.5615775526625,
      4237.0568611071185,
      -9581.931701634761,
      -1461.6913552409758,
      -183.12733958476446,
      -10.718010163869403,
      0.41421356237309503,
      /* tan(PI/8) */
      1.414213562373095,
      -0.37677560326535325,
      41.619486213528496,
      241.05423794991074,
      -187.94665032361226,
      13450.063605744153,
      1836.153896465782,
      369.4908799925761,
      29.001847876923147,
      /* 7 */
      2.0714759319987186,
      6.779591200894186,
      377.7767837205709,
      3990.386575512536,
      -10081.709459700915,
      -1545.947424837898,
      -200.3762958015653,
      -11.864482073055006,
      0.3578057213145241,
      1.546020906725474,
      -0.3829366947518991,
      41.1516456456653,
      216.47684307105183,
      -406.1569483347166,
      13511.136535077321,
      1887.8076599260432,
      367.3025214564151,
      28.136213436723654,
      /* 6 */
      1.913880671464418,
      0.3829366947518991,
      323.85365704338597,
      3728.1472257487526,
      -10561.233882199509,
      -1625.2025997821418,
      -217.62525175416,
      -13.015432208941645,
      0.3033466836073424,
      1.66293922460509,
      -0.5822628872992417,
      40.35639251440489,
      188.20071124269245,
      -640.2706748618148,
      13519.21490106562,
      1927.6022433578062,
      362.8197642637487,
      26.968821921868447,
      /* 5 */
      1.7463817695935329,
      -5.62650678237171,
      269.3016715297017,
      3453.386536448852,
      -11016.145278780888,
      -1698.6569643425091,
      -234.7658734267683,
      -14.16351421663124,
      0.2504869601913055,
      1.76384252869671,
      -0.5887180101749253,
      39.23429103868072,
      155.76096234403798,
      -889.2492977967378,
      13475.470561874661,
      1955.0535223723712,
      356.4450994756727,
      25.894952980042156,
      /* 4 */
      1.5695032905781554,
      -11.181939564328772,
      214.80884394039484,
      3169.1640829158237,
      -11443.321309975563,
      -1765.1588461316153,
      -251.68908574481912,
      -15.49755935939164,
      0.198912367379658,
      1.847759065022573,
      -0.7912582233652842,
      37.39369355329111,
      119.699486012458,
      -1151.0956593239027,
      13380.446257078214,
      1970.3952110853447,
      348.01959814116185,
      24.731487364283044,
      /* 3 */
      1.3850130831637748,
      -16.421408865300393,
      161.05030052864092,
      2878.3322807850063,
      -11838.991423510031,
      -1823.985884688674,
      -268.2854986386903,
      -16.81724543849939,
      0.1483359875383474,
      1.913880671464418,
      -0.7960642926861912,
      35.2322109610459,
      80.01928065061526,
      -1424.0212633405113,
      13235.794061869668,
      1973.804052543835,
      337.9908651258184,
      23.289159354463873,
      1.3934255946442087,
      -21.099669467133474,
      108.48348407242611,
      2583.700758091299,
      -12199.726194855148,
      -1874.2780658979746,
      -284.2467154529415,
      -18.11369784385905,
      0.09849140335716425,
      1.961570560806461,
      -0.998795456205172,
      32.56307803611191,
      36.958364584370486,
      -1706.075448829146,
      13043.287458812016,
      1965.3831106103316,
      326.43182772364605,
      22.175018750622293,
      1.198638339011324,
      -25.371248002043963,
      57.53505923036915,
      2288.41886619975,
      -12522.674544337233,
      -1914.8400385312243,
      -299.26241273417224,
      -19.37805630698734,
      0.04912684976946725,
      1.990369453344394,
      0.035780907 * y.SQRT2 * 0.5 / 2384e-9,
      0.017876148 * y.SQRT2 * 0.5 / 2384e-9,
      3134727e-9 * y.SQRT2 * 0.5 / 2384e-9,
      2457142e-9 * y.SQRT2 * 0.5 / 2384e-9,
      971317e-9 * y.SQRT2 * 0.5 / 2384e-9,
      218868e-9 * y.SQRT2 * 0.5 / 2384e-9,
      101566e-9 * y.SQRT2 * 0.5 / 2384e-9,
      13828e-9 * y.SQRT2 * 0.5 / 2384e-9,
      12804.797818791945,
      1945.5515939597317,
      313.4244966442953,
      20.801593959731544,
      1995.1556208053692,
      9.000838926174497,
      -29.20218120805369
      /* 2.384e-06/2.384e-06 */
    ], W = 12, f0 = 36, R = [
      [
        2382191739347913e-28,
        6423305872147834e-28,
        9400849094049688e-28,
        1122435026096556e-27,
        1183840321267481e-27,
        1122435026096556e-27,
        940084909404969e-27,
        6423305872147839e-28,
        2382191739347918e-28,
        5456116108943412e-27,
        4878985199565852e-27,
        4240448995017367e-27,
        3559909094758252e-27,
        2858043359288075e-27,
        2156177623817898e-27,
        1475637723558783e-27,
        8371015190102974e-28,
        2599706096327376e-28,
        -5456116108943412e-27,
        -4878985199565852e-27,
        -4240448995017367e-27,
        -3559909094758252e-27,
        -2858043359288076e-27,
        -2156177623817898e-27,
        -1475637723558783e-27,
        -8371015190102975e-28,
        -2599706096327376e-28,
        -2382191739347923e-28,
        -6423305872147843e-28,
        -9400849094049696e-28,
        -1122435026096556e-27,
        -1183840321267481e-27,
        -1122435026096556e-27,
        -9400849094049694e-28,
        -642330587214784e-27,
        -2382191739347918e-28
      ],
      [
        2382191739347913e-28,
        6423305872147834e-28,
        9400849094049688e-28,
        1122435026096556e-27,
        1183840321267481e-27,
        1122435026096556e-27,
        9400849094049688e-28,
        6423305872147841e-28,
        2382191739347918e-28,
        5456116108943413e-27,
        4878985199565852e-27,
        4240448995017367e-27,
        3559909094758253e-27,
        2858043359288075e-27,
        2156177623817898e-27,
        1475637723558782e-27,
        8371015190102975e-28,
        2599706096327376e-28,
        -5461314069809755e-27,
        -4921085770524055e-27,
        -4343405037091838e-27,
        -3732668368707687e-27,
        -3093523840190885e-27,
        -2430835727329465e-27,
        -1734679010007751e-27,
        -974825365660928e-27,
        -2797435120168326e-28,
        0,
        0,
        0,
        0,
        0,
        0,
        -2283748241799531e-28,
        -4037858874020686e-28,
        -2146547464825323e-28
      ],
      [
        0.1316524975873958,
        /* win[SHORT_TYPE] */
        0.414213562373095,
        0.7673269879789602,
        1.091308501069271,
        /* tantab_l */
        1.303225372841206,
        1.56968557711749,
        1.920982126971166,
        2.414213562373094,
        3.171594802363212,
        4.510708503662055,
        7.595754112725146,
        22.90376554843115,
        0.984807753012208,
        /* cx */
        0.6427876096865394,
        0.3420201433256688,
        0.9396926207859084,
        -0.1736481776669303,
        -0.7660444431189779,
        0.8660254037844387,
        0.5,
        -0.5144957554275265,
        /* ca */
        -0.4717319685649723,
        -0.3133774542039019,
        -0.1819131996109812,
        -0.09457419252642064,
        -0.04096558288530405,
        -0.01419856857247115,
        -0.003699974673760037,
        0.8574929257125442,
        /* cs */
        0.8817419973177052,
        0.9496286491027329,
        0.9833145924917901,
        0.9955178160675857,
        0.9991605581781475,
        0.999899195244447,
        0.9999931550702802
      ],
      [
        0,
        0,
        0,
        0,
        0,
        0,
        2283748241799531e-28,
        4037858874020686e-28,
        2146547464825323e-28,
        5461314069809755e-27,
        4921085770524055e-27,
        4343405037091838e-27,
        3732668368707687e-27,
        3093523840190885e-27,
        2430835727329466e-27,
        1734679010007751e-27,
        974825365660928e-27,
        2797435120168326e-28,
        -5456116108943413e-27,
        -4878985199565852e-27,
        -4240448995017367e-27,
        -3559909094758253e-27,
        -2858043359288075e-27,
        -2156177623817898e-27,
        -1475637723558782e-27,
        -8371015190102975e-28,
        -2599706096327376e-28,
        -2382191739347913e-28,
        -6423305872147834e-28,
        -9400849094049688e-28,
        -1122435026096556e-27,
        -1183840321267481e-27,
        -1122435026096556e-27,
        -9400849094049688e-28,
        -6423305872147841e-28,
        -2382191739347918e-28
      ]
    ], c = R[P.SHORT_TYPE], H = R[P.SHORT_TYPE], n0 = R[P.SHORT_TYPE], Q = R[P.SHORT_TYPE], t0 = [
      0,
      1,
      16,
      17,
      8,
      9,
      24,
      25,
      4,
      5,
      20,
      21,
      12,
      13,
      28,
      29,
      2,
      3,
      18,
      19,
      10,
      11,
      26,
      27,
      6,
      7,
      22,
      23,
      14,
      15,
      30,
      31
    ];
    function j(h, A, e) {
      for (var l = 10, B = A + 238 - 14 - 286, V = -15; V < 0; V++) {
        var O, w, L;
        O = D[l + -10], w = h[B + -224] * O, L = h[A + 224] * O, O = D[l + -9], w += h[B + -160] * O, L += h[A + 160] * O, O = D[l + -8], w += h[B + -96] * O, L += h[A + 96] * O, O = D[l + -7], w += h[B + -32] * O, L += h[A + 32] * O, O = D[l + -6], w += h[B + 32] * O, L += h[A + -32] * O, O = D[l + -5], w += h[B + 96] * O, L += h[A + -96] * O, O = D[l + -4], w += h[B + 160] * O, L += h[A + -160] * O, O = D[l + -3], w += h[B + 224] * O, L += h[A + -224] * O, O = D[l + -2], w += h[A + -256] * O, L -= h[B + 256] * O, O = D[l + -1], w += h[A + -192] * O, L -= h[B + 192] * O, O = D[l + 0], w += h[A + -128] * O, L -= h[B + 128] * O, O = D[l + 1], w += h[A + -64] * O, L -= h[B + 64] * O, O = D[l + 2], w += h[A + 0] * O, L -= h[B + 0] * O, O = D[l + 3], w += h[A + 64] * O, L -= h[B + -64] * O, O = D[l + 4], w += h[A + 128] * O, L -= h[B + -128] * O, O = D[l + 5], w += h[A + 192] * O, L -= h[B + -192] * O, w *= D[l + 6], O = L - w, e[30 + V * 2] = L + w, e[31 + V * 2] = D[l + 7] * O, l += 18, A--, B++;
      }
      {
        var w, L, v0, b;
        L = h[A + -16] * D[l + -10], w = h[A + -32] * D[l + -2], L += (h[A + -48] - h[A + 16]) * D[l + -9], w += h[A + -96] * D[l + -1], L += (h[A + -80] + h[A + 48]) * D[l + -8], w += h[A + -160] * D[l + 0], L += (h[A + -112] - h[A + 80]) * D[l + -7], w += h[A + -224] * D[l + 1], L += (h[A + -144] + h[A + 112]) * D[l + -6], w -= h[A + 32] * D[l + 2], L += (h[A + -176] - h[A + 144]) * D[l + -5], w -= h[A + 96] * D[l + 3], L += (h[A + -208] + h[A + 176]) * D[l + -4], w -= h[A + 160] * D[l + 4], L += (h[A + -240] - h[A + 208]) * D[l + -3], w -= h[A + 224], v0 = w - L, b = w + L, L = e[14], w = e[15] - L, e[31] = b + L, e[30] = v0 + w, e[15] = v0 - w, e[14] = b - L;
      }
      {
        var a;
        a = e[28] - e[0], e[0] += e[28], e[28] = a * D[l + -2 * 18 + 7], a = e[29] - e[1], e[1] += e[29], e[29] = a * D[l + -2 * 18 + 7], a = e[26] - e[2], e[2] += e[26], e[26] = a * D[l + -4 * 18 + 7], a = e[27] - e[3], e[3] += e[27], e[27] = a * D[l + -4 * 18 + 7], a = e[24] - e[4], e[4] += e[24], e[24] = a * D[l + -6 * 18 + 7], a = e[25] - e[5], e[5] += e[25], e[25] = a * D[l + -6 * 18 + 7], a = e[22] - e[6], e[6] += e[22], e[22] = a * y.SQRT2, a = e[23] - e[7], e[7] += e[23], e[23] = a * y.SQRT2 - e[7], e[7] -= e[6], e[22] -= e[7], e[23] -= e[22], a = e[6], e[6] = e[31] - a, e[31] = e[31] + a, a = e[7], e[7] = e[30] - a, e[30] = e[30] + a, a = e[22], e[22] = e[15] - a, e[15] = e[15] + a, a = e[23], e[23] = e[14] - a, e[14] = e[14] + a, a = e[20] - e[8], e[8] += e[20], e[20] = a * D[l + -10 * 18 + 7], a = e[21] - e[9], e[9] += e[21], e[21] = a * D[l + -10 * 18 + 7], a = e[18] - e[10], e[10] += e[18], e[18] = a * D[l + -12 * 18 + 7], a = e[19] - e[11], e[11] += e[19], e[19] = a * D[l + -12 * 18 + 7], a = e[16] - e[12], e[12] += e[16], e[16] = a * D[l + -14 * 18 + 7], a = e[17] - e[13], e[13] += e[17], e[17] = a * D[l + -14 * 18 + 7], a = -e[20] + e[24], e[20] += e[24], e[24] = a * D[l + -12 * 18 + 7], a = -e[21] + e[25], e[21] += e[25], e[25] = a * D[l + -12 * 18 + 7], a = e[4] - e[8], e[4] += e[8], e[8] = a * D[l + -12 * 18 + 7], a = e[5] - e[9], e[5] += e[9], e[9] = a * D[l + -12 * 18 + 7], a = e[0] - e[12], e[0] += e[12], e[12] = a * D[l + -4 * 18 + 7], a = e[1] - e[13], e[1] += e[13], e[13] = a * D[l + -4 * 18 + 7], a = e[16] - e[28], e[16] += e[28], e[28] = a * D[l + -4 * 18 + 7], a = -e[17] + e[29], e[17] += e[29], e[29] = a * D[l + -4 * 18 + 7], a = y.SQRT2 * (e[2] - e[10]), e[2] += e[10], e[10] = a, a = y.SQRT2 * (e[3] - e[11]), e[3] += e[11], e[11] = a, a = y.SQRT2 * (-e[18] + e[26]), e[18] += e[26], e[26] = a - e[18], a = y.SQRT2 * (-e[19] + e[27]), e[19] += e[27], e[27] = a - e[19], a = e[2], e[19] -= e[3], e[3] -= a, e[2] = e[31] - a, e[31] += a, a = e[3], e[11] -= e[19], e[18] -= a, e[3] = e[30] - a, e[30] += a, a = e[18], e[27] -= e[11], e[19] -= a, e[18] = e[15] - a, e[15] += a, a = e[19], e[10] -= a, e[19] = e[14] - a, e[14] += a, a = e[10], e[11] -= a, e[10] = e[23] - a, e[23] += a, a = e[11], e[26] -= a, e[11] = e[22] - a, e[22] += a, a = e[26], e[27] -= a, e[26] = e[7] - a, e[7] += a, a = e[27], e[27] = e[6] - a, e[6] += a, a = y.SQRT2 * (e[0] - e[4]), e[0] += e[4], e[4] = a, a = y.SQRT2 * (e[1] - e[5]), e[1] += e[5], e[5] = a, a = y.SQRT2 * (e[16] - e[20]), e[16] += e[20], e[20] = a, a = y.SQRT2 * (e[17] - e[21]), e[17] += e[21], e[21] = a, a = -y.SQRT2 * (e[8] - e[12]), e[8] += e[12], e[12] = a - e[8], a = -y.SQRT2 * (e[9] - e[13]), e[9] += e[13], e[13] = a - e[9], a = -y.SQRT2 * (e[25] - e[29]), e[25] += e[29], e[29] = a - e[25], a = -y.SQRT2 * (e[24] + e[28]), e[24] -= e[28], e[28] = a - e[24], a = e[24] - e[16], e[24] = a, a = e[20] - a, e[20] = a, a = e[28] - a, e[28] = a, a = e[25] - e[17], e[25] = a, a = e[21] - a, e[21] = a, a = e[29] - a, e[29] = a, a = e[17] - e[1], e[17] = a, a = e[9] - a, e[9] = a, a = e[25] - a, e[25] = a, a = e[5] - a, e[5] = a, a = e[21] - a, e[21] = a, a = e[13] - a, e[13] = a, a = e[29] - a, e[29] = a, a = e[1] - e[0], e[1] = a, a = e[16] - a, e[16] = a, a = e[17] - a, e[17] = a, a = e[8] - a, e[8] = a, a = e[9] - a, e[9] = a, a = e[24] - a, e[24] = a, a = e[25] - a, e[25] = a, a = e[4] - a, e[4] = a, a = e[5] - a, e[5] = a, a = e[20] - a, e[20] = a, a = e[21] - a, e[21] = a, a = e[12] - a, e[12] = a, a = e[13] - a, e[13] = a, a = e[28] - a, e[28] = a, a = e[29] - a, e[29] = a, a = e[0], e[0] += e[31], e[31] -= a, a = e[1], e[1] += e[30], e[30] -= a, a = e[16], e[16] += e[15], e[15] -= a, a = e[17], e[17] += e[14], e[14] -= a, a = e[8], e[8] += e[23], e[23] -= a, a = e[9], e[9] += e[22], e[22] -= a, a = e[24], e[24] += e[7], e[7] -= a, a = e[25], e[25] += e[6], e[6] -= a, a = e[4], e[4] += e[27], e[27] -= a, a = e[5], e[5] += e[26], e[26] -= a, a = e[20], e[20] += e[11], e[11] -= a, a = e[21], e[21] += e[10], e[10] -= a, a = e[12], e[12] += e[19], e[19] -= a, a = e[13], e[13] += e[18], e[18] -= a, a = e[28], e[28] += e[3], e[3] -= a, a = e[29], e[29] += e[2], e[2] -= a;
      }
    }
    function M(h, A) {
      for (var e = 0; e < 3; e++) {
        var l, B, V, O, w, L;
        O = h[A + 2 * 3] * R[P.SHORT_TYPE][0] - h[A + 5 * 3], l = h[A + 0 * 3] * R[P.SHORT_TYPE][2] - h[A + 3 * 3], B = O + l, V = O - l, O = h[A + 5 * 3] * R[P.SHORT_TYPE][0] + h[A + 2 * 3], l = h[A + 3 * 3] * R[P.SHORT_TYPE][2] + h[A + 0 * 3], w = O + l, L = -O + l, l = (h[A + 1 * 3] * R[P.SHORT_TYPE][1] - h[A + 4 * 3]) * 2069978111953089e-26, O = (h[A + 4 * 3] * R[P.SHORT_TYPE][1] + h[A + 1 * 3]) * 2069978111953089e-26, h[A + 3 * 0] = B * 190752519173728e-25 + l, h[A + 3 * 5] = -w * 190752519173728e-25 + O, V = V * 0.8660254037844387 * 1907525191737281e-26, w = w * 0.5 * 1907525191737281e-26 + O, h[A + 3 * 1] = V - w, h[A + 3 * 2] = V + w, B = B * 0.5 * 1907525191737281e-26 - l, L = L * 0.8660254037844387 * 1907525191737281e-26, h[A + 3 * 3] = B + L, h[A + 3 * 4] = B - L, A++;
      }
    }
    function v(h, A, e) {
      var l, B;
      {
        var V, O, w, L, v0, b, a, S;
        V = e[17] - e[9], w = e[15] - e[11], L = e[14] - e[12], v0 = e[0] + e[8], b = e[1] + e[7], a = e[2] + e[6], S = e[3] + e[5], h[A + 17] = v0 + a - S - (b - e[4]), B = (v0 + a - S) * H[12 + 7] + (b - e[4]), l = (V - w - L) * H[12 + 6], h[A + 5] = l + B, h[A + 6] = l - B, O = (e[16] - e[10]) * H[12 + 6], b = b * H[12 + 7] + e[4], l = V * H[12 + 0] + O + w * H[12 + 1] + L * H[12 + 2], B = -v0 * H[12 + 4] + b - a * H[12 + 5] + S * H[12 + 3], h[A + 1] = l + B, h[A + 2] = l - B, l = V * H[12 + 1] - O - w * H[12 + 2] + L * H[12 + 0], B = -v0 * H[12 + 5] + b - a * H[12 + 3] + S * H[12 + 4], h[A + 9] = l + B, h[A + 10] = l - B, l = V * H[12 + 2] - O + w * H[12 + 0] - L * H[12 + 1], B = v0 * H[12 + 3] - b + a * H[12 + 4] - S * H[12 + 5], h[A + 13] = l + B, h[A + 14] = l - B;
      }
      {
        var C, F, N, U, T, s, n, r;
        C = e[8] - e[0], N = e[6] - e[2], U = e[5] - e[3], T = e[17] + e[9], s = e[16] + e[10], n = e[15] + e[11], r = e[14] + e[12], h[A + 0] = T + n + r + (s + e[13]), l = (T + n + r) * H[12 + 7] - (s + e[13]), B = (C - N + U) * H[12 + 6], h[A + 11] = l + B, h[A + 12] = l - B, F = (e[7] - e[1]) * H[12 + 6], s = e[13] - s * H[12 + 7], l = T * H[12 + 3] - s + n * H[12 + 4] + r * H[12 + 5], B = C * H[12 + 2] + F + N * H[12 + 0] + U * H[12 + 1], h[A + 3] = l + B, h[A + 4] = l - B, l = -T * H[12 + 5] + s - n * H[12 + 3] - r * H[12 + 4], B = C * H[12 + 1] + F - N * H[12 + 2] - U * H[12 + 0], h[A + 7] = l + B, h[A + 8] = l - B, l = -T * H[12 + 4] + s - n * H[12 + 5] - r * H[12 + 3], B = C * H[12 + 0] - F + N * H[12 + 1] - U * H[12 + 2], h[A + 15] = l + B, h[A + 16] = l - B;
      }
    }
    this.mdct_sub48 = function(h, A, e) {
      for (var l = A, B = 286, V = 0; V < h.channels_out; V++) {
        for (var O = 0; O < h.mode_gr; O++) {
          for (var w, L = h.l3_side.tt[O][V], v0 = L.xr, b = 0, a = h.sb_sample[V][1 - O], S = 0, C = 0; C < 18 / 2; C++)
            for (j(l, B, a[S]), j(l, B + 32, a[S + 1]), S += 2, B += 64, w = 1; w < 32; w += 2)
              a[S - 1][w] *= -1;
          for (w = 0; w < 32; w++, b += 18) {
            var F = L.block_type, N = h.sb_sample[V][O], U = h.sb_sample[V][1 - O];
            if (L.mixed_block_flag != 0 && w < 2 && (F = 0), h.amp_filter[w] < 1e-12)
              K.fill(
                v0,
                b + 0,
                b + 18,
                0
              );
            else {
              if (h.amp_filter[w] < 1)
                for (var C = 0; C < 18; C++)
                  U[C][t0[w]] *= h.amp_filter[w];
              if (F == P.SHORT_TYPE) {
                for (var C = -W / 4; C < 0; C++) {
                  var T = R[P.SHORT_TYPE][C + 3];
                  v0[b + C * 3 + 9] = N[9 + C][t0[w]] * T - N[8 - C][t0[w]], v0[b + C * 3 + 18] = N[14 - C][t0[w]] * T + N[15 + C][t0[w]], v0[b + C * 3 + 10] = N[15 + C][t0[w]] * T - N[14 - C][t0[w]], v0[b + C * 3 + 19] = U[2 - C][t0[w]] * T + U[3 + C][t0[w]], v0[b + C * 3 + 11] = U[3 + C][t0[w]] * T - U[2 - C][t0[w]], v0[b + C * 3 + 20] = U[8 - C][t0[w]] * T + U[9 + C][t0[w]];
                }
                M(v0, b);
              } else {
                for (var s = i0(18), C = -f0 / 4; C < 0; C++) {
                  var n, r;
                  n = R[F][C + 27] * U[C + 9][t0[w]] + R[F][C + 36] * U[8 - C][t0[w]], r = R[F][C + 9] * N[C + 9][t0[w]] - R[F][C + 18] * N[8 - C][t0[w]], s[C + 9] = n - r * c[3 + C + 9], s[C + 18] = n * c[3 + C + 9] + r;
                }
                v(v0, b, s);
              }
            }
            if (F != P.SHORT_TYPE && w != 0)
              for (var C = 7; C >= 0; --C) {
                var i, f;
                i = v0[b + C] * n0[20 + C] + v0[b + -1 - C] * Q[28 + C], f = v0[b + C] * Q[28 + C] - v0[b + -1 - C] * n0[20 + C], v0[b + -1 - C] = i, v0[b + C] = f;
              }
          }
        }
        if (l = e, B = 286, h.mode_gr == 1)
          for (var q = 0; q < 18; q++)
            x.arraycopy(
              h.sb_sample[V][1][q],
              0,
              h.sb_sample[V][0][q],
              0,
              32
            );
      }
    };
  }
  return xe = z, xe;
}
var Me, Ue;
function La() {
  if (Ue)
    return Me;
  Ue = 1;
  var m = t1(), x = Q0, y = x.System, K = x.new_float, i0 = x.new_float_n;
  function P() {
    this.l = K(m.SBMAX_l), this.s = i0([m.SBMAX_s, 3]);
    var z = this;
    this.assign = function(D) {
      y.arraycopy(D.l, 0, z.l, 0, m.SBMAX_l);
      for (var W = 0; W < m.SBMAX_s; W++)
        for (var f0 = 0; f0 < 3; f0++)
          z.s[W][f0] = D.s[W][f0];
    };
  }
  return Me = P, Me;
}
var Ee, Qe;
function sr() {
  if (Qe)
    return Ee;
  Qe = 1;
  var m = La();
  function x() {
    this.thm = new m(), this.en = new m();
  }
  return Ee = x, Ee;
}
function A1(m) {
  var x = m;
  this.ordinal = function() {
    return x;
  };
}
A1.STEREO = new A1(0);
A1.JOINT_STEREO = new A1(1);
A1.DUAL_CHANNEL = new A1(2);
A1.MONO = new A1(3);
A1.NOT_SET = new A1(4);
var j1 = A1, Be, ze;
function t1() {
  if (ze)
    return Be;
  ze = 1;
  var m = Q0, x = m.System, y = m.VbrMode, K = m.new_array_n, i0 = m.new_float, P = m.new_float_n, z = m.new_int, D = m.assert;
  W.ENCDELAY = 576, W.POSTDELAY = 1152, W.MDCTDELAY = 48, W.FFTOFFSET = 224 + W.MDCTDELAY, W.DECDELAY = 528, W.SBLIMIT = 32, W.CBANDS = 64, W.SBPSY_l = 21, W.SBPSY_s = 12, W.SBMAX_l = 22, W.SBMAX_s = 13, W.PSFB21 = 6, W.PSFB12 = 6, W.BLKSIZE = 1024, W.HBLKSIZE = W.BLKSIZE / 2 + 1, W.BLKSIZE_s = 256, W.HBLKSIZE_s = W.BLKSIZE_s / 2 + 1, W.NORM_TYPE = 0, W.START_TYPE = 1, W.SHORT_TYPE = 2, W.STOP_TYPE = 3, W.MPG_MD_LR_LR = 0, W.MPG_MD_LR_I = 1, W.MPG_MD_MS_LR = 2, W.MPG_MD_MS_I = 3, W.fircoef = [
    -0.0207887 * 5,
    -0.0378413 * 5,
    -0.0432472 * 5,
    -0.031183 * 5,
    779609e-23 * 5,
    0.0467745 * 5,
    0.10091 * 5,
    0.151365 * 5,
    0.187098 * 5
  ];
  function W() {
    var f0 = nr(), R = sr(), c = j1, H = W.FFTOFFSET, n0 = W.MPG_MD_MS_LR, Q = null;
    this.psy = null;
    var t0 = null, j = null, M = null;
    this.setModules = function(l, B, V, O) {
      Q = l, this.psy = B, t0 = B, j = O, M = V;
    };
    var v = new f0();
    function h(l) {
      var B, V;
      if (l.ATH.useAdjust == 0) {
        l.ATH.adjust = 1;
        return;
      }
      if (V = l.loudness_sq[0][0], B = l.loudness_sq[1][0], l.channels_out == 2 ? (V += l.loudness_sq[0][1], B += l.loudness_sq[1][1]) : (V += V, B += B), l.mode_gr == 2 && (V = Math.max(V, B)), V *= 0.5, V *= l.ATH.aaSensitivityP, V > 0.03125)
        l.ATH.adjust >= 1 ? l.ATH.adjust = 1 : l.ATH.adjust < l.ATH.adjustLimit && (l.ATH.adjust = l.ATH.adjustLimit), l.ATH.adjustLimit = 1;
      else {
        var O = 31.98 * V + 625e-6;
        l.ATH.adjust >= O ? (l.ATH.adjust *= O * 0.075 + 0.925, l.ATH.adjust < O && (l.ATH.adjust = O)) : l.ATH.adjustLimit >= O ? l.ATH.adjust = O : l.ATH.adjust < l.ATH.adjustLimit && (l.ATH.adjust = l.ATH.adjustLimit), l.ATH.adjustLimit = O;
      }
    }
    function A(l) {
      var B, V;
      for (D(0 <= l.bitrate_index && l.bitrate_index < 16), D(0 <= l.mode_ext && l.mode_ext < 4), l.bitrate_stereoMode_Hist[l.bitrate_index][4]++, l.bitrate_stereoMode_Hist[15][4]++, l.channels_out == 2 && (l.bitrate_stereoMode_Hist[l.bitrate_index][l.mode_ext]++, l.bitrate_stereoMode_Hist[15][l.mode_ext]++), B = 0; B < l.mode_gr; ++B)
        for (V = 0; V < l.channels_out; ++V) {
          var O = l.l3_side.tt[B][V].block_type | 0;
          l.l3_side.tt[B][V].mixed_block_flag != 0 && (O = 4), l.bitrate_blockType_Hist[l.bitrate_index][O]++, l.bitrate_blockType_Hist[l.bitrate_index][5]++, l.bitrate_blockType_Hist[15][O]++, l.bitrate_blockType_Hist[15][5]++;
        }
    }
    function e(l, B) {
      var V = l.internal_flags, O, w;
      if (V.lame_encode_frame_init == 0) {
        var L, v0, b = i0(2014), a = i0(286 + 1152 + 576);
        for (V.lame_encode_frame_init = 1, L = 0, v0 = 0; L < 286 + 576 * (1 + V.mode_gr); ++L)
          L < 576 * V.mode_gr ? (b[L] = 0, V.channels_out == 2 && (a[L] = 0)) : (b[L] = B[0][v0], V.channels_out == 2 && (a[L] = B[1][v0]), ++v0);
        for (w = 0; w < V.mode_gr; w++)
          for (O = 0; O < V.channels_out; O++)
            V.l3_side.tt[w][O].block_type = W.SHORT_TYPE;
        v.mdct_sub48(V, b, a), D(576 >= W.FFTOFFSET), D(V.mf_size >= W.BLKSIZE + l.framesize - W.FFTOFFSET), D(V.mf_size >= 512 + l.framesize - 32);
      }
    }
    this.lame_encode_mp3_frame = function(l, B, V, O, w, L) {
      var v0, b = K([2, 2]);
      b[0][0] = new R(), b[0][1] = new R(), b[1][0] = new R(), b[1][1] = new R();
      var a = K([2, 2]);
      a[0][0] = new R(), a[0][1] = new R(), a[1][0] = new R(), a[1][1] = new R();
      var S, C = [null, null], F = l.internal_flags, N = P([2, 4]), U = [0.5, 0.5], T = [[0, 0], [0, 0]], s = [[0, 0], [0, 0]], n, r, i;
      if (C[0] = B, C[1] = V, F.lame_encode_frame_init == 0 && e(l, C), F.padding = 0, (F.slot_lag -= F.frac_SpF) < 0 && (F.slot_lag += l.out_samplerate, F.padding = 1), F.psymodel != 0) {
        var f, q = [null, null], g = 0, p = z(2);
        for (i = 0; i < F.mode_gr; i++) {
          for (r = 0; r < F.channels_out; r++)
            q[r] = C[r], g = 576 + i * 576 - W.FFTOFFSET;
          if (l.VBR == y.vbr_mtrh || l.VBR == y.vbr_mt ? f = t0.L3psycho_anal_vbr(
            l,
            q,
            g,
            i,
            b,
            a,
            T[i],
            s[i],
            N[i],
            p
          ) : f = t0.L3psycho_anal_ns(
            l,
            q,
            g,
            i,
            b,
            a,
            T[i],
            s[i],
            N[i],
            p
          ), f != 0)
            return -4;
          for (l.mode == c.JOINT_STEREO && (U[i] = N[i][2] + N[i][3], U[i] > 0 && (U[i] = N[i][3] / U[i])), r = 0; r < F.channels_out; r++) {
            var G = F.l3_side.tt[i][r];
            G.block_type = p[r], G.mixed_block_flag = 0;
          }
        }
      } else
        for (i = 0; i < F.mode_gr; i++)
          for (r = 0; r < F.channels_out; r++)
            F.l3_side.tt[i][r].block_type = W.NORM_TYPE, F.l3_side.tt[i][r].mixed_block_flag = 0, s[i][r] = T[i][r] = 700;
      if (h(F), v.mdct_sub48(F, C[0], C[1]), F.mode_ext = W.MPG_MD_LR_LR, l.force_ms)
        F.mode_ext = W.MPG_MD_MS_LR;
      else if (l.mode == c.JOINT_STEREO) {
        var s0 = 0, h0 = 0;
        for (i = 0; i < F.mode_gr; i++)
          for (r = 0; r < F.channels_out; r++)
            s0 += s[i][r], h0 += T[i][r];
        if (s0 <= 1 * h0) {
          var S0 = F.l3_side.tt[0], M0 = F.l3_side.tt[F.mode_gr - 1];
          S0[0].block_type == S0[1].block_type && M0[0].block_type == M0[1].block_type && (F.mode_ext = W.MPG_MD_MS_LR);
        }
      }
      if (F.mode_ext == n0 ? (S = a, n = s) : (S = b, n = T), l.analysis && F.pinfo != null)
        for (i = 0; i < F.mode_gr; i++)
          for (r = 0; r < F.channels_out; r++)
            F.pinfo.ms_ratio[i] = F.ms_ratio[i], F.pinfo.ms_ener_ratio[i] = U[i], F.pinfo.blocktype[i][r] = F.l3_side.tt[i][r].block_type, F.pinfo.pe[i][r] = n[i][r], x.arraycopy(
              F.l3_side.tt[i][r].xr,
              0,
              F.pinfo.xr[i][r],
              0,
              576
            ), F.mode_ext == n0 && (F.pinfo.ers[i][r] = F.pinfo.ers[i][r + 2], x.arraycopy(
              F.pinfo.energy[i][r + 2],
              0,
              F.pinfo.energy[i][r],
              0,
              F.pinfo.energy[i][r].length
            ));
      if (l.VBR == y.vbr_off || l.VBR == y.vbr_abr) {
        var R0, A0;
        for (R0 = 0; R0 < 18; R0++)
          F.nsPsy.pefirbuf[R0] = F.nsPsy.pefirbuf[R0 + 1];
        for (A0 = 0, i = 0; i < F.mode_gr; i++)
          for (r = 0; r < F.channels_out; r++)
            A0 += n[i][r];
        for (F.nsPsy.pefirbuf[18] = A0, A0 = F.nsPsy.pefirbuf[9], R0 = 0; R0 < 9; R0++)
          A0 += (F.nsPsy.pefirbuf[R0] + F.nsPsy.pefirbuf[18 - R0]) * W.fircoef[R0];
        for (A0 = 670 * 5 * F.mode_gr * F.channels_out / A0, i = 0; i < F.mode_gr; i++)
          for (r = 0; r < F.channels_out; r++)
            n[i][r] *= A0;
      }
      if (F.iteration_loop.iteration_loop(l, n, U, S), Q.format_bitstream(l), v0 = Q.copy_buffer(F, O, w, L, 1), l.bWriteVbrTag && j.addVbrFrame(l), l.analysis && F.pinfo != null) {
        for (r = 0; r < F.channels_out; r++) {
          var w0;
          for (w0 = 0; w0 < H; w0++)
            F.pinfo.pcmdata[r][w0] = F.pinfo.pcmdata[r][w0 + l.framesize];
          for (w0 = H; w0 < 1600; w0++)
            F.pinfo.pcmdata[r][w0] = C[r][w0 - H];
        }
        M.set_frame_pinfo(l, S);
      }
      return A(F), v0;
    };
  }
  return Be = W, Be;
}
var Ca = Q0, je = Ca.Util, We = Ca.new_float, J0 = t1();
function ir() {
  var m = We(J0.BLKSIZE), x = We(J0.BLKSIZE_s / 2), y = [
    0.9238795325112867,
    0.3826834323650898,
    0.9951847266721969,
    0.0980171403295606,
    0.9996988186962042,
    0.02454122852291229,
    0.9999811752826011,
    0.006135884649154475
  ];
  function K(P, z, D) {
    var W = 0, f0, R, c;
    D <<= 1;
    var H = z + D;
    f0 = 4;
    do {
      var n0, Q, t0, j, M, v, h;
      h = f0 >> 1, j = f0, M = f0 << 1, v = M + j, f0 = M << 1, R = z, c = R + h;
      do {
        var A, e, l, B;
        e = P[R + 0] - P[R + j], A = P[R + 0] + P[R + j], B = P[R + M] - P[R + v], l = P[R + M] + P[R + v], P[R + M] = A - l, P[R + 0] = A + l, P[R + v] = e - B, P[R + j] = e + B, e = P[c + 0] - P[c + j], A = P[c + 0] + P[c + j], B = je.SQRT2 * P[c + v], l = je.SQRT2 * P[c + M], P[c + M] = A - l, P[c + 0] = A + l, P[c + v] = e - B, P[c + j] = e + B, c += f0, R += f0;
      } while (R < H);
      for (Q = y[W + 0], n0 = y[W + 1], t0 = 1; t0 < h; t0++) {
        var V, O;
        V = 1 - 2 * n0 * n0, O = 2 * n0 * Q, R = z + t0, c = z + j - t0;
        do {
          var w, L, v0, A, e, b, l, a, B, S;
          L = O * P[R + j] - V * P[c + j], w = V * P[R + j] + O * P[c + j], e = P[R + 0] - w, A = P[R + 0] + w, b = P[c + 0] - L, v0 = P[c + 0] + L, L = O * P[R + v] - V * P[c + v], w = V * P[R + v] + O * P[c + v], B = P[R + M] - w, l = P[R + M] + w, S = P[c + M] - L, a = P[c + M] + L, L = n0 * l - Q * S, w = Q * l + n0 * S, P[R + M] = A - w, P[R + 0] = A + w, P[c + v] = b - L, P[c + j] = b + L, L = Q * a - n0 * B, w = n0 * a + Q * B, P[c + M] = v0 - w, P[c + 0] = v0 + w, P[R + v] = e - L, P[R + j] = e + L, c += f0, R += f0;
        } while (R < H);
        V = Q, Q = V * y[W + 0] - n0 * y[W + 1], n0 = V * y[W + 1] + n0 * y[W + 0];
      }
      W += 2;
    } while (f0 < D);
  }
  var i0 = [
    0,
    128,
    64,
    192,
    32,
    160,
    96,
    224,
    16,
    144,
    80,
    208,
    48,
    176,
    112,
    240,
    8,
    136,
    72,
    200,
    40,
    168,
    104,
    232,
    24,
    152,
    88,
    216,
    56,
    184,
    120,
    248,
    4,
    132,
    68,
    196,
    36,
    164,
    100,
    228,
    20,
    148,
    84,
    212,
    52,
    180,
    116,
    244,
    12,
    140,
    76,
    204,
    44,
    172,
    108,
    236,
    28,
    156,
    92,
    220,
    60,
    188,
    124,
    252,
    2,
    130,
    66,
    194,
    34,
    162,
    98,
    226,
    18,
    146,
    82,
    210,
    50,
    178,
    114,
    242,
    10,
    138,
    74,
    202,
    42,
    170,
    106,
    234,
    26,
    154,
    90,
    218,
    58,
    186,
    122,
    250,
    6,
    134,
    70,
    198,
    38,
    166,
    102,
    230,
    22,
    150,
    86,
    214,
    54,
    182,
    118,
    246,
    14,
    142,
    78,
    206,
    46,
    174,
    110,
    238,
    30,
    158,
    94,
    222,
    62,
    190,
    126,
    254
  ];
  this.fft_short = function(P, z, D, W, f0) {
    for (var R = 0; R < 3; R++) {
      var c = J0.BLKSIZE_s / 2, H = 65535 & 576 / 3 * (R + 1), n0 = J0.BLKSIZE_s / 8 - 1;
      do {
        var Q, t0, j, M, v, h = i0[n0 << 2] & 255;
        Q = x[h] * W[D][f0 + h + H], v = x[127 - h] * W[D][f0 + h + H + 128], t0 = Q - v, Q = Q + v, j = x[h + 64] * W[D][f0 + h + H + 64], v = x[63 - h] * W[D][f0 + h + H + 192], M = j - v, j = j + v, c -= 4, z[R][c + 0] = Q + j, z[R][c + 2] = Q - j, z[R][c + 1] = t0 + M, z[R][c + 3] = t0 - M, Q = x[h + 1] * W[D][f0 + h + H + 1], v = x[126 - h] * W[D][f0 + h + H + 129], t0 = Q - v, Q = Q + v, j = x[h + 65] * W[D][f0 + h + H + 65], v = x[62 - h] * W[D][f0 + h + H + 193], M = j - v, j = j + v, z[R][c + J0.BLKSIZE_s / 2 + 0] = Q + j, z[R][c + J0.BLKSIZE_s / 2 + 2] = Q - j, z[R][c + J0.BLKSIZE_s / 2 + 1] = t0 + M, z[R][c + J0.BLKSIZE_s / 2 + 3] = t0 - M;
      } while (--n0 >= 0);
      K(z[R], c, J0.BLKSIZE_s / 2);
    }
  }, this.fft_long = function(P, z, D, W, f0) {
    var R = J0.BLKSIZE / 8 - 1, c = J0.BLKSIZE / 2;
    do {
      var H, n0, Q, t0, j, M = i0[R] & 255;
      H = m[M] * W[D][f0 + M], j = m[M + 512] * W[D][f0 + M + 512], n0 = H - j, H = H + j, Q = m[M + 256] * W[D][f0 + M + 256], j = m[M + 768] * W[D][f0 + M + 768], t0 = Q - j, Q = Q + j, c -= 4, z[c + 0] = H + Q, z[c + 2] = H - Q, z[c + 1] = n0 + t0, z[c + 3] = n0 - t0, H = m[M + 1] * W[D][f0 + M + 1], j = m[M + 513] * W[D][f0 + M + 513], n0 = H - j, H = H + j, Q = m[M + 257] * W[D][f0 + M + 257], j = m[M + 769] * W[D][f0 + M + 769], t0 = Q - j, Q = Q + j, z[c + J0.BLKSIZE / 2 + 0] = H + Q, z[c + J0.BLKSIZE / 2 + 2] = H - Q, z[c + J0.BLKSIZE / 2 + 1] = n0 + t0, z[c + J0.BLKSIZE / 2 + 3] = n0 - t0;
    } while (--R >= 0);
    K(z, c, J0.BLKSIZE / 2);
  }, this.init_fft = function(P) {
    for (var z = 0; z < J0.BLKSIZE; z++)
      m[z] = 0.42 - 0.5 * Math.cos(2 * Math.PI * (z + 0.5) / J0.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (z + 0.5) / J0.BLKSIZE);
    for (var z = 0; z < J0.BLKSIZE_s / 2; z++)
      x[z] = 0.5 * (1 - Math.cos(2 * Math.PI * (z + 0.5) / J0.BLKSIZE_s));
  };
}
var _r = ir, T1 = Q0, O1 = T1.VbrMode, Je = T1.Float, F1 = T1.ShortBlock, i1 = T1.Util, lr = T1.Arrays, g0 = T1.new_float, c1 = T1.new_float_n, I1 = T1.new_int, O0 = T1.assert, or = _r, r0 = t1();
function vr() {
  var m = j1, x = new or(), y = 2.302585092994046, K = 2, i0 = 16, P = 2, z = 16, D = 0.34, W = 1 / (14752 * 14752) / (r0.BLKSIZE / 2), f0 = 0.01, R = 0.8, c = 0.6, H = 0.3, n0 = 3.5, Q = 21, t0 = 0.2302585093;
  function j(o) {
    return o;
  }
  function M(o, u) {
    for (var E = 0, I = 0; I < r0.BLKSIZE / 2; ++I)
      E += o[I] * u.ATH.eql_w[I];
    return E *= W, E;
  }
  function v(o, u, E, I, Y, d, k, $, X, e0, Z) {
    var a0 = o.internal_flags;
    if (X < 2)
      x.fft_long(a0, I[Y], X, e0, Z), x.fft_short(a0, d[k], X, e0, Z);
    else if (X == 2) {
      for (var c0 = r0.BLKSIZE - 1; c0 >= 0; --c0) {
        var L0 = I[Y + 0][c0], _0 = I[Y + 1][c0];
        I[Y + 0][c0] = (L0 + _0) * i1.SQRT2 * 0.5, I[Y + 1][c0] = (L0 - _0) * i1.SQRT2 * 0.5;
      }
      for (var I0 = 2; I0 >= 0; --I0)
        for (var c0 = r0.BLKSIZE_s - 1; c0 >= 0; --c0) {
          var L0 = d[k + 0][I0][c0], _0 = d[k + 1][I0][c0];
          d[k + 0][I0][c0] = (L0 + _0) * i1.SQRT2 * 0.5, d[k + 1][I0][c0] = (L0 - _0) * i1.SQRT2 * 0.5;
        }
    }
    u[0] = I[Y + 0][0], u[0] *= u[0];
    for (var c0 = r0.BLKSIZE / 2 - 1; c0 >= 0; --c0) {
      var J = I[Y + 0][r0.BLKSIZE / 2 - c0], x0 = I[Y + 0][r0.BLKSIZE / 2 + c0];
      u[r0.BLKSIZE / 2 - c0] = (J * J + x0 * x0) * 0.5;
    }
    for (var I0 = 2; I0 >= 0; --I0) {
      E[I0][0] = d[k + 0][I0][0], E[I0][0] *= E[I0][0];
      for (var c0 = r0.BLKSIZE_s / 2 - 1; c0 >= 0; --c0) {
        var J = d[k + 0][I0][r0.BLKSIZE_s / 2 - c0], x0 = d[k + 0][I0][r0.BLKSIZE_s / 2 + c0];
        E[I0][r0.BLKSIZE_s / 2 - c0] = (J * J + x0 * x0) * 0.5;
      }
    }
    {
      for (var k0 = 0, c0 = 11; c0 < r0.HBLKSIZE; c0++)
        k0 += u[c0];
      a0.tot_ener[X] = k0;
    }
    if (o.analysis) {
      for (var c0 = 0; c0 < r0.HBLKSIZE; c0++)
        a0.pinfo.energy[$][X][c0] = a0.pinfo.energy_save[X][c0], a0.pinfo.energy_save[X][c0] = u[c0];
      a0.pinfo.pe[$][X] = a0.pe[X];
    }
    o.athaa_loudapprox == 2 && X < 2 && (a0.loudness_sq[$][X] = a0.loudness_sq_save[X], a0.loudness_sq_save[X] = M(u, a0));
  }
  var h = 8, A = 23, e = 15, l, B, V, O = [
    1,
    0.79433,
    0.63096,
    0.63096,
    0.63096,
    0.63096,
    0.63096,
    0.25119,
    0.11749
  ];
  function w() {
    l = Math.pow(10, (h + 1) / 16), B = Math.pow(10, (A + 1) / 16), V = Math.pow(10, e / 10);
  }
  var L = [
    3.3246 * 3.3246,
    3.23837 * 3.23837,
    3.15437 * 3.15437,
    3.00412 * 3.00412,
    2.86103 * 2.86103,
    2.65407 * 2.65407,
    2.46209 * 2.46209,
    2.284 * 2.284,
    2.11879 * 2.11879,
    1.96552 * 1.96552,
    1.82335 * 1.82335,
    1.69146 * 1.69146,
    1.56911 * 1.56911,
    1.46658 * 1.46658,
    1.37074 * 1.37074,
    1.31036 * 1.31036,
    1.25264 * 1.25264,
    1.20648 * 1.20648,
    1.16203 * 1.16203,
    1.12765 * 1.12765,
    1.09428 * 1.09428,
    1.0659 * 1.0659,
    1.03826 * 1.03826,
    1.01895 * 1.01895,
    1
  ], v0 = [
    1.33352 * 1.33352,
    1.35879 * 1.35879,
    1.38454 * 1.38454,
    1.39497 * 1.39497,
    1.40548 * 1.40548,
    1.3537 * 1.3537,
    1.30382 * 1.30382,
    1.22321 * 1.22321,
    1.14758 * 1.14758,
    1
  ], b = [
    2.35364 * 2.35364,
    2.29259 * 2.29259,
    2.23313 * 2.23313,
    2.12675 * 2.12675,
    2.02545 * 2.02545,
    1.87894 * 1.87894,
    1.74303 * 1.74303,
    1.61695 * 1.61695,
    1.49999 * 1.49999,
    1.39148 * 1.39148,
    1.29083 * 1.29083,
    1.19746 * 1.19746,
    1.11084 * 1.11084,
    1.03826 * 1.03826
  ];
  function a(o, u, E, I, Y, d) {
    var k;
    if (u > o)
      if (u < o * B)
        k = u / o;
      else
        return o + u;
    else {
      if (o >= u * B)
        return o + u;
      k = o / u;
    }
    if (o += u, I + 3 <= 3 + 3) {
      if (k >= l)
        return o;
      var $ = 0 | i1.FAST_LOG10_X(k, 16);
      return o * v0[$];
    }
    var $ = 0 | i1.FAST_LOG10_X(k, 16);
    if (d != 0 ? u = Y.ATH.cb_s[E] * Y.ATH.adjust : u = Y.ATH.cb_l[E] * Y.ATH.adjust, o < V * u) {
      if (o > u) {
        var X, e0;
        return X = 1, $ <= 13 && (X = b[$]), e0 = i1.FAST_LOG10_X(o / u, 10 / 15), o * ((L[$] - X) * e0 + X);
      }
      return $ > 13 ? o : o * b[$];
    }
    return o * L[$];
  }
  var S = [
    1.33352 * 1.33352,
    1.35879 * 1.35879,
    1.38454 * 1.38454,
    1.39497 * 1.39497,
    1.40548 * 1.40548,
    1.3537 * 1.3537,
    1.30382 * 1.30382,
    1.22321 * 1.22321,
    1.14758 * 1.14758,
    1
  ];
  function C(o, u, E) {
    var I;
    if (o < 0 && (o = 0), u < 0 && (u = 0), o <= 0)
      return u;
    if (u <= 0)
      return o;
    if (u > o ? I = u / o : I = o / u, -2 <= E && E <= 2) {
      if (I >= l)
        return o + u;
      var Y = 0 | i1.FAST_LOG10_X(I, 16);
      return (o + u) * S[Y];
    }
    return I < B ? o + u : (o < u && (o = u), o);
  }
  function F(o, u) {
    var E = o.internal_flags;
    if (E.channels_out > 1) {
      for (var I = 0; I < r0.SBMAX_l; I++) {
        var Y = E.thm[0].l[I], d = E.thm[1].l[I];
        E.thm[0].l[I] += d * u, E.thm[1].l[I] += Y * u;
      }
      for (var I = 0; I < r0.SBMAX_s; I++)
        for (var k = 0; k < 3; k++) {
          var Y = E.thm[0].s[I][k], d = E.thm[1].s[I][k];
          E.thm[0].s[I][k] += d * u, E.thm[1].s[I][k] += Y * u;
        }
    }
  }
  function N(o) {
    for (var u = 0; u < r0.SBMAX_l; u++)
      if (!(o.thm[0].l[u] > 1.58 * o.thm[1].l[u] || o.thm[1].l[u] > 1.58 * o.thm[0].l[u])) {
        var E = o.mld_l[u] * o.en[3].l[u], I = Math.max(
          o.thm[2].l[u],
          Math.min(o.thm[3].l[u], E)
        );
        E = o.mld_l[u] * o.en[2].l[u];
        var Y = Math.max(
          o.thm[3].l[u],
          Math.min(o.thm[2].l[u], E)
        );
        o.thm[2].l[u] = I, o.thm[3].l[u] = Y;
      }
    for (var u = 0; u < r0.SBMAX_s; u++)
      for (var d = 0; d < 3; d++)
        if (!(o.thm[0].s[u][d] > 1.58 * o.thm[1].s[u][d] || o.thm[1].s[u][d] > 1.58 * o.thm[0].s[u][d])) {
          var E = o.mld_s[u] * o.en[3].s[u][d], I = Math.max(
            o.thm[2].s[u][d],
            Math.min(o.thm[3].s[u][d], E)
          );
          E = o.mld_s[u] * o.en[2].s[u][d];
          var Y = Math.max(
            o.thm[3].s[u][d],
            Math.min(o.thm[2].s[u][d], E)
          );
          o.thm[2].s[u][d] = I, o.thm[3].s[u][d] = Y;
        }
  }
  function U(o, u, E) {
    var I = u, Y = Math.pow(10, E);
    u *= 2, I *= 2;
    for (var d = 0; d < r0.SBMAX_l; d++) {
      var k, $, X, e0;
      if (e0 = o.ATH.cb_l[o.bm_l[d]] * Y, k = Math.min(
        Math.max(o.thm[0].l[d], e0),
        Math.max(o.thm[1].l[d], e0)
      ), $ = Math.max(o.thm[2].l[d], e0), X = Math.max(o.thm[3].l[d], e0), k * u < $ + X) {
        var Z = k * I / ($ + X);
        $ *= Z, X *= Z;
      }
      o.thm[2].l[d] = Math.min($, o.thm[2].l[d]), o.thm[3].l[d] = Math.min(X, o.thm[3].l[d]);
    }
    Y *= r0.BLKSIZE_s / r0.BLKSIZE;
    for (var d = 0; d < r0.SBMAX_s; d++)
      for (var a0 = 0; a0 < 3; a0++) {
        var k, $, X, e0;
        if (e0 = o.ATH.cb_s[o.bm_s[d]] * Y, k = Math.min(
          Math.max(o.thm[0].s[d][a0], e0),
          Math.max(o.thm[1].s[d][a0], e0)
        ), $ = Math.max(o.thm[2].s[d][a0], e0), X = Math.max(o.thm[3].s[d][a0], e0), k * u < $ + X) {
          var Z = k * u / ($ + X);
          $ *= Z, X *= Z;
        }
        o.thm[2].s[d][a0] = Math.min(
          o.thm[2].s[d][a0],
          $
        ), o.thm[3].s[d][a0] = Math.min(
          o.thm[3].s[d][a0],
          X
        );
      }
  }
  function T(o, u, E, I, Y) {
    var d, k, $ = 0, X = 0;
    for (d = k = 0; d < r0.SBMAX_s; ++k, ++d) {
      for (var e0 = o.bo_s[d], Z = o.npart_s, a0 = e0 < Z ? e0 : Z; k < a0; )
        O0(u[k] >= 0), O0(E[k] >= 0), $ += u[k], X += E[k], k++;
      if (o.en[I].s[d][Y] = $, o.thm[I].s[d][Y] = X, k >= Z) {
        ++d;
        break;
      }
      O0(u[k] >= 0), O0(E[k] >= 0);
      {
        var c0 = o.PSY.bo_s_weight[d], L0 = 1 - c0;
        $ = c0 * u[k], X = c0 * E[k], o.en[I].s[d][Y] += $, o.thm[I].s[d][Y] += X, $ = L0 * u[k], X = L0 * E[k];
      }
    }
    for (; d < r0.SBMAX_s; ++d)
      o.en[I].s[d][Y] = 0, o.thm[I].s[d][Y] = 0;
  }
  function s(o, u, E, I) {
    var Y, d, k = 0, $ = 0;
    for (Y = d = 0; Y < r0.SBMAX_l; ++d, ++Y) {
      for (var X = o.bo_l[Y], e0 = o.npart_l, Z = X < e0 ? X : e0; d < Z; )
        O0(u[d] >= 0), O0(E[d] >= 0), k += u[d], $ += E[d], d++;
      if (o.en[I].l[Y] = k, o.thm[I].l[Y] = $, d >= e0) {
        ++Y;
        break;
      }
      O0(u[d] >= 0), O0(E[d] >= 0);
      {
        var a0 = o.PSY.bo_l_weight[Y], c0 = 1 - a0;
        k = a0 * u[d], $ = a0 * E[d], o.en[I].l[Y] += k, o.thm[I].l[Y] += $, k = c0 * u[d], $ = c0 * E[d];
      }
    }
    for (; Y < r0.SBMAX_l; ++Y)
      o.en[I].l[Y] = 0, o.thm[I].l[Y] = 0;
  }
  function n(o, u, E, I, Y, d) {
    var k = o.internal_flags, $, X;
    for (X = $ = 0; X < k.npart_s; ++X) {
      for (var e0 = 0, Z = k.numlines_s[X], a0 = 0; a0 < Z; ++a0, ++$) {
        var c0 = u[d][$];
        e0 += c0;
      }
      E[X] = e0;
    }
    for (O0(X == k.npart_s), $ = X = 0; X < k.npart_s; X++) {
      var L0 = k.s3ind_s[X][0], _0 = k.s3_ss[$++] * E[L0];
      for (++L0; L0 <= k.s3ind_s[X][1]; )
        _0 += k.s3_ss[$] * E[L0], ++$, ++L0;
      {
        var I0 = P * k.nb_s1[Y][X];
        I[X] = Math.min(_0, I0);
      }
      if (k.blocktype_old[Y & 1] == r0.SHORT_TYPE) {
        var I0 = z * k.nb_s2[Y][X], J = I[X];
        I[X] = Math.min(I0, J);
      }
      k.nb_s2[Y][X] = k.nb_s1[Y][X], k.nb_s1[Y][X] = _0, O0(I[X] >= 0);
    }
    for (; X <= r0.CBANDS; ++X)
      E[X] = 0, I[X] = 0;
  }
  function r(o, u, E, I) {
    var Y = o.internal_flags;
    o.short_blocks == F1.short_block_coupled && !(u[0] != 0 && u[1] != 0) && (u[0] = u[1] = 0);
    for (var d = 0; d < Y.channels_out; d++)
      I[d] = r0.NORM_TYPE, o.short_blocks == F1.short_block_dispensed && (u[d] = 1), o.short_blocks == F1.short_block_forced && (u[d] = 0), u[d] != 0 ? (O0(Y.blocktype_old[d] != r0.START_TYPE), Y.blocktype_old[d] == r0.SHORT_TYPE && (I[d] = r0.STOP_TYPE)) : (I[d] = r0.SHORT_TYPE, Y.blocktype_old[d] == r0.NORM_TYPE && (Y.blocktype_old[d] = r0.START_TYPE), Y.blocktype_old[d] == r0.STOP_TYPE && (Y.blocktype_old[d] = r0.SHORT_TYPE)), E[d] = Y.blocktype_old[d], Y.blocktype_old[d] = I[d];
  }
  function i(o, u, E) {
    return E >= 1 ? o : E <= 0 ? u : u > 0 ? Math.pow(o / u, E) * u : 0;
  }
  var f = [
    11.8,
    13.6,
    17.2,
    32,
    46.5,
    51.3,
    57.5,
    67.1,
    71.5,
    84.6,
    97.6,
    130
    /* 255.8 */
  ];
  function q(o, u) {
    for (var E = 309.07, I = 0; I < r0.SBMAX_s - 1; I++)
      for (var Y = 0; Y < 3; Y++) {
        var d = o.thm.s[I][Y];
        if (d > 0) {
          var k = d * u, $ = o.en.s[I][Y];
          $ > k && ($ > k * 1e10 ? E += f[I] * (10 * y) : E += f[I] * i1.FAST_LOG10($ / k));
        }
      }
    return E;
  }
  var g = [
    6.8,
    5.8,
    5.8,
    6.4,
    6.5,
    9.9,
    12.1,
    14.4,
    15,
    18.9,
    21.6,
    26.9,
    34.2,
    40.2,
    46.8,
    56.5,
    60.7,
    73.9,
    85.7,
    93.4,
    126.1
    /* 241.3 */
  ];
  function p(o, u) {
    for (var E = 281.0575, I = 0; I < r0.SBMAX_l - 1; I++) {
      var Y = o.thm.l[I];
      if (Y > 0) {
        var d = Y * u, k = o.en.l[I];
        k > d && (k > d * 1e10 ? E += g[I] * (10 * y) : E += g[I] * i1.FAST_LOG10(k / d));
      }
    }
    return E;
  }
  function G(o, u, E, I, Y) {
    var d, k;
    for (d = k = 0; d < o.npart_l; ++d) {
      var $ = 0, X = 0, e0;
      for (e0 = 0; e0 < o.numlines_l[d]; ++e0, ++k) {
        var Z = u[k];
        $ += Z, X < Z && (X = Z);
      }
      E[d] = $, I[d] = X, Y[d] = $ * o.rnumlines_l[d], O0(o.rnumlines_l[d] >= 0), O0(E[d] >= 0), O0(I[d] >= 0), O0(Y[d] >= 0);
    }
  }
  function s0(o, u, E, I) {
    var Y = O.length - 1, d = 0, k = E[d] + E[d + 1];
    if (k > 0) {
      var $ = u[d];
      $ < u[d + 1] && ($ = u[d + 1]), O0(o.numlines_l[d] + o.numlines_l[d + 1] - 1 > 0), k = 20 * ($ * 2 - k) / (k * (o.numlines_l[d] + o.numlines_l[d + 1] - 1));
      var X = 0 | k;
      X > Y && (X = Y), I[d] = X;
    } else
      I[d] = 0;
    for (d = 1; d < o.npart_l - 1; d++)
      if (k = E[d - 1] + E[d] + E[d + 1], k > 0) {
        var $ = u[d - 1];
        $ < u[d] && ($ = u[d]), $ < u[d + 1] && ($ = u[d + 1]), O0(o.numlines_l[d - 1] + o.numlines_l[d] + o.numlines_l[d + 1] - 1 > 0), k = 20 * ($ * 3 - k) / (k * (o.numlines_l[d - 1] + o.numlines_l[d] + o.numlines_l[d + 1] - 1));
        var X = 0 | k;
        X > Y && (X = Y), I[d] = X;
      } else
        I[d] = 0;
    if (O0(d == o.npart_l - 1), k = E[d - 1] + E[d], k > 0) {
      var $ = u[d - 1];
      $ < u[d] && ($ = u[d]), O0(o.numlines_l[d - 1] + o.numlines_l[d] - 1 > 0), k = 20 * ($ * 2 - k) / (k * (o.numlines_l[d - 1] + o.numlines_l[d] - 1));
      var X = 0 | k;
      X > Y && (X = Y), I[d] = X;
    } else
      I[d] = 0;
    O0(d == o.npart_l - 1);
  }
  var h0 = [
    -865163e-23 * 2,
    -851586e-8 * 2,
    -674764e-23 * 2,
    0.0209036 * 2,
    -336639e-22 * 2,
    -0.0438162 * 2,
    -154175e-22 * 2,
    0.0931738 * 2,
    -552212e-22 * 2,
    -0.313819 * 2
  ];
  this.L3psycho_anal_ns = function(o, u, E, I, Y, d, k, $, X, e0) {
    var Z = o.internal_flags, a0 = c1([2, r0.BLKSIZE]), c0 = c1([2, 3, r0.BLKSIZE_s]), L0 = g0(r0.CBANDS + 1), _0 = g0(r0.CBANDS + 1), I0 = g0(r0.CBANDS + 2), J = I1(2), x0 = I1(2), k0, l0, B0, o0, C0, P0, b0, H0, X0 = c1([2, 576]), Z0, o1 = I1(r0.CBANDS + 2), W0 = I1(r0.CBANDS + 2);
    for (lr.fill(W0, 0), k0 = Z.channels_out, o.mode == m.JOINT_STEREO && (k0 = 4), o.VBR == O1.vbr_off ? Z0 = Z.ResvMax == 0 ? 0 : Z.ResvSize / Z.ResvMax * 0.5 : o.VBR == O1.vbr_rh || o.VBR == O1.vbr_mtrh || o.VBR == O1.vbr_mt ? Z0 = 0.6 : Z0 = 1, l0 = 0; l0 < Z.channels_out; l0++) {
      var K0 = u[l0], n1 = E + 576 - 350 - Q + 192;
      for (o0 = 0; o0 < 576; o0++) {
        var v1, u1;
        for (v1 = K0[n1 + o0 + 10], u1 = 0, C0 = 0; C0 < (Q - 1) / 2 - 1; C0 += 2)
          v1 += h0[C0] * (K0[n1 + o0 + C0] + K0[n1 + o0 + Q - C0]), u1 += h0[C0 + 1] * (K0[n1 + o0 + C0 + 1] + K0[n1 + o0 + Q - C0 - 1]);
        X0[l0][o0] = v1 + u1;
      }
      Y[I][l0].en.assign(Z.en[l0]), Y[I][l0].thm.assign(Z.thm[l0]), k0 > 2 && (d[I][l0].en.assign(Z.en[l0 + 2]), d[I][l0].thm.assign(Z.thm[l0 + 2]));
    }
    for (l0 = 0; l0 < k0; l0++) {
      var b1, d1, r1 = g0(12), R1 = [0, 0, 0, 0], H1 = g0(12), fe = 1, qe, De = g0(r0.CBANDS), Ge = g0(r0.CBANDS), U0 = [0, 0, 0, 0], $e = g0(r0.HBLKSIZE), Pe = c1([3, r0.HBLKSIZE_s]);
      for (O0(Z.npart_s <= r0.CBANDS), O0(Z.npart_l <= r0.CBANDS), o0 = 0; o0 < 3; o0++)
        r1[o0] = Z.nsPsy.last_en_subshort[l0][o0 + 6], O0(Z.nsPsy.last_en_subshort[l0][o0 + 4] > 0), H1[o0] = r1[o0] / Z.nsPsy.last_en_subshort[l0][o0 + 4], R1[0] += r1[o0];
      if (l0 == 2)
        for (o0 = 0; o0 < 576; o0++) {
          var ce, me;
          ce = X0[0][o0], me = X0[1][o0], X0[0][o0] = ce + me, X0[1][o0] = ce - me;
        }
      {
        var Ze = X0[l0 & 1], G1 = 0;
        for (o0 = 0; o0 < 9; o0++) {
          for (var Ua = G1 + 64, a1 = 1; G1 < Ua; G1++)
            a1 < Math.abs(Ze[G1]) && (a1 = Math.abs(Ze[G1]));
          Z.nsPsy.last_en_subshort[l0][o0] = r1[o0 + 3] = a1, R1[1 + o0 / 3] += a1, a1 > r1[o0 + 3 - 2] ? (O0(r1[o0 + 3 - 2] > 0), a1 = a1 / r1[o0 + 3 - 2]) : r1[o0 + 3 - 2] > a1 * 10 ? a1 = r1[o0 + 3 - 2] / (a1 * 10) : a1 = 0, H1[o0 + 3] = a1;
        }
      }
      if (o.analysis) {
        var be = H1[0];
        for (o0 = 1; o0 < 12; o0++)
          be < H1[o0] && (be = H1[o0]);
        Z.pinfo.ers[I][l0] = Z.pinfo.ers_save[l0], Z.pinfo.ers_save[l0] = be;
      }
      for (qe = l0 == 3 ? Z.nsPsy.attackthre_s : Z.nsPsy.attackthre, o0 = 0; o0 < 12; o0++)
        U0[o0 / 3] == 0 && H1[o0] > qe && (U0[o0 / 3] = o0 % 3 + 1);
      for (o0 = 1; o0 < 4; o0++) {
        var de;
        R1[o0 - 1] > R1[o0] ? (O0(R1[o0] > 0), de = R1[o0 - 1] / R1[o0]) : (O0(R1[o0 - 1] > 0), de = R1[o0] / R1[o0 - 1]), de < 1.7 && (U0[o0] = 0, o0 == 1 && (U0[0] = 0));
      }
      for (U0[0] != 0 && Z.nsPsy.lastAttacks[l0] != 0 && (U0[0] = 0), (Z.nsPsy.lastAttacks[l0] == 3 || U0[0] + U0[1] + U0[2] + U0[3] != 0) && (fe = 0, U0[1] != 0 && U0[0] != 0 && (U0[1] = 0), U0[2] != 0 && U0[1] != 0 && (U0[2] = 0), U0[3] != 0 && U0[2] != 0 && (U0[3] = 0)), l0 < 2 ? x0[l0] = fe : fe == 0 && (x0[0] = x0[1] = 0), X[l0] = Z.tot_ener[l0], d1 = c0, b1 = a0, v(
        o,
        $e,
        Pe,
        b1,
        l0 & 1,
        d1,
        l0 & 1,
        I,
        l0,
        u,
        E
      ), G(Z, $e, L0, De, Ge), s0(Z, De, Ge, o1), H0 = 0; H0 < 3; H0++) {
        var Se, s1;
        for (n(o, Pe, _0, I0, l0, H0), T(Z, _0, I0, l0, H0), b0 = 0; b0 < r0.SBMAX_s; b0++) {
          if (s1 = Z.thm[l0].s[b0][H0], s1 *= R, U0[H0] >= 2 || U0[H0 + 1] == 1) {
            var $1 = H0 != 0 ? H0 - 1 : 2, a1 = i(
              Z.thm[l0].s[b0][$1],
              s1,
              c * Z0
            );
            s1 = Math.min(s1, a1);
          }
          if (U0[H0] == 1) {
            var $1 = H0 != 0 ? H0 - 1 : 2, a1 = i(
              Z.thm[l0].s[b0][$1],
              s1,
              H * Z0
            );
            s1 = Math.min(s1, a1);
          } else if (H0 != 0 && U0[H0 - 1] == 3 || H0 == 0 && Z.nsPsy.lastAttacks[l0] == 3) {
            var $1 = H0 != 2 ? H0 + 1 : 0, a1 = i(
              Z.thm[l0].s[b0][$1],
              s1,
              H * Z0
            );
            s1 = Math.min(s1, a1);
          }
          Se = r1[H0 * 3 + 3] + r1[H0 * 3 + 4] + r1[H0 * 3 + 5], r1[H0 * 3 + 5] * 6 < Se && (s1 *= 0.5, r1[H0 * 3 + 4] * 6 < Se && (s1 *= 0.5)), Z.thm[l0].s[b0][H0] = s1;
        }
      }
      for (Z.nsPsy.lastAttacks[l0] = U0[2], P0 = 0, B0 = 0; B0 < Z.npart_l; B0++) {
        for (var w1 = Z.s3ind[B0][0], Ae = L0[w1] * O[o1[w1]], p1 = Z.s3_ll[P0++] * Ae; ++w1 <= Z.s3ind[B0][1]; )
          Ae = L0[w1] * O[o1[w1]], p1 = a(
            p1,
            Z.s3_ll[P0++] * Ae,
            w1,
            w1 - B0,
            Z,
            0
          );
        p1 *= 0.158489319246111, Z.blocktype_old[l0 & 1] == r0.SHORT_TYPE ? I0[B0] = p1 : I0[B0] = i(
          Math.min(p1, Math.min(K * Z.nb_1[l0][B0], i0 * Z.nb_2[l0][B0])),
          p1,
          Z0
        ), Z.nb_2[l0][B0] = Z.nb_1[l0][B0], Z.nb_1[l0][B0] = p1;
      }
      for (; B0 <= r0.CBANDS; ++B0)
        L0[B0] = 0, I0[B0] = 0;
      s(Z, L0, I0, l0);
    }
    if ((o.mode == m.STEREO || o.mode == m.JOINT_STEREO) && o.interChRatio > 0 && F(o, o.interChRatio), o.mode == m.JOINT_STEREO) {
      var Re;
      N(Z), Re = o.msfix, Math.abs(Re) > 0 && U(Z, Re, o.ATHlower * Z.ATH.adjust);
    }
    for (r(o, x0, e0, J), l0 = 0; l0 < k0; l0++) {
      var P1, Z1 = 0, W1, J1;
      l0 > 1 ? (P1 = $, Z1 = -2, W1 = r0.NORM_TYPE, (e0[0] == r0.SHORT_TYPE || e0[1] == r0.SHORT_TYPE) && (W1 = r0.SHORT_TYPE), J1 = d[I][l0 - 2]) : (P1 = k, Z1 = 0, W1 = e0[l0], J1 = Y[I][l0]), W1 == r0.SHORT_TYPE ? P1[Z1 + l0] = q(J1, Z.masking_lower) : P1[Z1 + l0] = p(J1, Z.masking_lower), o.analysis && (Z.pinfo.pe[I][l0] = P1[Z1 + l0]);
    }
    return 0;
  };
  function S0(o, u, E, I, Y, d, k, $) {
    var X = o.internal_flags;
    if (I < 2)
      x.fft_long(X, k[$], I, u, E);
    else if (I == 2)
      for (var e0 = r0.BLKSIZE - 1; e0 >= 0; --e0) {
        var Z = k[$ + 0][e0], a0 = k[$ + 1][e0];
        k[$ + 0][e0] = (Z + a0) * i1.SQRT2 * 0.5, k[$ + 1][e0] = (Z - a0) * i1.SQRT2 * 0.5;
      }
    d[0] = k[$ + 0][0], d[0] *= d[0];
    for (var e0 = r0.BLKSIZE / 2 - 1; e0 >= 0; --e0) {
      var c0 = k[$ + 0][r0.BLKSIZE / 2 - e0], L0 = k[$ + 0][r0.BLKSIZE / 2 + e0];
      d[r0.BLKSIZE / 2 - e0] = (c0 * c0 + L0 * L0) * 0.5;
    }
    {
      for (var _0 = 0, e0 = 11; e0 < r0.HBLKSIZE; e0++)
        _0 += d[e0];
      X.tot_ener[I] = _0;
    }
    if (o.analysis) {
      for (var e0 = 0; e0 < r0.HBLKSIZE; e0++)
        X.pinfo.energy[Y][I][e0] = X.pinfo.energy_save[I][e0], X.pinfo.energy_save[I][e0] = d[e0];
      X.pinfo.pe[Y][I] = X.pe[I];
    }
  }
  function M0(o, u, E, I, Y, d, k, $) {
    var X = o.internal_flags;
    if (Y == 0 && I < 2 && x.fft_short(X, k[$], I, u, E), I == 2)
      for (var e0 = r0.BLKSIZE_s - 1; e0 >= 0; --e0) {
        var Z = k[$ + 0][Y][e0], a0 = k[$ + 1][Y][e0];
        k[$ + 0][Y][e0] = (Z + a0) * i1.SQRT2 * 0.5, k[$ + 1][Y][e0] = (Z - a0) * i1.SQRT2 * 0.5;
      }
    d[Y][0] = k[$ + 0][Y][0], d[Y][0] *= d[Y][0];
    for (var e0 = r0.BLKSIZE_s / 2 - 1; e0 >= 0; --e0) {
      var c0 = k[$ + 0][Y][r0.BLKSIZE_s / 2 - e0], L0 = k[$ + 0][Y][r0.BLKSIZE_s / 2 + e0];
      d[Y][r0.BLKSIZE_s / 2 - e0] = (c0 * c0 + L0 * L0) * 0.5;
    }
  }
  function R0(o, u, E, I) {
    var Y = o.internal_flags;
    o.athaa_loudapprox == 2 && E < 2 && (Y.loudness_sq[u][E] = Y.loudness_sq_save[E], Y.loudness_sq_save[E] = M(I, Y));
  }
  var A0 = [
    -865163e-23 * 2,
    -851586e-8 * 2,
    -674764e-23 * 2,
    0.0209036 * 2,
    -336639e-22 * 2,
    -0.0438162 * 2,
    -154175e-22 * 2,
    0.0931738 * 2,
    -552212e-22 * 2,
    -0.313819 * 2
  ];
  function w0(o, u, E, I, Y, d, k, $, X, e0) {
    for (var Z = c1([2, 576]), a0 = o.internal_flags, c0 = a0.channels_out, L0 = o.mode == m.JOINT_STEREO ? 4 : c0, _0 = 0; _0 < c0; _0++) {
      firbuf = u[_0];
      for (var I0 = E + 576 - 350 - Q + 192, J = 0; J < 576; J++) {
        var x0, k0;
        x0 = firbuf[I0 + J + 10], k0 = 0;
        for (var l0 = 0; l0 < (Q - 1) / 2 - 1; l0 += 2)
          x0 += A0[l0] * (firbuf[I0 + J + l0] + firbuf[I0 + J + Q - l0]), k0 += A0[l0 + 1] * (firbuf[I0 + J + l0 + 1] + firbuf[I0 + J + Q - l0 - 1]);
        Z[_0][J] = x0 + k0;
      }
      Y[I][_0].en.assign(a0.en[_0]), Y[I][_0].thm.assign(a0.thm[_0]), L0 > 2 && (d[I][_0].en.assign(a0.en[_0 + 2]), d[I][_0].thm.assign(a0.thm[_0 + 2]));
    }
    for (var _0 = 0; _0 < L0; _0++) {
      var B0 = g0(12), o0 = g0(12), C0 = [0, 0, 0, 0], P0 = Z[_0 & 1], b0 = 0, H0 = _0 == 3 ? a0.nsPsy.attackthre_s : a0.nsPsy.attackthre, X0 = 1;
      if (_0 == 2)
        for (var J = 0, l0 = 576; l0 > 0; ++J, --l0) {
          var Z0 = Z[0][J], o1 = Z[1][J];
          Z[0][J] = Z0 + o1, Z[1][J] = Z0 - o1;
        }
      for (var J = 0; J < 3; J++)
        o0[J] = a0.nsPsy.last_en_subshort[_0][J + 6], O0(a0.nsPsy.last_en_subshort[_0][J + 4] > 0), B0[J] = o0[J] / a0.nsPsy.last_en_subshort[_0][J + 4], C0[0] += o0[J];
      for (var J = 0; J < 9; J++) {
        for (var W0 = b0 + 64, K0 = 1; b0 < W0; b0++)
          K0 < Math.abs(P0[b0]) && (K0 = Math.abs(P0[b0]));
        a0.nsPsy.last_en_subshort[_0][J] = o0[J + 3] = K0, C0[1 + J / 3] += K0, K0 > o0[J + 3 - 2] ? (O0(o0[J + 3 - 2] > 0), K0 = K0 / o0[J + 3 - 2]) : o0[J + 3 - 2] > K0 * 10 ? K0 = o0[J + 3 - 2] / (K0 * 10) : K0 = 0, B0[J + 3] = K0;
      }
      for (var J = 0; J < 3; ++J) {
        var n1 = o0[J * 3 + 3] + o0[J * 3 + 4] + o0[J * 3 + 5], v1 = 1;
        o0[J * 3 + 5] * 6 < n1 && (v1 *= 0.5, o0[J * 3 + 4] * 6 < n1 && (v1 *= 0.5)), $[_0][J] = v1;
      }
      if (o.analysis) {
        for (var u1 = B0[0], J = 1; J < 12; J++)
          u1 < B0[J] && (u1 = B0[J]);
        a0.pinfo.ers[I][_0] = a0.pinfo.ers_save[_0], a0.pinfo.ers_save[_0] = u1;
      }
      for (var J = 0; J < 12; J++)
        X[_0][J / 3] == 0 && B0[J] > H0 && (X[_0][J / 3] = J % 3 + 1);
      for (var J = 1; J < 4; J++) {
        var b1 = C0[J - 1], d1 = C0[J], r1 = Math.max(b1, d1);
        r1 < 4e4 && b1 < 1.7 * d1 && d1 < 1.7 * b1 && (J == 1 && X[_0][0] <= X[_0][J] && (X[_0][0] = 0), X[_0][J] = 0);
      }
      X[_0][0] <= a0.nsPsy.lastAttacks[_0] && (X[_0][0] = 0), (a0.nsPsy.lastAttacks[_0] == 3 || X[_0][0] + X[_0][1] + X[_0][2] + X[_0][3] != 0) && (X0 = 0, X[_0][1] != 0 && X[_0][0] != 0 && (X[_0][1] = 0), X[_0][2] != 0 && X[_0][1] != 0 && (X[_0][2] = 0), X[_0][3] != 0 && X[_0][2] != 0 && (X[_0][3] = 0)), _0 < 2 ? e0[_0] = X0 : X0 == 0 && (e0[0] = e0[1] = 0), k[_0] = a0.tot_ener[_0];
    }
  }
  function $0(o, u, E) {
    if (E == 0)
      for (var I = 0; I < o.npart_s; I++)
        o.nb_s2[u][I] = o.nb_s1[u][I], o.nb_s1[u][I] = 0;
  }
  function f1(o, u) {
    for (var E = 0; E < o.npart_l; E++)
      o.nb_2[u][E] = o.nb_1[u][E], o.nb_1[u][E] = 0;
  }
  function t(o, u, E, I) {
    var Y = O.length - 1, d = 0, k = E[d] + E[d + 1];
    if (k > 0) {
      var $ = u[d];
      $ < u[d + 1] && ($ = u[d + 1]), O0(o.numlines_s[d] + o.numlines_s[d + 1] - 1 > 0), k = 20 * ($ * 2 - k) / (k * (o.numlines_s[d] + o.numlines_s[d + 1] - 1));
      var X = 0 | k;
      X > Y && (X = Y), I[d] = X;
    } else
      I[d] = 0;
    for (d = 1; d < o.npart_s - 1; d++)
      if (k = E[d - 1] + E[d] + E[d + 1], O0(d + 1 < o.npart_s), k > 0) {
        var $ = u[d - 1];
        $ < u[d] && ($ = u[d]), $ < u[d + 1] && ($ = u[d + 1]), O0(o.numlines_s[d - 1] + o.numlines_s[d] + o.numlines_s[d + 1] - 1 > 0), k = 20 * ($ * 3 - k) / (k * (o.numlines_s[d - 1] + o.numlines_s[d] + o.numlines_s[d + 1] - 1));
        var X = 0 | k;
        X > Y && (X = Y), I[d] = X;
      } else
        I[d] = 0;
    if (O0(d == o.npart_s - 1), k = E[d - 1] + E[d], k > 0) {
      var $ = u[d - 1];
      $ < u[d] && ($ = u[d]), O0(o.numlines_s[d - 1] + o.numlines_s[d] - 1 > 0), k = 20 * ($ * 2 - k) / (k * (o.numlines_s[d - 1] + o.numlines_s[d] - 1));
      var X = 0 | k;
      X > Y && (X = Y), I[d] = X;
    } else
      I[d] = 0;
    O0(d == o.npart_s - 1);
  }
  function _(o, u, E, I, Y, d) {
    var k = o.internal_flags, $ = new float[r0.CBANDS](), X = g0(r0.CBANDS), e0, Z, a0, c0 = new int[r0.CBANDS]();
    for (a0 = Z = 0; a0 < k.npart_s; ++a0) {
      var L0 = 0, _0 = 0, I0 = k.numlines_s[a0];
      for (e0 = 0; e0 < I0; ++e0, ++Z) {
        var J = u[d][Z];
        L0 += J, _0 < J && (_0 = J);
      }
      E[a0] = L0, $[a0] = _0, X[a0] = L0 / I0, O0(X[a0] >= 0);
    }
    for (O0(a0 == k.npart_s); a0 < r0.CBANDS; ++a0)
      $[a0] = 0, X[a0] = 0;
    for (t(k, $, X, c0), Z = a0 = 0; a0 < k.npart_s; a0++) {
      var x0 = k.s3ind_s[a0][0], k0 = k.s3ind_s[a0][1], l0, B0, o0, C0, P0;
      for (l0 = c0[x0], B0 = 1, C0 = k.s3_ss[Z] * E[x0] * O[c0[x0]], ++Z, ++x0; x0 <= k0; )
        l0 += c0[x0], B0 += 1, o0 = k.s3_ss[Z] * E[x0] * O[c0[x0]], C0 = C(C0, o0, x0 - a0), ++Z, ++x0;
      l0 = (1 + 2 * l0) / (2 * B0), P0 = O[l0] * 0.5, C0 *= P0, I[a0] = C0, k.nb_s2[Y][a0] = k.nb_s1[Y][a0], k.nb_s1[Y][a0] = C0, o0 = $[a0], o0 *= k.minval_s[a0], o0 *= P0, I[a0] > o0 && (I[a0] = o0), k.masking_lower > 1 && (I[a0] *= k.masking_lower), I[a0] > E[a0] && (I[a0] = E[a0]), k.masking_lower < 1 && (I[a0] *= k.masking_lower), O0(I[a0] >= 0);
    }
    for (; a0 < r0.CBANDS; ++a0)
      E[a0] = 0, I[a0] = 0;
  }
  function d0(o, u, E, I, Y) {
    var d = g0(r0.CBANDS), k = g0(r0.CBANDS), $ = I1(r0.CBANDS + 2), X;
    G(o, u, E, d, k), s0(o, d, k, $);
    var e0 = 0;
    for (X = 0; X < o.npart_l; X++) {
      var Z, a0, c0, L0, _0 = o.s3ind[X][0], I0 = o.s3ind[X][1], J = 0, x0 = 0;
      for (J = $[_0], x0 += 1, a0 = o.s3_ll[e0] * E[_0] * O[$[_0]], ++e0, ++_0; _0 <= I0; )
        J += $[_0], x0 += 1, Z = o.s3_ll[e0] * E[_0] * O[$[_0]], L0 = C(a0, Z, _0 - X), a0 = L0, ++e0, ++_0;
      if (J = (1 + 2 * J) / (2 * x0), c0 = O[J] * 0.5, a0 *= c0, o.blocktype_old[Y & 1] == r0.SHORT_TYPE) {
        var k0 = K * o.nb_1[Y][X];
        k0 > 0 ? I[X] = Math.min(a0, k0) : I[X] = Math.min(a0, E[X] * H);
      } else {
        var l0 = i0 * o.nb_2[Y][X], B0 = K * o.nb_1[Y][X], k0;
        l0 <= 0 && (l0 = a0), B0 <= 0 && (B0 = a0), o.blocktype_old[Y & 1] == r0.NORM_TYPE ? k0 = Math.min(B0, l0) : k0 = B0, I[X] = Math.min(a0, k0);
      }
      o.nb_2[Y][X] = o.nb_1[Y][X], o.nb_1[Y][X] = a0, Z = d[X], Z *= o.minval_l[X], Z *= c0, I[X] > Z && (I[X] = Z), o.masking_lower > 1 && (I[X] *= o.masking_lower), I[X] > E[X] && (I[X] = E[X]), o.masking_lower < 1 && (I[X] *= o.masking_lower), O0(I[X] >= 0);
    }
    for (; X < r0.CBANDS; ++X)
      E[X] = 0, I[X] = 0;
  }
  function E0(o, u) {
    var E = o.internal_flags;
    o.short_blocks == F1.short_block_coupled && !(u[0] != 0 && u[1] != 0) && (u[0] = u[1] = 0);
    for (var I = 0; I < E.channels_out; I++)
      o.short_blocks == F1.short_block_dispensed && (u[I] = 1), o.short_blocks == F1.short_block_forced && (u[I] = 0);
  }
  function V0(o, u, E) {
    for (var I = o.internal_flags, Y = 0; Y < I.channels_out; Y++) {
      var d = r0.NORM_TYPE;
      u[Y] != 0 ? (O0(I.blocktype_old[Y] != r0.START_TYPE), I.blocktype_old[Y] == r0.SHORT_TYPE && (d = r0.STOP_TYPE)) : (d = r0.SHORT_TYPE, I.blocktype_old[Y] == r0.NORM_TYPE && (I.blocktype_old[Y] = r0.START_TYPE), I.blocktype_old[Y] == r0.STOP_TYPE && (I.blocktype_old[Y] = r0.SHORT_TYPE)), E[Y] = I.blocktype_old[Y], I.blocktype_old[Y] = d;
    }
  }
  function N0(o, u, E, I, Y, d, k) {
    for (var $ = d * 2, X = d > 0 ? Math.pow(10, Y) : 1, e0, Z, a0 = 0; a0 < k; ++a0) {
      var c0 = o[2][a0], L0 = o[3][a0], _0 = u[0][a0], I0 = u[1][a0], J = u[2][a0], x0 = u[3][a0];
      if (_0 <= 1.58 * I0 && I0 <= 1.58 * _0) {
        var k0 = E[a0] * L0, l0 = E[a0] * c0;
        Z = Math.max(J, Math.min(x0, k0)), e0 = Math.max(x0, Math.min(J, l0));
      } else
        Z = J, e0 = x0;
      if (d > 0) {
        var B0, o0, C0 = I[a0] * X;
        if (B0 = Math.min(Math.max(_0, C0), Math.max(I0, C0)), J = Math.max(Z, C0), x0 = Math.max(e0, C0), o0 = J + x0, o0 > 0 && B0 * $ < o0) {
          var P0 = B0 * $ / o0;
          J *= P0, x0 *= P0;
        }
        Z = Math.min(J, Z), e0 = Math.min(x0, e0);
      }
      Z > c0 && (Z = c0), e0 > L0 && (e0 = L0), u[2][a0] = Z, u[3][a0] = e0;
    }
  }
  this.L3psycho_anal_vbr = function(o, u, E, I, Y, d, k, $, X, e0) {
    var Z = o.internal_flags, a0, c0, L0 = g0(r0.HBLKSIZE), _0 = c1([3, r0.HBLKSIZE_s]), I0 = c1([2, r0.BLKSIZE]), J = c1([2, 3, r0.BLKSIZE_s]), x0 = c1([4, r0.CBANDS]), k0 = c1([4, r0.CBANDS]), l0 = c1([4, 3]), B0 = 0.6, o0 = [
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0]
    ], C0 = I1(2), P0 = o.mode == m.JOINT_STEREO ? 4 : Z.channels_out;
    w0(
      o,
      u,
      E,
      I,
      Y,
      d,
      X,
      l0,
      o0,
      C0
    ), E0(o, C0);
    {
      for (var b0 = 0; b0 < P0; b0++) {
        var H0 = b0 & 1;
        a0 = I0, S0(
          o,
          u,
          E,
          b0,
          I,
          L0,
          a0,
          H0
        ), R0(
          o,
          I,
          b0,
          L0
        ), C0[H0] != 0 ? d0(
          Z,
          L0,
          x0[b0],
          k0[b0],
          b0
        ) : f1(Z, b0);
      }
      C0[0] + C0[1] == 2 && o.mode == m.JOINT_STEREO && N0(
        x0,
        k0,
        Z.mld_cb_l,
        Z.ATH.cb_l,
        o.ATHlower * Z.ATH.adjust,
        o.msfix,
        Z.npart_l
      );
      for (var b0 = 0; b0 < P0; b0++) {
        var H0 = b0 & 1;
        C0[H0] != 0 && s(Z, x0[b0], k0[b0], b0);
      }
    }
    {
      for (var X0 = 0; X0 < 3; X0++) {
        for (var b0 = 0; b0 < P0; ++b0) {
          var H0 = b0 & 1;
          C0[H0] != 0 ? $0(Z, b0, X0) : (c0 = J, M0(
            o,
            u,
            E,
            b0,
            X0,
            _0,
            c0,
            H0
          ), _(
            o,
            _0,
            x0[b0],
            k0[b0],
            b0,
            X0
          ));
        }
        C0[0] + C0[1] == 0 && o.mode == m.JOINT_STEREO && N0(
          x0,
          k0,
          Z.mld_cb_s,
          Z.ATH.cb_s,
          o.ATHlower * Z.ATH.adjust,
          o.msfix,
          Z.npart_s
        );
        for (var b0 = 0; b0 < P0; ++b0) {
          var H0 = b0 & 1;
          C0[H0] == 0 && T(
            Z,
            x0[b0],
            k0[b0],
            b0,
            X0
          );
        }
      }
      for (var b0 = 0; b0 < P0; b0++) {
        var H0 = b0 & 1;
        if (C0[H0] == 0)
          for (var Z0 = 0; Z0 < r0.SBMAX_s; Z0++) {
            for (var o1 = g0(3), X0 = 0; X0 < 3; X0++) {
              var W0 = Z.thm[b0].s[Z0][X0];
              if (W0 *= R, o0[b0][X0] >= 2 || o0[b0][X0 + 1] == 1) {
                var K0 = X0 != 0 ? X0 - 1 : 2, n1 = i(
                  Z.thm[b0].s[Z0][K0],
                  W0,
                  c * B0
                );
                W0 = Math.min(W0, n1);
              } else if (o0[b0][X0] == 1) {
                var K0 = X0 != 0 ? X0 - 1 : 2, n1 = i(
                  Z.thm[b0].s[Z0][K0],
                  W0,
                  H * B0
                );
                W0 = Math.min(W0, n1);
              } else if (X0 != 0 && o0[b0][X0 - 1] == 3 || X0 == 0 && Z.nsPsy.lastAttacks[b0] == 3) {
                var K0 = X0 != 2 ? X0 + 1 : 0, n1 = i(
                  Z.thm[b0].s[Z0][K0],
                  W0,
                  H * B0
                );
                W0 = Math.min(W0, n1);
              }
              W0 *= l0[b0][X0], o1[X0] = W0;
            }
            for (var X0 = 0; X0 < 3; X0++)
              Z.thm[b0].s[Z0][X0] = o1[X0];
          }
      }
    }
    for (var b0 = 0; b0 < P0; b0++)
      Z.nsPsy.lastAttacks[b0] = o0[b0][2];
    V0(o, C0, e0);
    for (var b0 = 0; b0 < P0; b0++) {
      var v1, u1, b1, d1;
      b0 > 1 ? (v1 = $, u1 = -2, b1 = r0.NORM_TYPE, (e0[0] == r0.SHORT_TYPE || e0[1] == r0.SHORT_TYPE) && (b1 = r0.SHORT_TYPE), d1 = d[I][b0 - 2]) : (v1 = k, u1 = 0, b1 = e0[b0], d1 = Y[I][b0]), b1 == r0.SHORT_TYPE ? v1[u1 + b0] = q(d1, Z.masking_lower) : v1[u1 + b0] = p(d1, Z.masking_lower), o.analysis && (Z.pinfo.pe[I][b0] = v1[u1 + b0]);
    }
    return 0;
  };
  function y0(o, u) {
    var E = o, I;
    return E >= 0 ? I = -E * 27 : I = E * u, I <= -72 ? 0 : Math.exp(I * t0);
  }
  function T0(o) {
    var u = 0, E = 0;
    {
      var I = 0, Y, d;
      for (I = 0; y0(I, o) > 1e-20; I -= 1)
        ;
      for (Y = I, d = 0; Math.abs(d - Y) > 1e-12; )
        I = (d + Y) / 2, y0(I, o) > 0 ? d = I : Y = I;
      u = Y;
    }
    {
      var I = 0, Y, d;
      for (I = 0; y0(I, o) > 1e-20; I += 1)
        ;
      for (Y = 0, d = I; Math.abs(d - Y) > 1e-12; )
        I = (d + Y) / 2, y0(I, o) > 0 ? Y = I : d = I;
      E = d;
    }
    {
      var k = 0, $ = 1e3, X;
      for (X = 0; X <= $; ++X) {
        var I = u + X * (E - u) / $, e0 = y0(I, o);
        k += e0;
      }
      {
        var Z = ($ + 1) / (k * (E - u));
        return Z;
      }
    }
  }
  function F0(o) {
    var u, E, I, Y;
    return u = o, u >= 0 ? u *= 3 : u *= 1.5, u >= 0.5 && u <= 2.5 ? (Y = u - 0.5, E = 8 * (Y * Y - 2 * Y)) : E = 0, u += 0.474, I = 15.811389 + 7.5 * u - 17.5 * Math.sqrt(1 + u * u), I <= -60 ? 0 : (u = Math.exp((E + I) * t0), u /= 0.6609193, u);
  }
  function p0(o) {
    return o < 0 && (o = 0), o = o * 1e-3, 13 * Math.atan(0.76 * o) + 3.5 * Math.atan(o * o / (7.5 * 7.5));
  }
  function m0(o, u, E, I, Y, d, k, $, X, e0, Z, a0) {
    var c0 = g0(r0.CBANDS + 1), L0 = $ / (a0 > 15 ? 2 * 576 : 2 * 192), _0 = I1(r0.HBLKSIZE), I0;
    $ /= X;
    var J = 0, x0 = 0;
    for (I0 = 0; I0 < r0.CBANDS; I0++) {
      var k0, l0;
      for (k0 = p0($ * J), c0[I0] = $ * J, l0 = J; p0($ * l0) - k0 < D && l0 <= X / 2; l0++)
        ;
      for (o[I0] = l0 - J, x0 = I0 + 1; J < l0; )
        O0(J < r0.HBLKSIZE), _0[J++] = I0;
      if (J > X / 2) {
        J = X / 2, ++I0;
        break;
      }
    }
    O0(I0 < r0.CBANDS), c0[I0] = $ * J;
    for (var B0 = 0; B0 < a0; B0++) {
      var o0, C0, P0, b0, H0;
      P0 = e0[B0], b0 = e0[B0 + 1], o0 = 0 | Math.floor(0.5 + Z * (P0 - 0.5)), o0 < 0 && (o0 = 0), C0 = 0 | Math.floor(0.5 + Z * (b0 - 0.5)), C0 > X / 2 && (C0 = X / 2), E[B0] = (_0[o0] + _0[C0]) / 2, u[B0] = _0[C0];
      var X0 = L0 * b0;
      k[B0] = (X0 - c0[u[B0]]) / (c0[u[B0] + 1] - c0[u[B0]]), k[B0] < 0 ? k[B0] = 0 : k[B0] > 1 && (k[B0] = 1), H0 = p0($ * e0[B0] * Z), H0 = Math.min(H0, 15.5) / 15.5, d[B0] = Math.pow(
        10,
        1.25 * (1 - Math.cos(Math.PI * H0)) - 2.5
      );
    }
    J = 0;
    for (var Z0 = 0; Z0 < x0; Z0++) {
      var o1 = o[Z0], k0, W0;
      k0 = p0($ * J), W0 = p0($ * (J + o1 - 1)), I[Z0] = 0.5 * (k0 + W0), k0 = p0($ * (J - 0.5)), W0 = p0($ * (J + o1 - 0.5)), Y[Z0] = W0 - k0, J += o1;
    }
    return x0;
  }
  function G0(o, u, E, I, Y, d) {
    var k = c1([r0.CBANDS, r0.CBANDS]), $, X = 0;
    if (d)
      for (var e0 = 0; e0 < u; e0++)
        for ($ = 0; $ < u; $++) {
          var Z = F0(E[e0] - E[$]) * I[$];
          k[e0][$] = Z * Y[e0];
        }
    else
      for ($ = 0; $ < u; $++)
        for (var a0 = 15 + Math.min(21 / E[$], 12), c0 = T0(a0), e0 = 0; e0 < u; e0++) {
          var Z = c0 * y0(E[e0] - E[$], a0) * I[$];
          k[e0][$] = Z * Y[e0];
        }
    for (var e0 = 0; e0 < u; e0++) {
      for ($ = 0; $ < u && !(k[e0][$] > 0); $++)
        ;
      for (o[e0][0] = $, $ = u - 1; $ > 0 && !(k[e0][$] > 0); $--)
        ;
      o[e0][1] = $, X += o[e0][1] - o[e0][0] + 1;
    }
    for (var L0 = g0(X), _0 = 0, e0 = 0; e0 < u; e0++)
      for ($ = o[e0][0]; $ <= o[e0][1]; $++)
        L0[_0++] = k[e0][$];
    return L0;
  }
  function e1(o) {
    var u = p0(o);
    return u = Math.min(u, 15.5) / 15.5, Math.pow(
      10,
      1.25 * (1 - Math.cos(Math.PI * u)) - 2.5
    );
  }
  this.psymodel_init = function(o) {
    var u = o.internal_flags, E, I = !0, Y = 13, d = 24, k = 0, $ = 0, X = -8.25, e0 = -4.5, Z = g0(r0.CBANDS), a0 = g0(r0.CBANDS), c0 = g0(r0.CBANDS), L0 = o.out_samplerate;
    switch (o.experimentalZ) {
      default:
      case 0:
        I = !0;
        break;
      case 1:
        I = !(o.VBR == O1.vbr_mtrh || o.VBR == O1.vbr_mt);
        break;
      case 2:
        I = !1;
        break;
      case 3:
        Y = 8, k = -1.75, $ = -0.0125, X = -8.25, e0 = -2.25;
        break;
    }
    for (u.ms_ener_ratio_old = 0.25, u.blocktype_old[0] = u.blocktype_old[1] = r0.NORM_TYPE, E = 0; E < 4; ++E) {
      for (var J = 0; J < r0.CBANDS; ++J)
        u.nb_1[E][J] = 1e20, u.nb_2[E][J] = 1e20, u.nb_s1[E][J] = u.nb_s2[E][J] = 1;
      for (var _0 = 0; _0 < r0.SBMAX_l; _0++)
        u.en[E].l[_0] = 1e20, u.thm[E].l[_0] = 1e20;
      for (var J = 0; J < 3; ++J) {
        for (var _0 = 0; _0 < r0.SBMAX_s; _0++)
          u.en[E].s[_0][J] = 1e20, u.thm[E].s[_0][J] = 1e20;
        u.nsPsy.lastAttacks[E] = 0;
      }
      for (var J = 0; J < 9; J++)
        u.nsPsy.last_en_subshort[E][J] = 10;
    }
    for (u.loudness_sq_save[0] = u.loudness_sq_save[1] = 0, u.npart_l = m0(
      u.numlines_l,
      u.bo_l,
      u.bm_l,
      Z,
      a0,
      u.mld_l,
      u.PSY.bo_l_weight,
      L0,
      r0.BLKSIZE,
      u.scalefac_band.l,
      r0.BLKSIZE / (2 * 576),
      r0.SBMAX_l
    ), O0(u.npart_l < r0.CBANDS), E = 0; E < u.npart_l; E++) {
      var I0 = k;
      Z[E] >= Y && (I0 = $ * (Z[E] - Y) / (d - Y) + k * (d - Z[E]) / (d - Y)), c0[E] = Math.pow(10, I0 / 10), u.numlines_l[E] > 0 ? u.rnumlines_l[E] = 1 / u.numlines_l[E] : u.rnumlines_l[E] = 0;
    }
    u.s3_ll = G0(
      u.s3ind,
      u.npart_l,
      Z,
      a0,
      c0,
      I
    );
    var J = 0;
    for (E = 0; E < u.npart_l; E++) {
      var x0;
      x0 = Je.MAX_VALUE;
      for (var k0 = 0; k0 < u.numlines_l[E]; k0++, J++) {
        var l0 = L0 * J / (1e3 * r0.BLKSIZE), B0;
        B0 = this.ATHformula(l0 * 1e3, o) - 20, B0 = Math.pow(10, 0.1 * B0), B0 *= u.numlines_l[E], x0 > B0 && (x0 = B0);
      }
      u.ATH.cb_l[E] = x0, x0 = -20 + Z[E] * 20 / 10, x0 > 6 && (x0 = 100), x0 < -15 && (x0 = -15), x0 -= 8, u.minval_l[E] = Math.pow(10, x0 / 10) * u.numlines_l[E];
    }
    for (u.npart_s = m0(
      u.numlines_s,
      u.bo_s,
      u.bm_s,
      Z,
      a0,
      u.mld_s,
      u.PSY.bo_s_weight,
      L0,
      r0.BLKSIZE_s,
      u.scalefac_band.s,
      r0.BLKSIZE_s / (2 * 192),
      r0.SBMAX_s
    ), O0(u.npart_s < r0.CBANDS), J = 0, E = 0; E < u.npart_s; E++) {
      var x0, I0 = X;
      Z[E] >= Y && (I0 = e0 * (Z[E] - Y) / (d - Y) + X * (d - Z[E]) / (d - Y)), c0[E] = Math.pow(10, I0 / 10), x0 = Je.MAX_VALUE;
      for (var k0 = 0; k0 < u.numlines_s[E]; k0++, J++) {
        var l0 = L0 * J / (1e3 * r0.BLKSIZE_s), B0;
        B0 = this.ATHformula(l0 * 1e3, o) - 20, B0 = Math.pow(10, 0.1 * B0), B0 *= u.numlines_s[E], x0 > B0 && (x0 = B0);
      }
      u.ATH.cb_s[E] = x0, x0 = -7 + Z[E] * 7 / 12, Z[E] > 12 && (x0 *= 1 + Math.log(1 + x0) * 3.1), Z[E] < 12 && (x0 *= 1 + Math.log(1 - x0) * 2.3), x0 < -15 && (x0 = -15), x0 -= 8, u.minval_s[E] = Math.pow(10, x0 / 10) * u.numlines_s[E];
    }
    u.s3_ss = G0(
      u.s3ind_s,
      u.npart_s,
      Z,
      a0,
      c0,
      I
    ), w(), x.init_fft(u), u.decay = Math.exp(-1 * y / (f0 * L0 / 192));
    {
      var o0;
      o0 = n0, o.exp_nspsytune & 2 && (o0 = 1), Math.abs(o.msfix) > 0 && (o0 = o.msfix), o.msfix = o0;
      for (var C0 = 0; C0 < u.npart_l; C0++)
        u.s3ind[C0][1] > u.npart_l - 1 && (u.s3ind[C0][1] = u.npart_l - 1);
    }
    var P0 = 576 * u.mode_gr / L0;
    if (u.ATH.decay = Math.pow(10, -12 / 10 * P0), u.ATH.adjust = 0.01, u.ATH.adjustLimit = 1, O0(u.bo_l[r0.SBMAX_l - 1] <= u.npart_l), O0(u.bo_s[r0.SBMAX_s - 1] <= u.npart_s), o.ATHtype != -1) {
      var l0, b0 = o.out_samplerate / r0.BLKSIZE, H0 = 0;
      for (l0 = 0, E = 0; E < r0.BLKSIZE / 2; ++E)
        l0 += b0, u.ATH.eql_w[E] = 1 / Math.pow(10, this.ATHformula(l0, o) / 10), H0 += u.ATH.eql_w[E];
      for (H0 = 1 / H0, E = r0.BLKSIZE / 2; --E >= 0; )
        u.ATH.eql_w[E] *= H0;
    }
    {
      for (var C0 = J = 0; C0 < u.npart_s; ++C0)
        for (E = 0; E < u.numlines_s[C0]; ++E)
          ++J;
      for (var C0 = J = 0; C0 < u.npart_l; ++C0)
        for (E = 0; E < u.numlines_l[C0]; ++E)
          ++J;
    }
    for (J = 0, E = 0; E < u.npart_l; E++) {
      var l0 = L0 * (J + u.numlines_l[E] / 2) / (1 * r0.BLKSIZE);
      u.mld_cb_l[E] = e1(l0), J += u.numlines_l[E];
    }
    for (; E < r0.CBANDS; ++E)
      u.mld_cb_l[E] = 1;
    for (J = 0, E = 0; E < u.npart_s; E++) {
      var l0 = L0 * (J + u.numlines_s[E] / 2) / (1 * r0.BLKSIZE_s);
      u.mld_cb_s[E] = e1(l0), J += u.numlines_s[E];
    }
    for (; E < r0.CBANDS; ++E)
      u.mld_cb_s[E] = 1;
    return 0;
  };
  function Y0(o, u) {
    o < -0.3 && (o = 3410), o /= 1e3, o = Math.max(0.1, o);
    var E = 3.64 * Math.pow(o, -0.8) - 6.8 * Math.exp(-0.6 * Math.pow(o - 3.4, 2)) + 6 * Math.exp(-0.15 * Math.pow(o - 8.7, 2)) + (0.6 + 0.04 * u) * 1e-3 * Math.pow(o, 4);
    return E;
  }
  this.ATHformula = function(o, u) {
    var E;
    switch (u.ATHtype) {
      case 0:
        E = Y0(o, 9);
        break;
      case 1:
        E = Y0(o, -1);
        break;
      case 2:
        E = Y0(o, 0);
        break;
      case 3:
        E = Y0(o, 1) + 6;
        break;
      case 4:
        E = Y0(o, u.ATHcurve);
        break;
      default:
        E = Y0(o, 0);
        break;
    }
    return E;
  };
}
var ur = vr, hr = j1;
function fr() {
  this.class_id = 0, this.num_samples = 0, this.num_channels = 0, this.in_samplerate = 0, this.out_samplerate = 0, this.scale = 0, this.scale_left = 0, this.scale_right = 0, this.analysis = !1, this.bWriteVbrTag = !1, this.decode_only = !1, this.quality = 0, this.mode = hr.STEREO, this.force_ms = !1, this.free_format = !1, this.findReplayGain = !1, this.decode_on_the_fly = !1, this.write_id3tag_automatic = !1, this.brate = 0, this.compression_ratio = 0, this.copyright = 0, this.original = 0, this.extension = 0, this.emphasis = 0, this.error_protection = 0, this.strict_ISO = !1, this.disable_reservoir = !1, this.quant_comp = 0, this.quant_comp_short = 0, this.experimentalY = !1, this.experimentalZ = 0, this.exp_nspsytune = 0, this.preset = 0, this.VBR = null, this.VBR_q_frac = 0, this.VBR_q = 0, this.VBR_mean_bitrate_kbps = 0, this.VBR_min_bitrate_kbps = 0, this.VBR_max_bitrate_kbps = 0, this.VBR_hard_min = 0, this.lowpassfreq = 0, this.highpassfreq = 0, this.lowpasswidth = 0, this.highpasswidth = 0, this.maskingadjust = 0, this.maskingadjust_short = 0, this.ATHonly = !1, this.ATHshort = !1, this.noATH = !1, this.ATHtype = 0, this.ATHcurve = 0, this.ATHlower = 0, this.athaa_type = 0, this.athaa_loudapprox = 0, this.athaa_sensitivity = 0, this.short_blocks = null, this.useTemporal = !1, this.interChRatio = 0, this.msfix = 0, this.tune = !1, this.tune_value_a = 0, this.version = 0, this.encoder_delay = 0, this.encoder_padding = 0, this.framesize = 0, this.frameNum = 0, this.lame_allocated_gfp = 0, this.internal_flags = null;
}
var cr = fr, mr = t1(), Na = {};
Na.SFBMAX = mr.SBMAX_s * 3;
var ve = Na, Va = Q0, br = Va.new_float, L1 = Va.new_int, Te = ve;
function dr() {
  this.xr = br(576), this.l3_enc = L1(576), this.scalefac = L1(Te.SFBMAX), this.xrpow_max = 0, this.part2_3_length = 0, this.big_values = 0, this.count1 = 0, this.global_gain = 0, this.scalefac_compress = 0, this.block_type = 0, this.mixed_block_flag = 0, this.table_select = L1(3), this.subblock_gain = L1(3 + 1), this.region0_count = 0, this.region1_count = 0, this.preflag = 0, this.scalefac_scale = 0, this.count1table_select = 0, this.part2_length = 0, this.sfb_lmax = 0, this.sfb_smin = 0, this.psy_lmax = 0, this.sfbmax = 0, this.psymax = 0, this.sfbdivide = 0, this.width = L1(Te.SFBMAX), this.window = L1(Te.SFBMAX), this.count1bits = 0, this.sfb_partition_table = null, this.slen = L1(4), this.max_nonzero_coeff = 0;
  var m = this;
  function x(K) {
    return new Int32Array(K);
  }
  function y(K) {
    return new Float32Array(K);
  }
  this.assign = function(K) {
    m.xr = y(K.xr), m.l3_enc = x(K.l3_enc), m.scalefac = x(K.scalefac), m.xrpow_max = K.xrpow_max, m.part2_3_length = K.part2_3_length, m.big_values = K.big_values, m.count1 = K.count1, m.global_gain = K.global_gain, m.scalefac_compress = K.scalefac_compress, m.block_type = K.block_type, m.mixed_block_flag = K.mixed_block_flag, m.table_select = x(K.table_select), m.subblock_gain = x(K.subblock_gain), m.region0_count = K.region0_count, m.region1_count = K.region1_count, m.preflag = K.preflag, m.scalefac_scale = K.scalefac_scale, m.count1table_select = K.count1table_select, m.part2_length = K.part2_length, m.sfb_lmax = K.sfb_lmax, m.sfb_smin = K.sfb_smin, m.psy_lmax = K.psy_lmax, m.sfbmax = K.sfbmax, m.psymax = K.psymax, m.sfbdivide = K.sfbdivide, m.width = x(K.width), m.window = x(K.window), m.count1bits = K.count1bits, m.sfb_partition_table = K.sfb_partition_table.slice(0), m.slen = x(K.slen), m.max_nonzero_coeff = K.max_nonzero_coeff;
  };
}
var He = dr, Sr = Q0, ge = Sr.new_int, Ar = He;
function Rr() {
  this.tt = [[null, null], [null, null]], this.main_data_begin = 0, this.private_bits = 0, this.resvDrain_pre = 0, this.resvDrain_post = 0, this.scfsi = [ge(4), ge(4)];
  for (var m = 0; m < 2; m++)
    for (var x = 0; x < 2; x++)
      this.tt[m][x] = new Ar();
}
var xr = Rr, Ha = Q0, ae = Ha.System, re = Ha.new_int, te = t1();
function Mr(m, x, y, K) {
  this.l = re(1 + te.SBMAX_l), this.s = re(1 + te.SBMAX_s), this.psfb21 = re(1 + te.PSFB21), this.psfb12 = re(1 + te.PSFB12);
  var i0 = this.l, P = this.s;
  arguments.length == 4 && (this.arrL = arguments[0], this.arrS = arguments[1], this.arr21 = arguments[2], this.arr12 = arguments[3], ae.arraycopy(this.arrL, 0, i0, 0, Math.min(this.arrL.length, this.l.length)), ae.arraycopy(this.arrS, 0, P, 0, Math.min(this.arrS.length, this.s.length)), ae.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length)), ae.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length)));
}
var Oa = Mr, Oe = Q0, ye = Oe.new_float, Er = Oe.new_float_n, Br = Oe.new_int, ea = t1();
function Tr() {
  this.last_en_subshort = Er([4, 9]), this.lastAttacks = Br(4), this.pefirbuf = ye(19), this.longfact = ye(ea.SBMAX_l), this.shortfact = ye(ea.SBMAX_s), this.attackthre = 0, this.attackthre_s = 0;
}
var yr = Tr;
function wr() {
  this.sum = 0, this.seen = 0, this.want = 0, this.pos = 0, this.size = 0, this.bag = null, this.nVbrNumFrames = 0, this.nBytesWritten = 0, this.TotalFrameSize = 0;
}
var pr = wr, Y1 = Q0, Ir = Y1.new_byte, Lr = Y1.new_double, m1 = Y1.new_float, C1 = Y1.new_float_n, S1 = Y1.new_int, ne = Y1.new_int_n, Cr = xr, Nr = Oa, Vr = yr, Hr = pr, aa = La(), z0 = t1(), Or = ve;
E1.MFSIZE = 3 * 1152 + z0.ENCDELAY - z0.MDCTDELAY;
E1.MAX_HEADER_BUF = 256;
E1.MAX_BITS_PER_CHANNEL = 4095;
E1.MAX_BITS_PER_GRANULE = 7680;
E1.BPC = 320;
function E1() {
  var m = 40;
  this.Class_ID = 0, this.lame_encode_frame_init = 0, this.iteration_init_init = 0, this.fill_buffer_resample_init = 0, this.mfbuf = C1([2, E1.MFSIZE]), this.mode_gr = 0, this.channels_in = 0, this.channels_out = 0, this.resample_ratio = 0, this.mf_samples_to_encode = 0, this.mf_size = 0, this.VBR_min_bitrate = 0, this.VBR_max_bitrate = 0, this.bitrate_index = 0, this.samplerate_index = 0, this.mode_ext = 0, this.lowpass1 = 0, this.lowpass2 = 0, this.highpass1 = 0, this.highpass2 = 0, this.noise_shaping = 0, this.noise_shaping_amp = 0, this.substep_shaping = 0, this.psymodel = 0, this.noise_shaping_stop = 0, this.subblock_gain = 0, this.use_best_huffman = 0, this.full_outer_loop = 0, this.l3_side = new Cr(), this.ms_ratio = m1(2), this.padding = 0, this.frac_SpF = 0, this.slot_lag = 0, this.tag_spec = null, this.nMusicCRC = 0, this.OldValue = S1(2), this.CurrentStep = S1(2), this.masking_lower = 0, this.bv_scf = S1(576), this.pseudohalf = S1(Or.SFBMAX), this.sfb21_extra = !1, this.inbuf_old = new Array(2), this.blackfilt = new Array(2 * E1.BPC + 1), this.itime = Lr(2), this.sideinfo_len = 0, this.sb_sample = C1([2, 2, 18, z0.SBLIMIT]), this.amp_filter = m1(32);
  function x() {
    this.write_timing = 0, this.ptr = 0, this.buf = Ir(m);
  }
  this.header = new Array(E1.MAX_HEADER_BUF), this.h_ptr = 0, this.w_ptr = 0, this.ancillary_flag = 0, this.ResvSize = 0, this.ResvMax = 0, this.scalefac_band = new Nr(), this.minval_l = m1(z0.CBANDS), this.minval_s = m1(z0.CBANDS), this.nb_1 = C1([4, z0.CBANDS]), this.nb_2 = C1([4, z0.CBANDS]), this.nb_s1 = C1([4, z0.CBANDS]), this.nb_s2 = C1([4, z0.CBANDS]), this.s3_ss = null, this.s3_ll = null, this.decay = 0, this.thm = new Array(4), this.en = new Array(4), this.tot_ener = m1(4), this.loudness_sq = C1([2, 2]), this.loudness_sq_save = m1(2), this.mld_l = m1(z0.SBMAX_l), this.mld_s = m1(z0.SBMAX_s), this.bm_l = S1(z0.SBMAX_l), this.bo_l = S1(z0.SBMAX_l), this.bm_s = S1(z0.SBMAX_s), this.bo_s = S1(z0.SBMAX_s), this.npart_l = 0, this.npart_s = 0, this.s3ind = ne([z0.CBANDS, 2]), this.s3ind_s = ne([z0.CBANDS, 2]), this.numlines_s = S1(z0.CBANDS), this.numlines_l = S1(z0.CBANDS), this.rnumlines_l = m1(z0.CBANDS), this.mld_cb_l = m1(z0.CBANDS), this.mld_cb_s = m1(z0.CBANDS), this.numlines_s_num1 = 0, this.numlines_l_num1 = 0, this.pe = m1(4), this.ms_ratio_s_old = 0, this.ms_ratio_l_old = 0, this.ms_ener_ratio_old = 0, this.blocktype_old = S1(2), this.nsPsy = new Vr(), this.VBR_seek_table = new Hr(), this.ATH = null, this.PSY = null, this.nogap_total = 0, this.nogap_current = 0, this.decode_on_the_fly = !0, this.findReplayGain = !0, this.findPeakSample = !0, this.PeakSample = 0, this.RadioGain = 0, this.AudiophileGain = 0, this.rgdata = null, this.noclipGainChange = 0, this.noclipScale = 0, this.bitrate_stereoMode_Hist = ne([16, 4 + 1]), this.bitrate_blockType_Hist = ne([16, 4 + 1 + 1]), this.pinfo = null, this.hip = null, this.in_buffer_nsamples = 0, this.in_buffer_0 = null, this.in_buffer_1 = null, this.iteration_loop = null;
  for (var y = 0; y < this.en.length; y++)
    this.en[y] = new aa();
  for (var y = 0; y < this.thm.length; y++)
    this.thm[y] = new aa();
  for (var y = 0; y < this.header.length; y++)
    this.header[y] = new x();
}
var ue = E1, Fr = Q0, N1 = Fr.new_float, V1 = t1();
function kr() {
  this.useAdjust = 0, this.aaSensitivityP = 0, this.adjust = 0, this.adjustLimit = 0, this.decay = 0, this.floor = 0, this.l = N1(V1.SBMAX_l), this.s = N1(V1.SBMAX_s), this.psfb21 = N1(V1.PSFB21), this.psfb12 = N1(V1.PSFB12), this.cb_l = N1(V1.CBANDS), this.cb_s = N1(V1.CBANDS), this.eql_w = N1(V1.BLKSIZE / 2);
}
var Xr = kr, Fa = Q0, _1 = Fa.System, ra = Fa.Arrays;
j0.STEPS_per_dB = 100;
j0.MAX_dB = 120;
j0.GAIN_NOT_ENOUGH_SAMPLES = -24601;
j0.GAIN_ANALYSIS_ERROR = 0;
j0.GAIN_ANALYSIS_OK = 1;
j0.INIT_GAIN_ANALYSIS_ERROR = 0;
j0.INIT_GAIN_ANALYSIS_OK = 1;
j0.YULE_ORDER = 10;
j0.MAX_ORDER = j0.YULE_ORDER;
j0.MAX_SAMP_FREQ = 48e3;
j0.RMS_WINDOW_TIME_NUMERATOR = 1;
j0.RMS_WINDOW_TIME_DENOMINATOR = 20;
j0.MAX_SAMPLES_PER_WINDOW = j0.MAX_SAMP_FREQ * j0.RMS_WINDOW_TIME_NUMERATOR / j0.RMS_WINDOW_TIME_DENOMINATOR + 1;
function j0() {
  var m = 64.82, x = 0.95, y = j0.RMS_WINDOW_TIME_NUMERATOR, K = j0.RMS_WINDOW_TIME_DENOMINATOR, i0 = [
    [
      0.038575994352,
      -3.84664617118067,
      -0.02160367184185,
      7.81501653005538,
      -0.00123395316851,
      -11.34170355132042,
      -9291677959e-14,
      13.05504219327545,
      -0.01655260341619,
      -12.28759895145294,
      0.02161526843274,
      9.4829380631979,
      -0.02074045215285,
      -5.87257861775999,
      0.00594298065125,
      2.75465861874613,
      0.00306428023191,
      -0.86984376593551,
      12025322027e-14,
      0.13919314567432,
      0.00288463683916
    ],
    [
      0.0541865640643,
      -3.47845948550071,
      -0.02911007808948,
      6.36317777566148,
      -0.00848709379851,
      -8.54751527471874,
      -0.00851165645469,
      9.4769360780128,
      -0.00834990904936,
      -8.81498681370155,
      0.02245293253339,
      6.85401540936998,
      -0.02596338512915,
      -4.39470996079559,
      0.01624864962975,
      2.19611684890774,
      -0.00240879051584,
      -0.75104302451432,
      0.00674613682247,
      0.13149317958808,
      -0.00187763777362
    ],
    [
      0.15457299681924,
      -2.37898834973084,
      -0.09331049056315,
      2.84868151156327,
      -0.06247880153653,
      -2.64577170229825,
      0.02163541888798,
      2.23697657451713,
      -0.05588393329856,
      -1.67148153367602,
      0.04781476674921,
      1.00595954808547,
      0.00222312597743,
      -0.45953458054983,
      0.03174092540049,
      0.16378164858596,
      -0.01390589421898,
      -0.05032077717131,
      0.00651420667831,
      0.0234789740702,
      -0.00881362733839
    ],
    [
      0.30296907319327,
      -1.61273165137247,
      -0.22613988682123,
      1.0797749225997,
      -0.08587323730772,
      -0.2565625775407,
      0.03282930172664,
      -0.1627671912044,
      -0.00915702933434,
      -0.22638893773906,
      -0.02364141202522,
      0.39120800788284,
      -0.00584456039913,
      -0.22138138954925,
      0.06276101321749,
      0.04500235387352,
      -828086748e-14,
      0.02005851806501,
      0.00205861885564,
      0.00302439095741,
      -0.02950134983287
    ],
    [
      0.33642304856132,
      -1.49858979367799,
      -0.2557224142557,
      0.87350271418188,
      -0.11828570177555,
      0.12205022308084,
      0.11921148675203,
      -0.80774944671438,
      -0.07834489609479,
      0.47854794562326,
      -0.0046997791438,
      -0.12453458140019,
      -0.0058950022444,
      -0.04067510197014,
      0.05724228140351,
      0.08333755284107,
      0.00832043980773,
      -0.04237348025746,
      -0.0163538138454,
      0.02977207319925,
      -0.0176017656815
    ],
    [
      0.4491525660845,
      -0.62820619233671,
      -0.14351757464547,
      0.29661783706366,
      -0.22784394429749,
      -0.372563729424,
      -0.01419140100551,
      0.00213767857124,
      0.04078262797139,
      -0.42029820170918,
      -0.12398163381748,
      0.22199650564824,
      0.04097565135648,
      0.00613424350682,
      0.10478503600251,
      0.06747620744683,
      -0.01863887810927,
      0.05784820375801,
      -0.03193428438915,
      0.03222754072173,
      0.00541907748707
    ],
    [
      0.56619470757641,
      -1.04800335126349,
      -0.75464456939302,
      0.29156311971249,
      0.1624213774223,
      -0.26806001042947,
      0.16744243493672,
      0.00819999645858,
      -0.18901604199609,
      0.45054734505008,
      0.3093178284183,
      -0.33032403314006,
      -0.27562961986224,
      0.0673936833311,
      0.00647310677246,
      -0.04784254229033,
      0.08647503780351,
      0.01639907836189,
      -0.0378898455484,
      0.01807364323573,
      -0.00588215443421
    ],
    [
      0.58100494960553,
      -0.51035327095184,
      -0.53174909058578,
      -0.31863563325245,
      -0.14289799034253,
      -0.20256413484477,
      0.17520704835522,
      0.1472815413433,
      0.02377945217615,
      0.38952639978999,
      0.15558449135573,
      -0.23313271880868,
      -0.25344790059353,
      -0.05246019024463,
      0.01628462406333,
      -0.02505961724053,
      0.06920467763959,
      0.02442357316099,
      -0.03721611395801,
      0.01818801111503,
      -0.00749618797172
    ],
    [
      0.53648789255105,
      -0.2504987195602,
      -0.42163034350696,
      -0.43193942311114,
      -0.00275953611929,
      -0.03424681017675,
      0.04267842219415,
      -0.04678328784242,
      -0.10214864179676,
      0.26408300200955,
      0.14590772289388,
      0.15113130533216,
      -0.02459864859345,
      -0.17556493366449,
      -0.11202315195388,
      -0.18823009262115,
      -0.04060034127,
      0.05477720428674,
      0.0478866554818,
      0.0470440968812,
      -0.02217936801134
    ]
  ], P = [
    [
      0.98621192462708,
      -1.97223372919527,
      -1.97242384925416,
      0.97261396931306,
      0.98621192462708
    ],
    [
      0.98500175787242,
      -1.96977855582618,
      -1.97000351574484,
      0.9702284756635,
      0.98500175787242
    ],
    [
      0.97938932735214,
      -1.95835380975398,
      -1.95877865470428,
      0.95920349965459,
      0.97938932735214
    ],
    [
      0.97531843204928,
      -1.95002759149878,
      -1.95063686409857,
      0.95124613669835,
      0.97531843204928
    ],
    [
      0.97316523498161,
      -1.94561023566527,
      -1.94633046996323,
      0.94705070426118,
      0.97316523498161
    ],
    [
      0.96454515552826,
      -1.92783286977036,
      -1.92909031105652,
      0.93034775234268,
      0.96454515552826
    ],
    [
      0.96009142950541,
      -1.91858953033784,
      -1.92018285901082,
      0.92177618768381,
      0.96009142950541
    ],
    [
      0.95856916599601,
      -1.9154210807478,
      -1.91713833199203,
      0.91885558323625,
      0.95856916599601
    ],
    [
      0.94597685600279,
      -1.88903307939452,
      -1.89195371200558,
      0.89487434461664,
      0.94597685600279
    ]
  ];
  function z(c, H, n0, Q, t0, j) {
    for (; t0-- != 0; )
      n0[Q] = 1e-10 + c[H + 0] * j[0] - n0[Q - 1] * j[1] + c[H - 1] * j[2] - n0[Q - 2] * j[3] + c[H - 2] * j[4] - n0[Q - 3] * j[5] + c[H - 3] * j[6] - n0[Q - 4] * j[7] + c[H - 4] * j[8] - n0[Q - 5] * j[9] + c[H - 5] * j[10] - n0[Q - 6] * j[11] + c[H - 6] * j[12] - n0[Q - 7] * j[13] + c[H - 7] * j[14] - n0[Q - 8] * j[15] + c[H - 8] * j[16] - n0[Q - 9] * j[17] + c[H - 9] * j[18] - n0[Q - 10] * j[19] + c[H - 10] * j[20], ++Q, ++H;
  }
  function D(c, H, n0, Q, t0, j) {
    for (; t0-- != 0; )
      n0[Q] = c[H + 0] * j[0] - n0[Q - 1] * j[1] + c[H - 1] * j[2] - n0[Q - 2] * j[3] + c[H - 2] * j[4], ++Q, ++H;
  }
  function W(c, H) {
    for (var n0 = 0; n0 < MAX_ORDER; n0++)
      c.linprebuf[n0] = c.lstepbuf[n0] = c.loutbuf[n0] = c.rinprebuf[n0] = c.rstepbuf[n0] = c.routbuf[n0] = 0;
    switch (0 | H) {
      case 48e3:
        c.reqindex = 0;
        break;
      case 44100:
        c.reqindex = 1;
        break;
      case 32e3:
        c.reqindex = 2;
        break;
      case 24e3:
        c.reqindex = 3;
        break;
      case 22050:
        c.reqindex = 4;
        break;
      case 16e3:
        c.reqindex = 5;
        break;
      case 12e3:
        c.reqindex = 6;
        break;
      case 11025:
        c.reqindex = 7;
        break;
      case 8e3:
        c.reqindex = 8;
        break;
      default:
        return INIT_GAIN_ANALYSIS_ERROR;
    }
    return c.sampleWindow = 0 | (H * y + K - 1) / K, c.lsum = 0, c.rsum = 0, c.totsamp = 0, ra.ill(c.A, 0), INIT_GAIN_ANALYSIS_OK;
  }
  this.InitGainAnalysis = function(c, H) {
    return W(c, H) != INIT_GAIN_ANALYSIS_OK ? INIT_GAIN_ANALYSIS_ERROR : (c.linpre = MAX_ORDER, c.rinpre = MAX_ORDER, c.lstep = MAX_ORDER, c.rstep = MAX_ORDER, c.lout = MAX_ORDER, c.rout = MAX_ORDER, ra.fill(c.B, 0), INIT_GAIN_ANALYSIS_OK);
  };
  function f0(c) {
    return c * c;
  }
  this.AnalyzeSamples = function(c, H, n0, Q, t0, j, M) {
    var v, h, A, e, l, B, V;
    if (j == 0)
      return GAIN_ANALYSIS_OK;
    switch (V = 0, l = j, M) {
      case 1:
        Q = H, t0 = n0;
        break;
      case 2:
        break;
      default:
        return GAIN_ANALYSIS_ERROR;
    }
    for (j < MAX_ORDER ? (_1.arraycopy(
      H,
      n0,
      c.linprebuf,
      MAX_ORDER,
      j
    ), _1.arraycopy(
      Q,
      t0,
      c.rinprebuf,
      MAX_ORDER,
      j
    )) : (_1.arraycopy(
      H,
      n0,
      c.linprebuf,
      MAX_ORDER,
      MAX_ORDER
    ), _1.arraycopy(
      Q,
      t0,
      c.rinprebuf,
      MAX_ORDER,
      MAX_ORDER
    )); l > 0; ) {
      B = l > c.sampleWindow - c.totsamp ? c.sampleWindow - c.totsamp : l, V < MAX_ORDER ? (v = c.linpre + V, h = c.linprebuf, A = c.rinpre + V, e = c.rinprebuf, B > MAX_ORDER - V && (B = MAX_ORDER - V)) : (v = n0 + V, h = H, A = t0 + V, e = Q), z(h, v, c.lstepbuf, c.lstep + c.totsamp, B, i0[c.reqindex]), z(e, A, c.rstepbuf, c.rstep + c.totsamp, B, i0[c.reqindex]), D(
        c.lstepbuf,
        c.lstep + c.totsamp,
        c.loutbuf,
        c.lout + c.totsamp,
        B,
        P[c.reqindex]
      ), D(
        c.rstepbuf,
        c.rstep + c.totsamp,
        c.routbuf,
        c.rout + c.totsamp,
        B,
        P[c.reqindex]
      ), v = c.lout + c.totsamp, h = c.loutbuf, A = c.rout + c.totsamp, e = c.routbuf;
      for (var O = B % 8; O-- != 0; )
        c.lsum += f0(h[v++]), c.rsum += f0(e[A++]);
      for (O = B / 8; O-- != 0; )
        c.lsum += f0(h[v + 0]) + f0(h[v + 1]) + f0(h[v + 2]) + f0(h[v + 3]) + f0(h[v + 4]) + f0(h[v + 5]) + f0(h[v + 6]) + f0(h[v + 7]), v += 8, c.rsum += f0(e[A + 0]) + f0(e[A + 1]) + f0(e[A + 2]) + f0(e[A + 3]) + f0(e[A + 4]) + f0(e[A + 5]) + f0(e[A + 6]) + f0(e[A + 7]), A += 8;
      if (l -= B, V += B, c.totsamp += B, c.totsamp == c.sampleWindow) {
        var w = j0.STEPS_per_dB * 10 * Math.log10((c.lsum + c.rsum) / c.totsamp * 0.5 + 1e-37), L = w <= 0 ? 0 : 0 | w;
        L >= c.A.length && (L = c.A.length - 1), c.A[L]++, c.lsum = c.rsum = 0, _1.arraycopy(
          c.loutbuf,
          c.totsamp,
          c.loutbuf,
          0,
          MAX_ORDER
        ), _1.arraycopy(
          c.routbuf,
          c.totsamp,
          c.routbuf,
          0,
          MAX_ORDER
        ), _1.arraycopy(
          c.lstepbuf,
          c.totsamp,
          c.lstepbuf,
          0,
          MAX_ORDER
        ), _1.arraycopy(
          c.rstepbuf,
          c.totsamp,
          c.rstepbuf,
          0,
          MAX_ORDER
        ), c.totsamp = 0;
      }
      if (c.totsamp > c.sampleWindow)
        return GAIN_ANALYSIS_ERROR;
    }
    return j < MAX_ORDER ? (_1.arraycopy(
      c.linprebuf,
      j,
      c.linprebuf,
      0,
      MAX_ORDER - j
    ), _1.arraycopy(
      c.rinprebuf,
      j,
      c.rinprebuf,
      0,
      MAX_ORDER - j
    ), _1.arraycopy(
      H,
      n0,
      c.linprebuf,
      MAX_ORDER - j,
      j
    ), _1.arraycopy(
      Q,
      t0,
      c.rinprebuf,
      MAX_ORDER - j,
      j
    )) : (_1.arraycopy(H, n0 + j - MAX_ORDER, c.linprebuf, 0, MAX_ORDER), _1.arraycopy(Q, t0 + j - MAX_ORDER, c.rinprebuf, 0, MAX_ORDER)), GAIN_ANALYSIS_OK;
  };
  function R(c, H) {
    var n0, Q = 0;
    for (n0 = 0; n0 < H; n0++)
      Q += c[n0];
    if (Q == 0)
      return GAIN_NOT_ENOUGH_SAMPLES;
    var t0 = 0 | Math.ceil(Q * (1 - x));
    for (n0 = H; n0-- > 0 && !((t0 -= c[n0]) <= 0); )
      ;
    return m - n0 / j0.STEPS_per_dB;
  }
  this.GetTitleGain = function(c) {
    for (var H = R(c.A, c.A.length), n0 = 0; n0 < c.A.length; n0++)
      c.B[n0] += c.A[n0], c.A[n0] = 0;
    for (var n0 = 0; n0 < MAX_ORDER; n0++)
      c.linprebuf[n0] = c.lstepbuf[n0] = c.loutbuf[n0] = c.rinprebuf[n0] = c.rstepbuf[n0] = c.routbuf[n0] = 0;
    return c.totsamp = 0, c.lsum = c.rsum = 0, H;
  };
}
var ka = j0, Xa = Q0, k1 = Xa.new_float, ta = Xa.new_int, l1 = ka;
function Yr() {
  this.linprebuf = k1(l1.MAX_ORDER * 2), this.linpre = 0, this.lstepbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.lstep = 0, this.loutbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.lout = 0, this.rinprebuf = k1(l1.MAX_ORDER * 2), this.rinpre = 0, this.rstepbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.rstep = 0, this.routbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.rout = 0, this.sampleWindow = 0, this.totsamp = 0, this.lsum = 0, this.rsum = 0, this.freqindex = 0, this.first = 0, this.A = ta(0 | l1.STEPS_per_dB * l1.MAX_dB), this.B = ta(0 | l1.STEPS_per_dB * l1.MAX_dB);
}
var qr = Yr;
function Dr(m) {
  this.bits = m;
}
var Ya = Dr, Fe = Q0, na = Fe.new_float, Gr = Fe.new_int, sa = Fe.assert, $r = Ya, ia = t1(), Pr = ve, Zr = ue;
function Kr(m) {
  var x = m;
  this.quantize = x, this.iteration_loop = function(y, K, i0, P) {
    var z = y.internal_flags, D = na(Pr.SFBMAX), W = na(576), f0 = Gr(2), R = 0, c, H = z.l3_side, n0 = new $r(R);
    this.quantize.rv.ResvFrameBegin(y, n0), R = n0.bits;
    for (var Q = 0; Q < z.mode_gr; Q++) {
      c = this.quantize.qupvt.on_pe(
        y,
        K,
        f0,
        R,
        Q,
        Q
      ), z.mode_ext == ia.MPG_MD_MS_LR && (this.quantize.ms_convert(z.l3_side, Q), this.quantize.qupvt.reduce_side(
        f0,
        i0[Q],
        R,
        c
      ));
      for (var t0 = 0; t0 < z.channels_out; t0++) {
        var j, M, v = H.tt[Q][t0];
        v.block_type != ia.SHORT_TYPE ? (j = 0, M = z.PSY.mask_adjust - j) : (j = 0, M = z.PSY.mask_adjust_short - j), z.masking_lower = Math.pow(
          10,
          M * 0.1
        ), this.quantize.init_outer_loop(z, v), this.quantize.init_xrpow(z, v, W) && (this.quantize.qupvt.calc_xmin(
          y,
          P[Q][t0],
          v,
          D
        ), this.quantize.outer_loop(
          y,
          v,
          D,
          W,
          t0,
          f0[t0]
        )), this.quantize.iteration_finish_one(z, Q, t0), sa(v.part2_3_length <= Zr.MAX_BITS_PER_CHANNEL), sa(v.part2_3_length <= f0[t0]);
      }
    }
    this.quantize.rv.ResvFrameEnd(z, R);
  };
}
var Ur = Kr;
function q0(m, x, y, K) {
  this.xlen = m, this.linmax = x, this.table = y, this.hlen = K;
}
var u0 = {};
u0.t1HB = [
  1,
  1,
  1,
  0
];
u0.t2HB = [
  1,
  2,
  1,
  3,
  1,
  1,
  3,
  2,
  0
];
u0.t3HB = [
  3,
  2,
  1,
  1,
  1,
  1,
  3,
  2,
  0
];
u0.t5HB = [
  1,
  2,
  6,
  5,
  3,
  1,
  4,
  4,
  7,
  5,
  7,
  1,
  6,
  1,
  1,
  0
];
u0.t6HB = [
  7,
  3,
  5,
  1,
  6,
  2,
  3,
  2,
  5,
  4,
  4,
  1,
  3,
  3,
  2,
  0
];
u0.t7HB = [
  1,
  2,
  10,
  19,
  16,
  10,
  3,
  3,
  7,
  10,
  5,
  3,
  11,
  4,
  13,
  17,
  8,
  4,
  12,
  11,
  18,
  15,
  11,
  2,
  7,
  6,
  9,
  14,
  3,
  1,
  6,
  4,
  5,
  3,
  2,
  0
];
u0.t8HB = [
  3,
  4,
  6,
  18,
  12,
  5,
  5,
  1,
  2,
  16,
  9,
  3,
  7,
  3,
  5,
  14,
  7,
  3,
  19,
  17,
  15,
  13,
  10,
  4,
  13,
  5,
  8,
  11,
  5,
  1,
  12,
  4,
  4,
  1,
  1,
  0
];
u0.t9HB = [
  7,
  5,
  9,
  14,
  15,
  7,
  6,
  4,
  5,
  5,
  6,
  7,
  7,
  6,
  8,
  8,
  8,
  5,
  15,
  6,
  9,
  10,
  5,
  1,
  11,
  7,
  9,
  6,
  4,
  1,
  14,
  4,
  6,
  2,
  6,
  0
];
u0.t10HB = [
  1,
  2,
  10,
  23,
  35,
  30,
  12,
  17,
  3,
  3,
  8,
  12,
  18,
  21,
  12,
  7,
  11,
  9,
  15,
  21,
  32,
  40,
  19,
  6,
  14,
  13,
  22,
  34,
  46,
  23,
  18,
  7,
  20,
  19,
  33,
  47,
  27,
  22,
  9,
  3,
  31,
  22,
  41,
  26,
  21,
  20,
  5,
  3,
  14,
  13,
  10,
  11,
  16,
  6,
  5,
  1,
  9,
  8,
  7,
  8,
  4,
  4,
  2,
  0
];
u0.t11HB = [
  3,
  4,
  10,
  24,
  34,
  33,
  21,
  15,
  5,
  3,
  4,
  10,
  32,
  17,
  11,
  10,
  11,
  7,
  13,
  18,
  30,
  31,
  20,
  5,
  25,
  11,
  19,
  59,
  27,
  18,
  12,
  5,
  35,
  33,
  31,
  58,
  30,
  16,
  7,
  5,
  28,
  26,
  32,
  19,
  17,
  15,
  8,
  14,
  14,
  12,
  9,
  13,
  14,
  9,
  4,
  1,
  11,
  4,
  6,
  6,
  6,
  3,
  2,
  0
];
u0.t12HB = [
  9,
  6,
  16,
  33,
  41,
  39,
  38,
  26,
  7,
  5,
  6,
  9,
  23,
  16,
  26,
  11,
  17,
  7,
  11,
  14,
  21,
  30,
  10,
  7,
  17,
  10,
  15,
  12,
  18,
  28,
  14,
  5,
  32,
  13,
  22,
  19,
  18,
  16,
  9,
  5,
  40,
  17,
  31,
  29,
  17,
  13,
  4,
  2,
  27,
  12,
  11,
  15,
  10,
  7,
  4,
  1,
  27,
  12,
  8,
  12,
  6,
  3,
  1,
  0
];
u0.t13HB = [
  1,
  5,
  14,
  21,
  34,
  51,
  46,
  71,
  42,
  52,
  68,
  52,
  67,
  44,
  43,
  19,
  3,
  4,
  12,
  19,
  31,
  26,
  44,
  33,
  31,
  24,
  32,
  24,
  31,
  35,
  22,
  14,
  15,
  13,
  23,
  36,
  59,
  49,
  77,
  65,
  29,
  40,
  30,
  40,
  27,
  33,
  42,
  16,
  22,
  20,
  37,
  61,
  56,
  79,
  73,
  64,
  43,
  76,
  56,
  37,
  26,
  31,
  25,
  14,
  35,
  16,
  60,
  57,
  97,
  75,
  114,
  91,
  54,
  73,
  55,
  41,
  48,
  53,
  23,
  24,
  58,
  27,
  50,
  96,
  76,
  70,
  93,
  84,
  77,
  58,
  79,
  29,
  74,
  49,
  41,
  17,
  47,
  45,
  78,
  74,
  115,
  94,
  90,
  79,
  69,
  83,
  71,
  50,
  59,
  38,
  36,
  15,
  72,
  34,
  56,
  95,
  92,
  85,
  91,
  90,
  86,
  73,
  77,
  65,
  51,
  44,
  43,
  42,
  43,
  20,
  30,
  44,
  55,
  78,
  72,
  87,
  78,
  61,
  46,
  54,
  37,
  30,
  20,
  16,
  53,
  25,
  41,
  37,
  44,
  59,
  54,
  81,
  66,
  76,
  57,
  54,
  37,
  18,
  39,
  11,
  35,
  33,
  31,
  57,
  42,
  82,
  72,
  80,
  47,
  58,
  55,
  21,
  22,
  26,
  38,
  22,
  53,
  25,
  23,
  38,
  70,
  60,
  51,
  36,
  55,
  26,
  34,
  23,
  27,
  14,
  9,
  7,
  34,
  32,
  28,
  39,
  49,
  75,
  30,
  52,
  48,
  40,
  52,
  28,
  18,
  17,
  9,
  5,
  45,
  21,
  34,
  64,
  56,
  50,
  49,
  45,
  31,
  19,
  12,
  15,
  10,
  7,
  6,
  3,
  48,
  23,
  20,
  39,
  36,
  35,
  53,
  21,
  16,
  23,
  13,
  10,
  6,
  1,
  4,
  2,
  16,
  15,
  17,
  27,
  25,
  20,
  29,
  11,
  17,
  12,
  16,
  8,
  1,
  1,
  0,
  1
];
u0.t15HB = [
  7,
  12,
  18,
  53,
  47,
  76,
  124,
  108,
  89,
  123,
  108,
  119,
  107,
  81,
  122,
  63,
  13,
  5,
  16,
  27,
  46,
  36,
  61,
  51,
  42,
  70,
  52,
  83,
  65,
  41,
  59,
  36,
  19,
  17,
  15,
  24,
  41,
  34,
  59,
  48,
  40,
  64,
  50,
  78,
  62,
  80,
  56,
  33,
  29,
  28,
  25,
  43,
  39,
  63,
  55,
  93,
  76,
  59,
  93,
  72,
  54,
  75,
  50,
  29,
  52,
  22,
  42,
  40,
  67,
  57,
  95,
  79,
  72,
  57,
  89,
  69,
  49,
  66,
  46,
  27,
  77,
  37,
  35,
  66,
  58,
  52,
  91,
  74,
  62,
  48,
  79,
  63,
  90,
  62,
  40,
  38,
  125,
  32,
  60,
  56,
  50,
  92,
  78,
  65,
  55,
  87,
  71,
  51,
  73,
  51,
  70,
  30,
  109,
  53,
  49,
  94,
  88,
  75,
  66,
  122,
  91,
  73,
  56,
  42,
  64,
  44,
  21,
  25,
  90,
  43,
  41,
  77,
  73,
  63,
  56,
  92,
  77,
  66,
  47,
  67,
  48,
  53,
  36,
  20,
  71,
  34,
  67,
  60,
  58,
  49,
  88,
  76,
  67,
  106,
  71,
  54,
  38,
  39,
  23,
  15,
  109,
  53,
  51,
  47,
  90,
  82,
  58,
  57,
  48,
  72,
  57,
  41,
  23,
  27,
  62,
  9,
  86,
  42,
  40,
  37,
  70,
  64,
  52,
  43,
  70,
  55,
  42,
  25,
  29,
  18,
  11,
  11,
  118,
  68,
  30,
  55,
  50,
  46,
  74,
  65,
  49,
  39,
  24,
  16,
  22,
  13,
  14,
  7,
  91,
  44,
  39,
  38,
  34,
  63,
  52,
  45,
  31,
  52,
  28,
  19,
  14,
  8,
  9,
  3,
  123,
  60,
  58,
  53,
  47,
  43,
  32,
  22,
  37,
  24,
  17,
  12,
  15,
  10,
  2,
  1,
  71,
  37,
  34,
  30,
  28,
  20,
  17,
  26,
  21,
  16,
  10,
  6,
  8,
  6,
  2,
  0
];
u0.t16HB = [
  1,
  5,
  14,
  44,
  74,
  63,
  110,
  93,
  172,
  149,
  138,
  242,
  225,
  195,
  376,
  17,
  3,
  4,
  12,
  20,
  35,
  62,
  53,
  47,
  83,
  75,
  68,
  119,
  201,
  107,
  207,
  9,
  15,
  13,
  23,
  38,
  67,
  58,
  103,
  90,
  161,
  72,
  127,
  117,
  110,
  209,
  206,
  16,
  45,
  21,
  39,
  69,
  64,
  114,
  99,
  87,
  158,
  140,
  252,
  212,
  199,
  387,
  365,
  26,
  75,
  36,
  68,
  65,
  115,
  101,
  179,
  164,
  155,
  264,
  246,
  226,
  395,
  382,
  362,
  9,
  66,
  30,
  59,
  56,
  102,
  185,
  173,
  265,
  142,
  253,
  232,
  400,
  388,
  378,
  445,
  16,
  111,
  54,
  52,
  100,
  184,
  178,
  160,
  133,
  257,
  244,
  228,
  217,
  385,
  366,
  715,
  10,
  98,
  48,
  91,
  88,
  165,
  157,
  148,
  261,
  248,
  407,
  397,
  372,
  380,
  889,
  884,
  8,
  85,
  84,
  81,
  159,
  156,
  143,
  260,
  249,
  427,
  401,
  392,
  383,
  727,
  713,
  708,
  7,
  154,
  76,
  73,
  141,
  131,
  256,
  245,
  426,
  406,
  394,
  384,
  735,
  359,
  710,
  352,
  11,
  139,
  129,
  67,
  125,
  247,
  233,
  229,
  219,
  393,
  743,
  737,
  720,
  885,
  882,
  439,
  4,
  243,
  120,
  118,
  115,
  227,
  223,
  396,
  746,
  742,
  736,
  721,
  712,
  706,
  223,
  436,
  6,
  202,
  224,
  222,
  218,
  216,
  389,
  386,
  381,
  364,
  888,
  443,
  707,
  440,
  437,
  1728,
  4,
  747,
  211,
  210,
  208,
  370,
  379,
  734,
  723,
  714,
  1735,
  883,
  877,
  876,
  3459,
  865,
  2,
  377,
  369,
  102,
  187,
  726,
  722,
  358,
  711,
  709,
  866,
  1734,
  871,
  3458,
  870,
  434,
  0,
  12,
  10,
  7,
  11,
  10,
  17,
  11,
  9,
  13,
  12,
  10,
  7,
  5,
  3,
  1,
  3
];
u0.t24HB = [
  15,
  13,
  46,
  80,
  146,
  262,
  248,
  434,
  426,
  669,
  653,
  649,
  621,
  517,
  1032,
  88,
  14,
  12,
  21,
  38,
  71,
  130,
  122,
  216,
  209,
  198,
  327,
  345,
  319,
  297,
  279,
  42,
  47,
  22,
  41,
  74,
  68,
  128,
  120,
  221,
  207,
  194,
  182,
  340,
  315,
  295,
  541,
  18,
  81,
  39,
  75,
  70,
  134,
  125,
  116,
  220,
  204,
  190,
  178,
  325,
  311,
  293,
  271,
  16,
  147,
  72,
  69,
  135,
  127,
  118,
  112,
  210,
  200,
  188,
  352,
  323,
  306,
  285,
  540,
  14,
  263,
  66,
  129,
  126,
  119,
  114,
  214,
  202,
  192,
  180,
  341,
  317,
  301,
  281,
  262,
  12,
  249,
  123,
  121,
  117,
  113,
  215,
  206,
  195,
  185,
  347,
  330,
  308,
  291,
  272,
  520,
  10,
  435,
  115,
  111,
  109,
  211,
  203,
  196,
  187,
  353,
  332,
  313,
  298,
  283,
  531,
  381,
  17,
  427,
  212,
  208,
  205,
  201,
  193,
  186,
  177,
  169,
  320,
  303,
  286,
  268,
  514,
  377,
  16,
  335,
  199,
  197,
  191,
  189,
  181,
  174,
  333,
  321,
  305,
  289,
  275,
  521,
  379,
  371,
  11,
  668,
  184,
  183,
  179,
  175,
  344,
  331,
  314,
  304,
  290,
  277,
  530,
  383,
  373,
  366,
  10,
  652,
  346,
  171,
  168,
  164,
  318,
  309,
  299,
  287,
  276,
  263,
  513,
  375,
  368,
  362,
  6,
  648,
  322,
  316,
  312,
  307,
  302,
  292,
  284,
  269,
  261,
  512,
  376,
  370,
  364,
  359,
  4,
  620,
  300,
  296,
  294,
  288,
  282,
  273,
  266,
  515,
  380,
  374,
  369,
  365,
  361,
  357,
  2,
  1033,
  280,
  278,
  274,
  267,
  264,
  259,
  382,
  378,
  372,
  367,
  363,
  360,
  358,
  356,
  0,
  43,
  20,
  19,
  17,
  15,
  13,
  11,
  9,
  7,
  6,
  4,
  7,
  5,
  3,
  1,
  3
];
u0.t32HB = [
  1 << 0,
  5 << 1,
  4 << 1,
  5 << 2,
  6 << 1,
  5 << 2,
  4 << 2,
  4 << 3,
  7 << 1,
  3 << 2,
  6 << 2,
  0 << 3,
  7 << 2,
  2 << 3,
  3 << 3,
  1 << 4
];
u0.t33HB = [
  15 << 0,
  14 << 1,
  13 << 1,
  12 << 2,
  11 << 1,
  10 << 2,
  9 << 2,
  8 << 3,
  7 << 1,
  6 << 2,
  5 << 2,
  4 << 3,
  3 << 2,
  2 << 3,
  1 << 3,
  0 << 4
];
u0.t1l = [
  1,
  4,
  3,
  5
];
u0.t2l = [
  1,
  4,
  7,
  4,
  5,
  7,
  6,
  7,
  8
];
u0.t3l = [
  2,
  3,
  7,
  4,
  4,
  7,
  6,
  7,
  8
];
u0.t5l = [
  1,
  4,
  7,
  8,
  4,
  5,
  8,
  9,
  7,
  8,
  9,
  10,
  8,
  8,
  9,
  10
];
u0.t6l = [
  3,
  4,
  6,
  8,
  4,
  4,
  6,
  7,
  5,
  6,
  7,
  8,
  7,
  7,
  8,
  9
];
u0.t7l = [
  1,
  4,
  7,
  9,
  9,
  10,
  4,
  6,
  8,
  9,
  9,
  10,
  7,
  7,
  9,
  10,
  10,
  11,
  8,
  9,
  10,
  11,
  11,
  11,
  8,
  9,
  10,
  11,
  11,
  12,
  9,
  10,
  11,
  12,
  12,
  12
];
u0.t8l = [
  2,
  4,
  7,
  9,
  9,
  10,
  4,
  4,
  6,
  10,
  10,
  10,
  7,
  6,
  8,
  10,
  10,
  11,
  9,
  10,
  10,
  11,
  11,
  12,
  9,
  9,
  10,
  11,
  12,
  12,
  10,
  10,
  11,
  11,
  13,
  13
];
u0.t9l = [
  3,
  4,
  6,
  7,
  9,
  10,
  4,
  5,
  6,
  7,
  8,
  10,
  5,
  6,
  7,
  8,
  9,
  10,
  7,
  7,
  8,
  9,
  9,
  10,
  8,
  8,
  9,
  9,
  10,
  11,
  9,
  9,
  10,
  10,
  11,
  11
];
u0.t10l = [
  1,
  4,
  7,
  9,
  10,
  10,
  10,
  11,
  4,
  6,
  8,
  9,
  10,
  11,
  10,
  10,
  7,
  8,
  9,
  10,
  11,
  12,
  11,
  11,
  8,
  9,
  10,
  11,
  12,
  12,
  11,
  12,
  9,
  10,
  11,
  12,
  12,
  12,
  12,
  12,
  10,
  11,
  12,
  12,
  13,
  13,
  12,
  13,
  9,
  10,
  11,
  12,
  12,
  12,
  13,
  13,
  10,
  10,
  11,
  12,
  12,
  13,
  13,
  13
];
u0.t11l = [
  2,
  4,
  6,
  8,
  9,
  10,
  9,
  10,
  4,
  5,
  6,
  8,
  10,
  10,
  9,
  10,
  6,
  7,
  8,
  9,
  10,
  11,
  10,
  10,
  8,
  8,
  9,
  11,
  10,
  12,
  10,
  11,
  9,
  10,
  10,
  11,
  11,
  12,
  11,
  12,
  9,
  10,
  11,
  12,
  12,
  13,
  12,
  13,
  9,
  9,
  9,
  10,
  11,
  12,
  12,
  12,
  9,
  9,
  10,
  11,
  12,
  12,
  12,
  12
];
u0.t12l = [
  4,
  4,
  6,
  8,
  9,
  10,
  10,
  10,
  4,
  5,
  6,
  7,
  9,
  9,
  10,
  10,
  6,
  6,
  7,
  8,
  9,
  10,
  9,
  10,
  7,
  7,
  8,
  8,
  9,
  10,
  10,
  10,
  8,
  8,
  9,
  9,
  10,
  10,
  10,
  11,
  9,
  9,
  10,
  10,
  10,
  11,
  10,
  11,
  9,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12
];
u0.t13l = [
  1,
  5,
  7,
  8,
  9,
  10,
  10,
  11,
  10,
  11,
  12,
  12,
  13,
  13,
  14,
  14,
  4,
  6,
  8,
  9,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  13,
  14,
  14,
  14,
  7,
  8,
  9,
  10,
  11,
  11,
  12,
  12,
  11,
  12,
  12,
  13,
  13,
  14,
  15,
  15,
  8,
  9,
  10,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  15,
  15,
  9,
  9,
  11,
  11,
  12,
  12,
  13,
  13,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  16,
  10,
  10,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  13,
  15,
  15,
  16,
  16,
  10,
  11,
  12,
  12,
  13,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  15,
  15,
  16,
  16,
  11,
  11,
  12,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  16,
  18,
  18,
  10,
  10,
  11,
  12,
  12,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  16,
  17,
  17,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  15,
  14,
  15,
  15,
  16,
  16,
  16,
  18,
  17,
  11,
  12,
  12,
  13,
  13,
  14,
  14,
  15,
  14,
  15,
  16,
  15,
  16,
  17,
  18,
  19,
  12,
  12,
  12,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  16,
  17,
  17,
  17,
  18,
  12,
  13,
  13,
  14,
  14,
  15,
  14,
  15,
  16,
  16,
  17,
  17,
  17,
  18,
  18,
  18,
  13,
  13,
  14,
  15,
  15,
  15,
  16,
  16,
  16,
  16,
  16,
  17,
  18,
  17,
  18,
  18,
  14,
  14,
  14,
  15,
  15,
  15,
  17,
  16,
  16,
  19,
  17,
  17,
  17,
  19,
  18,
  18,
  13,
  14,
  15,
  16,
  16,
  16,
  17,
  16,
  17,
  17,
  18,
  18,
  21,
  20,
  21,
  18
];
u0.t15l = [
  3,
  5,
  6,
  8,
  8,
  9,
  10,
  10,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  14,
  5,
  5,
  7,
  8,
  9,
  9,
  10,
  10,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  6,
  7,
  7,
  8,
  9,
  9,
  10,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  9,
  9,
  9,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  10,
  9,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  14,
  14,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  14,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  14,
  14,
  14,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  15,
  14,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  15,
  12,
  12,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  14,
  15,
  15,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  14,
  15,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  15
];
u0.t16_5l = [
  1,
  5,
  7,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  14,
  11,
  4,
  6,
  8,
  9,
  10,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  14,
  13,
  14,
  11,
  7,
  8,
  9,
  10,
  11,
  11,
  12,
  12,
  13,
  12,
  13,
  13,
  13,
  14,
  14,
  12,
  9,
  9,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  14,
  14,
  14,
  15,
  15,
  13,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  14,
  15,
  15,
  15,
  12,
  10,
  10,
  11,
  11,
  12,
  13,
  13,
  14,
  13,
  14,
  14,
  15,
  15,
  15,
  16,
  13,
  11,
  11,
  11,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  16,
  13,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  17,
  17,
  13,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  13,
  12,
  12,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  15,
  16,
  15,
  14,
  12,
  13,
  12,
  13,
  14,
  14,
  14,
  14,
  15,
  16,
  16,
  16,
  17,
  17,
  16,
  13,
  13,
  13,
  13,
  13,
  14,
  14,
  15,
  16,
  16,
  16,
  16,
  16,
  16,
  15,
  16,
  14,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  15,
  17,
  16,
  16,
  16,
  16,
  18,
  14,
  15,
  14,
  14,
  14,
  15,
  15,
  16,
  16,
  16,
  18,
  17,
  17,
  17,
  19,
  17,
  14,
  14,
  15,
  13,
  14,
  16,
  16,
  15,
  16,
  16,
  17,
  18,
  17,
  19,
  17,
  16,
  14,
  11,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  14,
  14,
  14,
  12
];
u0.t16l = [
  1,
  5,
  7,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  14,
  10,
  4,
  6,
  8,
  9,
  10,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  14,
  13,
  14,
  10,
  7,
  8,
  9,
  10,
  11,
  11,
  12,
  12,
  13,
  12,
  13,
  13,
  13,
  14,
  14,
  11,
  9,
  9,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  14,
  14,
  14,
  15,
  15,
  12,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  14,
  15,
  15,
  15,
  11,
  10,
  10,
  11,
  11,
  12,
  13,
  13,
  14,
  13,
  14,
  14,
  15,
  15,
  15,
  16,
  12,
  11,
  11,
  11,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  16,
  12,
  11,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  17,
  17,
  12,
  11,
  12,
  12,
  13,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  16,
  16,
  12,
  12,
  12,
  12,
  13,
  13,
  14,
  14,
  15,
  15,
  15,
  15,
  16,
  15,
  16,
  15,
  13,
  12,
  13,
  12,
  13,
  14,
  14,
  14,
  14,
  15,
  16,
  16,
  16,
  17,
  17,
  16,
  12,
  13,
  13,
  13,
  13,
  14,
  14,
  15,
  16,
  16,
  16,
  16,
  16,
  16,
  15,
  16,
  13,
  13,
  14,
  14,
  14,
  14,
  15,
  15,
  15,
  15,
  17,
  16,
  16,
  16,
  16,
  18,
  13,
  15,
  14,
  14,
  14,
  15,
  15,
  16,
  16,
  16,
  18,
  17,
  17,
  17,
  19,
  17,
  13,
  14,
  15,
  13,
  14,
  16,
  16,
  15,
  16,
  16,
  17,
  18,
  17,
  19,
  17,
  16,
  13,
  10,
  10,
  10,
  11,
  11,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  10
];
u0.t24l = [
  4,
  5,
  7,
  8,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  13,
  10,
  5,
  6,
  7,
  8,
  9,
  10,
  10,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  10,
  7,
  7,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  13,
  9,
  8,
  8,
  9,
  9,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  9,
  9,
  9,
  9,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  9,
  10,
  9,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  9,
  10,
  10,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  13,
  9,
  11,
  10,
  10,
  10,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  10,
  11,
  11,
  11,
  11,
  11,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  13,
  13,
  10,
  11,
  11,
  11,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  10,
  12,
  11,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  10,
  12,
  12,
  11,
  11,
  11,
  12,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  10,
  12,
  12,
  12,
  12,
  12,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  13,
  10,
  12,
  12,
  12,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  10,
  13,
  12,
  12,
  12,
  12,
  12,
  12,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  13,
  10,
  9,
  9,
  9,
  9,
  9,
  9,
  9,
  9,
  9,
  9,
  9,
  10,
  10,
  10,
  10,
  6
];
u0.t32l = [
  1 + 0,
  4 + 1,
  4 + 1,
  5 + 2,
  4 + 1,
  6 + 2,
  5 + 2,
  6 + 3,
  4 + 1,
  5 + 2,
  5 + 2,
  6 + 3,
  5 + 2,
  6 + 3,
  6 + 3,
  6 + 4
];
u0.t33l = [
  4 + 0,
  4 + 1,
  4 + 1,
  4 + 2,
  4 + 1,
  4 + 2,
  4 + 2,
  4 + 3,
  4 + 1,
  4 + 2,
  4 + 2,
  4 + 3,
  4 + 2,
  4 + 3,
  4 + 3,
  4 + 4
];
u0.ht = [
  /* xlen, linmax, table, hlen */
  new q0(0, 0, null, null),
  new q0(2, 0, u0.t1HB, u0.t1l),
  new q0(3, 0, u0.t2HB, u0.t2l),
  new q0(3, 0, u0.t3HB, u0.t3l),
  new q0(0, 0, null, null),
  /* Apparently not used */
  new q0(4, 0, u0.t5HB, u0.t5l),
  new q0(4, 0, u0.t6HB, u0.t6l),
  new q0(6, 0, u0.t7HB, u0.t7l),
  new q0(6, 0, u0.t8HB, u0.t8l),
  new q0(6, 0, u0.t9HB, u0.t9l),
  new q0(8, 0, u0.t10HB, u0.t10l),
  new q0(8, 0, u0.t11HB, u0.t11l),
  new q0(8, 0, u0.t12HB, u0.t12l),
  new q0(16, 0, u0.t13HB, u0.t13l),
  new q0(0, 0, null, u0.t16_5l),
  /* Apparently not used */
  new q0(16, 0, u0.t15HB, u0.t15l),
  new q0(1, 1, u0.t16HB, u0.t16l),
  new q0(2, 3, u0.t16HB, u0.t16l),
  new q0(3, 7, u0.t16HB, u0.t16l),
  new q0(4, 15, u0.t16HB, u0.t16l),
  new q0(6, 63, u0.t16HB, u0.t16l),
  new q0(8, 255, u0.t16HB, u0.t16l),
  new q0(10, 1023, u0.t16HB, u0.t16l),
  new q0(13, 8191, u0.t16HB, u0.t16l),
  new q0(4, 15, u0.t24HB, u0.t24l),
  new q0(5, 31, u0.t24HB, u0.t24l),
  new q0(6, 63, u0.t24HB, u0.t24l),
  new q0(7, 127, u0.t24HB, u0.t24l),
  new q0(8, 255, u0.t24HB, u0.t24l),
  new q0(9, 511, u0.t24HB, u0.t24l),
  new q0(11, 2047, u0.t24HB, u0.t24l),
  new q0(13, 8191, u0.t24HB, u0.t24l),
  new q0(0, 0, u0.t32HB, u0.t32l),
  new q0(0, 0, u0.t33HB, u0.t33l)
];
u0.largetbl = [
  65540,
  327685,
  458759,
  589832,
  655369,
  655370,
  720906,
  720907,
  786443,
  786444,
  786444,
  851980,
  851980,
  851980,
  917517,
  655370,
  262149,
  393222,
  524295,
  589832,
  655369,
  720906,
  720906,
  720907,
  786443,
  786443,
  786444,
  851980,
  917516,
  851980,
  917516,
  655370,
  458759,
  524295,
  589832,
  655369,
  720905,
  720906,
  786442,
  786443,
  851979,
  786443,
  851979,
  851980,
  851980,
  917516,
  917517,
  720905,
  589832,
  589832,
  655369,
  720905,
  720906,
  786442,
  786442,
  786443,
  851979,
  851979,
  917515,
  917516,
  917516,
  983052,
  983052,
  786441,
  655369,
  655369,
  720905,
  720906,
  786442,
  786442,
  851978,
  851979,
  851979,
  917515,
  917516,
  917516,
  983052,
  983052,
  983053,
  720905,
  655370,
  655369,
  720906,
  720906,
  786442,
  851978,
  851979,
  917515,
  851979,
  917515,
  917516,
  983052,
  983052,
  983052,
  1048588,
  786441,
  720906,
  720906,
  720906,
  786442,
  851978,
  851979,
  851979,
  851979,
  917515,
  917516,
  917516,
  917516,
  983052,
  983052,
  1048589,
  786441,
  720907,
  720906,
  786442,
  786442,
  851979,
  851979,
  851979,
  917515,
  917516,
  983052,
  983052,
  983052,
  983052,
  1114125,
  1114125,
  786442,
  720907,
  786443,
  786443,
  851979,
  851979,
  851979,
  917515,
  917515,
  983051,
  983052,
  983052,
  983052,
  1048588,
  1048589,
  1048589,
  786442,
  786443,
  786443,
  786443,
  851979,
  851979,
  917515,
  917515,
  983052,
  983052,
  983052,
  983052,
  1048588,
  983053,
  1048589,
  983053,
  851978,
  786444,
  851979,
  786443,
  851979,
  917515,
  917516,
  917516,
  917516,
  983052,
  1048588,
  1048588,
  1048589,
  1114125,
  1114125,
  1048589,
  786442,
  851980,
  851980,
  851979,
  851979,
  917515,
  917516,
  983052,
  1048588,
  1048588,
  1048588,
  1048588,
  1048589,
  1048589,
  983053,
  1048589,
  851978,
  851980,
  917516,
  917516,
  917516,
  917516,
  983052,
  983052,
  983052,
  983052,
  1114124,
  1048589,
  1048589,
  1048589,
  1048589,
  1179661,
  851978,
  983052,
  917516,
  917516,
  917516,
  983052,
  983052,
  1048588,
  1048588,
  1048589,
  1179661,
  1114125,
  1114125,
  1114125,
  1245197,
  1114125,
  851978,
  917517,
  983052,
  851980,
  917516,
  1048588,
  1048588,
  983052,
  1048589,
  1048589,
  1114125,
  1179661,
  1114125,
  1245197,
  1114125,
  1048589,
  851978,
  655369,
  655369,
  655369,
  720905,
  720905,
  786441,
  786441,
  786441,
  851977,
  851977,
  851977,
  851978,
  851978,
  851978,
  851978,
  655366
];
u0.table23 = [
  65538,
  262147,
  458759,
  262148,
  327684,
  458759,
  393222,
  458759,
  524296
];
u0.table56 = [
  65539,
  262148,
  458758,
  524296,
  262148,
  327684,
  524294,
  589831,
  458757,
  524294,
  589831,
  655368,
  524295,
  524295,
  589832,
  655369
];
u0.bitrate_table = [
  [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1],
  /* MPEG 2 */
  [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1],
  /* MPEG 1 */
  [0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1]
  /* MPEG 2.5 */
];
u0.samplerate_table = [
  [22050, 24e3, 16e3, -1],
  [44100, 48e3, 32e3, -1],
  [11025, 12e3, 8e3, -1]
];
u0.scfsi_band = [0, 6, 11, 16, 21];
var ke = u0, we, _a;
function qa() {
  if (_a)
    return we;
  _a = 1;
  var m = Oa, x = Q0, y = x.VbrMode, K = x.Float, i0 = x.Util, P = x.new_float, z = x.new_int, D = x.assert, W = t1(), f0 = Ya, R = ue;
  c.Q_MAX = 256 + 1, c.Q_MAX2 = 116, c.LARGE_BITS = 1e5, c.IXMAX_VAL = 8206;
  function c() {
    var H = Xe(), n0 = null, Q = null, t0 = null;
    this.setModules = function(S, C, F) {
      n0 = S, Q = C, t0 = F;
    };
    function j(S) {
      return D(0 <= S + c.Q_MAX2 && S < c.Q_MAX), V[S + c.Q_MAX2];
    }
    this.IPOW20 = function(S) {
      return D(0 <= S && S < c.Q_MAX), O[S];
    };
    var M = 2220446049250313e-31, v = c.IXMAX_VAL, h = v + 2, A = c.Q_MAX, e = c.Q_MAX2;
    c.LARGE_BITS;
    var l = 100;
    this.nr_of_sfb_block = [
      [[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]],
      [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]],
      [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]],
      [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]],
      [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]],
      [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]
    ];
    var B = [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      2,
      2,
      3,
      3,
      3,
      2,
      0
    ];
    this.pretab = B, this.sfBandIndex = [
      // Table B.2.b: 22.05 kHz
      new m(
        [
          0,
          6,
          12,
          18,
          24,
          30,
          36,
          44,
          54,
          66,
          80,
          96,
          116,
          140,
          168,
          200,
          238,
          284,
          336,
          396,
          464,
          522,
          576
        ],
        [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        //  sfb12 pseudo sub bands
      ),
      /* Table B.2.c: 24 kHz */
      /* docs: 332. mpg123(broken): 330 */
      new m(
        [
          0,
          6,
          12,
          18,
          24,
          30,
          36,
          44,
          54,
          66,
          80,
          96,
          114,
          136,
          162,
          194,
          232,
          278,
          332,
          394,
          464,
          540,
          576
        ],
        [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* Table B.2.a: 16 kHz */
      new m(
        [
          0,
          6,
          12,
          18,
          24,
          30,
          36,
          44,
          54,
          66,
          80,
          96,
          116,
          140,
          168,
          200,
          238,
          284,
          336,
          396,
          464,
          522,
          576
        ],
        [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* Table B.8.b: 44.1 kHz */
      new m(
        [
          0,
          4,
          8,
          12,
          16,
          20,
          24,
          30,
          36,
          44,
          52,
          62,
          74,
          90,
          110,
          134,
          162,
          196,
          238,
          288,
          342,
          418,
          576
        ],
        [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* Table B.8.c: 48 kHz */
      new m(
        [
          0,
          4,
          8,
          12,
          16,
          20,
          24,
          30,
          36,
          42,
          50,
          60,
          72,
          88,
          106,
          128,
          156,
          190,
          230,
          276,
          330,
          384,
          576
        ],
        [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* Table B.8.a: 32 kHz */
      new m(
        [
          0,
          4,
          8,
          12,
          16,
          20,
          24,
          30,
          36,
          44,
          54,
          66,
          82,
          102,
          126,
          156,
          194,
          240,
          296,
          364,
          448,
          550,
          576
        ],
        [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* MPEG-2.5 11.025 kHz */
      new m(
        [
          0,
          6,
          12,
          18,
          24,
          30,
          36,
          44,
          54,
          66,
          80,
          96,
          116,
          140,
          168,
          200,
          238,
          284,
          336,
          396,
          464,
          522,
          576
        ],
        [
          0 / 3,
          12 / 3,
          24 / 3,
          36 / 3,
          54 / 3,
          78 / 3,
          108 / 3,
          144 / 3,
          186 / 3,
          240 / 3,
          312 / 3,
          402 / 3,
          522 / 3,
          576 / 3
        ],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* MPEG-2.5 12 kHz */
      new m(
        [
          0,
          6,
          12,
          18,
          24,
          30,
          36,
          44,
          54,
          66,
          80,
          96,
          116,
          140,
          168,
          200,
          238,
          284,
          336,
          396,
          464,
          522,
          576
        ],
        [
          0 / 3,
          12 / 3,
          24 / 3,
          36 / 3,
          54 / 3,
          78 / 3,
          108 / 3,
          144 / 3,
          186 / 3,
          240 / 3,
          312 / 3,
          402 / 3,
          522 / 3,
          576 / 3
        ],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      ),
      /* MPEG-2.5 8 kHz */
      new m(
        [
          0,
          12,
          24,
          36,
          48,
          60,
          72,
          88,
          108,
          132,
          160,
          192,
          232,
          280,
          336,
          400,
          476,
          566,
          568,
          570,
          572,
          574,
          576
        ],
        [
          0 / 3,
          24 / 3,
          48 / 3,
          72 / 3,
          108 / 3,
          156 / 3,
          216 / 3,
          288 / 3,
          372 / 3,
          480 / 3,
          486 / 3,
          492 / 3,
          498 / 3,
          576 / 3
        ],
        [0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0]
        /*  sfb12 pseudo sub bands */
      )
    ];
    var V = P(A + e + 1), O = P(A), w = P(h), L = P(h);
    this.adj43 = L;
    function v0(S, C) {
      var F = t0.ATHformula(C, S);
      return F -= l, F = Math.pow(10, F / 10 + S.ATHlower), F;
    }
    function b(S) {
      for (var C = S.internal_flags.ATH.l, F = S.internal_flags.ATH.psfb21, N = S.internal_flags.ATH.s, U = S.internal_flags.ATH.psfb12, T = S.internal_flags, s = S.out_samplerate, n = 0; n < W.SBMAX_l; n++) {
        var r = T.scalefac_band.l[n], i = T.scalefac_band.l[n + 1];
        C[n] = K.MAX_VALUE;
        for (var f = r; f < i; f++) {
          var q = f * s / 1152, g = v0(S, q);
          C[n] = Math.min(C[n], g);
        }
      }
      for (var n = 0; n < W.PSFB21; n++) {
        var r = T.scalefac_band.psfb21[n], i = T.scalefac_band.psfb21[n + 1];
        F[n] = K.MAX_VALUE;
        for (var f = r; f < i; f++) {
          var q = f * s / 1152, g = v0(S, q);
          F[n] = Math.min(F[n], g);
        }
      }
      for (var n = 0; n < W.SBMAX_s; n++) {
        var r = T.scalefac_band.s[n], i = T.scalefac_band.s[n + 1];
        N[n] = K.MAX_VALUE;
        for (var f = r; f < i; f++) {
          var q = f * s / 384, g = v0(S, q);
          N[n] = Math.min(N[n], g);
        }
        N[n] *= T.scalefac_band.s[n + 1] - T.scalefac_band.s[n];
      }
      for (var n = 0; n < W.PSFB12; n++) {
        var r = T.scalefac_band.psfb12[n], i = T.scalefac_band.psfb12[n + 1];
        U[n] = K.MAX_VALUE;
        for (var f = r; f < i; f++) {
          var q = f * s / 384, g = v0(S, q);
          U[n] = Math.min(U[n], g);
        }
        U[n] *= T.scalefac_band.s[13] - T.scalefac_band.s[12];
      }
      if (S.noATH) {
        for (var n = 0; n < W.SBMAX_l; n++)
          C[n] = 1e-20;
        for (var n = 0; n < W.PSFB21; n++)
          F[n] = 1e-20;
        for (var n = 0; n < W.SBMAX_s; n++)
          N[n] = 1e-20;
        for (var n = 0; n < W.PSFB12; n++)
          U[n] = 1e-20;
      }
      T.ATH.floor = 10 * Math.log10(v0(S, -1));
    }
    this.iteration_init = function(S) {
      var C = S.internal_flags, F = C.l3_side, N;
      if (C.iteration_init_init == 0) {
        for (C.iteration_init_init = 1, F.main_data_begin = 0, b(S), w[0] = 0, N = 1; N < h; N++)
          w[N] = Math.pow(N, 4 / 3);
        for (N = 0; N < h - 1; N++)
          L[N] = N + 1 - Math.pow(
            0.5 * (w[N] + w[N + 1]),
            0.75
          );
        for (L[N] = 0.5, N = 0; N < A; N++)
          O[N] = Math.pow(2, (N - 210) * -0.1875);
        for (N = 0; N <= A + e; N++)
          V[N] = Math.pow(2, (N - 210 - e) * 0.25);
        n0.huffman_init(C);
        {
          var U, T, s, n;
          for (N = S.exp_nspsytune >> 2 & 63, N >= 32 && (N -= 64), U = Math.pow(10, N / 4 / 10), N = S.exp_nspsytune >> 8 & 63, N >= 32 && (N -= 64), T = Math.pow(10, N / 4 / 10), N = S.exp_nspsytune >> 14 & 63, N >= 32 && (N -= 64), s = Math.pow(10, N / 4 / 10), N = S.exp_nspsytune >> 20 & 63, N >= 32 && (N -= 64), n = s * Math.pow(10, N / 4 / 10), N = 0; N < W.SBMAX_l; N++) {
            var r;
            N <= 6 ? r = U : N <= 13 ? r = T : N <= 20 ? r = s : r = n, C.nsPsy.longfact[N] = r;
          }
          for (N = 0; N < W.SBMAX_s; N++) {
            var r;
            N <= 5 ? r = U : N <= 10 ? r = T : N <= 11 ? r = s : r = n, C.nsPsy.shortfact[N] = r;
          }
        }
      }
    }, this.on_pe = function(S, C, F, N, U, T) {
      var s = S.internal_flags, n = 0, r, i = z(2), f, q = new f0(n), g = Q.ResvMaxBits(S, N, q, T);
      n = q.bits;
      var p = n + g;
      for (p > R.MAX_BITS_PER_GRANULE && (p = R.MAX_BITS_PER_GRANULE), r = 0, f = 0; f < s.channels_out; ++f)
        F[f] = Math.min(
          R.MAX_BITS_PER_CHANNEL,
          n / s.channels_out
        ), i[f] = 0 | F[f] * C[U][f] / 700 - F[f], i[f] > N * 3 / 4 && (i[f] = N * 3 / 4), i[f] < 0 && (i[f] = 0), i[f] + F[f] > R.MAX_BITS_PER_CHANNEL && (i[f] = Math.max(
          0,
          R.MAX_BITS_PER_CHANNEL - F[f]
        )), r += i[f];
      if (r > g)
        for (f = 0; f < s.channels_out; ++f)
          i[f] = g * i[f] / r;
      for (f = 0; f < s.channels_out; ++f)
        F[f] += i[f], g -= i[f];
      for (r = 0, f = 0; f < s.channels_out; ++f)
        r += F[f];
      if (r > R.MAX_BITS_PER_GRANULE) {
        var G = 0;
        for (f = 0; f < s.channels_out; ++f)
          F[f] *= R.MAX_BITS_PER_GRANULE, F[f] /= r, G += F[f];
      }
      return p;
    }, this.reduce_side = function(S, C, F, N) {
      D(S[0] + S[1] <= R.MAX_BITS_PER_GRANULE);
      var U = 0.33 * (0.5 - C) / 0.5;
      U < 0 && (U = 0), U > 0.5 && (U = 0.5);
      var T = 0 | U * 0.5 * (S[0] + S[1]);
      T > R.MAX_BITS_PER_CHANNEL - S[0] && (T = R.MAX_BITS_PER_CHANNEL - S[0]), T < 0 && (T = 0), S[1] >= 125 && (S[1] - T > 125 ? (S[0] < F && (S[0] += T), S[1] -= T) : (S[0] += S[1] - 125, S[1] = 125)), T = S[0] + S[1], T > N && (S[0] = N * S[0] / T, S[1] = N * S[1] / T), D(S[0] <= R.MAX_BITS_PER_CHANNEL), D(S[1] <= R.MAX_BITS_PER_CHANNEL), D(S[0] + S[1] <= R.MAX_BITS_PER_GRANULE);
    }, this.athAdjust = function(S, C, F) {
      var N = 90.30873362, U = 94.82444863, T = i0.FAST_LOG10_X(C, 10), s = S * S, n = 0;
      return T -= F, s > 1e-20 && (n = 1 + i0.FAST_LOG10_X(s, 10 / N)), n < 0 && (n = 0), T *= n, T += F + N - U, Math.pow(10, 0.1 * T);
    }, this.calc_xmin = function(S, C, F, N) {
      var U = 0, T = S.internal_flags, s, n = 0, r = 0, i = T.ATH, f = F.xr, q = S.VBR == y.vbr_mtrh ? 1 : 0, g = T.masking_lower;
      for ((S.VBR == y.vbr_mtrh || S.VBR == y.vbr_mt) && (g = 1), s = 0; s < F.psy_lmax; s++) {
        var p, G, s0, h0, S0, M0;
        S.VBR == y.vbr_rh || S.VBR == y.vbr_mtrh ? G = athAdjust(i.adjust, i.l[s], i.floor) : G = i.adjust * i.l[s], S0 = F.width[s], s0 = G / S0, h0 = M, M0 = S0 >> 1, p = 0;
        do {
          var R0, A0;
          R0 = f[n] * f[n], p += R0, h0 += R0 < s0 ? R0 : s0, n++, A0 = f[n] * f[n], p += A0, h0 += A0 < s0 ? A0 : s0, n++;
        } while (--M0 > 0);
        if (p > G && r++, s == W.SBPSY_l) {
          var w0 = G * T.nsPsy.longfact[s];
          h0 < w0 && (h0 = w0);
        }
        if (q != 0 && (G = h0), !S.ATHonly) {
          var $0 = C.en.l[s];
          if ($0 > 0) {
            var w0;
            w0 = p * C.thm.l[s] * g / $0, q != 0 && (w0 *= T.nsPsy.longfact[s]), G < w0 && (G = w0);
          }
        }
        q != 0 ? N[U++] = G : N[U++] = G * T.nsPsy.longfact[s];
      }
      var f1 = 575;
      if (F.block_type != W.SHORT_TYPE)
        for (var t = 576; t-- != 0 && H.EQ(f[t], 0); )
          f1 = t;
      F.max_nonzero_coeff = f1;
      for (var _ = F.sfb_smin; s < F.psymax; _++, s += 3) {
        var S0, d0, E0;
        for (S.VBR == y.vbr_rh || S.VBR == y.vbr_mtrh ? E0 = athAdjust(i.adjust, i.s[_], i.floor) : E0 = i.adjust * i.s[_], S0 = F.width[s], d0 = 0; d0 < 3; d0++) {
          var p = 0, G, s0, h0, M0 = S0 >> 1;
          s0 = E0 / S0, h0 = M;
          do {
            var R0, A0;
            R0 = f[n] * f[n], p += R0, h0 += R0 < s0 ? R0 : s0, n++, A0 = f[n] * f[n], p += A0, h0 += A0 < s0 ? A0 : s0, n++;
          } while (--M0 > 0);
          if (p > E0 && r++, _ == W.SBPSY_s) {
            var w0 = E0 * T.nsPsy.shortfact[_];
            h0 < w0 && (h0 = w0);
          }
          if (q != 0 ? G = h0 : G = E0, !S.ATHonly && !S.ATHshort) {
            var $0 = C.en.s[_][d0];
            if ($0 > 0) {
              var w0;
              w0 = p * C.thm.s[_][d0] * g / $0, q != 0 && (w0 *= T.nsPsy.shortfact[_]), G < w0 && (G = w0);
            }
          }
          q != 0 ? N[U++] = G : N[U++] = G * T.nsPsy.shortfact[_];
        }
        S.useTemporal && (N[U - 3] > N[U - 3 + 1] && (N[U - 3 + 1] += (N[U - 3] - N[U - 3 + 1]) * T.decay), N[U - 3 + 1] > N[U - 3 + 2] && (N[U - 3 + 2] += (N[U - 3 + 1] - N[U - 3 + 2]) * T.decay));
      }
      return r;
    };
    function a(S) {
      this.s = S;
    }
    this.calc_noise_core = function(S, C, F, N) {
      var U = 0, T = C.s, s = S.l3_enc;
      if (T > S.count1)
        for (; F-- != 0; ) {
          var n;
          n = S.xr[T], T++, U += n * n, n = S.xr[T], T++, U += n * n;
        }
      else if (T > S.big_values) {
        var r = P(2);
        for (r[0] = 0, r[1] = N; F-- != 0; ) {
          var n;
          n = Math.abs(S.xr[T]) - r[s[T]], T++, U += n * n, n = Math.abs(S.xr[T]) - r[s[T]], T++, U += n * n;
        }
      } else
        for (; F-- != 0; ) {
          var n;
          n = Math.abs(S.xr[T]) - w[s[T]] * N, T++, U += n * n, n = Math.abs(S.xr[T]) - w[s[T]] * N, T++, U += n * n;
        }
      return C.s = T, U;
    }, this.calc_noise = function(S, C, F, N, U) {
      var T = 0, s = 0, n, r, i = 0, f = 0, q = 0, g = -20, p = 0, G = S.scalefac, s0 = 0;
      for (N.over_SSD = 0, n = 0; n < S.psymax; n++) {
        var h0 = S.global_gain - (G[s0++] + (S.preflag != 0 ? B[n] : 0) << S.scalefac_scale + 1) - S.subblock_gain[S.window[n]] * 8, S0 = 0;
        if (U != null && U.step[n] == h0)
          S0 = U.noise[n], p += S.width[n], F[T++] = S0 / C[s++], S0 = U.noise_log[n];
        else {
          var M0 = j(h0);
          if (r = S.width[n] >> 1, p + S.width[n] > S.max_nonzero_coeff) {
            var R0;
            R0 = S.max_nonzero_coeff - p + 1, R0 > 0 ? r = R0 >> 1 : r = 0;
          }
          var A0 = new a(p);
          S0 = this.calc_noise_core(S, A0, r, M0), p = A0.s, U != null && (U.step[n] = h0, U.noise[n] = S0), S0 = F[T++] = S0 / C[s++], S0 = i0.FAST_LOG10(Math.max(S0, 1e-20)), U != null && (U.noise_log[n] = S0);
        }
        if (U != null && (U.global_gain = S.global_gain), q += S0, S0 > 0) {
          var w0;
          w0 = Math.max(0 | S0 * 10 + 0.5, 1), N.over_SSD += w0 * w0, i++, f += S0;
        }
        g = Math.max(g, S0);
      }
      return N.over_count = i, N.tot_noise = q, N.over_noise = f, N.max_noise = g, i;
    }, this.set_pinfo = function(S, C, F, N, U) {
      var T = S.internal_flags, s, n, r, i, f, q = C.scalefac_scale == 0 ? 0.5 : 1, g = C.scalefac, p = P(L3Side.SFBMAX), G = P(L3Side.SFBMAX), s0 = new CalcNoiseResult();
      calc_xmin(S, F, C, p), calc_noise(C, p, G, s0, null);
      var h0 = 0;
      for (n = C.sfb_lmax, C.block_type != W.SHORT_TYPE && C.mixed_block_flag == 0 && (n = 22), s = 0; s < n; s++) {
        var S0 = T.scalefac_band.l[s], M0 = T.scalefac_band.l[s + 1], R0 = M0 - S0;
        for (i = 0; h0 < M0; h0++)
          i += C.xr[h0] * C.xr[h0];
        i /= R0, f = 1e15, T.pinfo.en[N][U][s] = f * i, T.pinfo.xfsf[N][U][s] = f * p[s] * G[s] / R0, F.en.l[s] > 0 && !S.ATHonly ? i = i / F.en.l[s] : i = 0, T.pinfo.thr[N][U][s] = f * Math.max(i * F.thm.l[s], T.ATH.l[s]), T.pinfo.LAMEsfb[N][U][s] = 0, C.preflag != 0 && s >= 11 && (T.pinfo.LAMEsfb[N][U][s] = -q * B[s]), s < W.SBPSY_l && (D(g[s] >= 0), T.pinfo.LAMEsfb[N][U][s] -= q * g[s]);
      }
      if (C.block_type == W.SHORT_TYPE)
        for (n = s, s = C.sfb_smin; s < W.SBMAX_s; s++)
          for (var S0 = T.scalefac_band.s[s], M0 = T.scalefac_band.s[s + 1], R0 = M0 - S0, A0 = 0; A0 < 3; A0++) {
            for (i = 0, r = S0; r < M0; r++)
              i += C.xr[h0] * C.xr[h0], h0++;
            i = Math.max(i / R0, 1e-20), f = 1e15, T.pinfo.en_s[N][U][3 * s + A0] = f * i, T.pinfo.xfsf_s[N][U][3 * s + A0] = f * p[n] * G[n] / R0, F.en.s[s][A0] > 0 ? i = i / F.en.s[s][A0] : i = 0, (S.ATHonly || S.ATHshort) && (i = 0), T.pinfo.thr_s[N][U][3 * s + A0] = f * Math.max(
              i * F.thm.s[s][A0],
              T.ATH.s[s]
            ), T.pinfo.LAMEsfb_s[N][U][3 * s + A0] = -2 * C.subblock_gain[A0], s < W.SBPSY_s && (T.pinfo.LAMEsfb_s[N][U][3 * s + A0] -= q * g[n]), n++;
          }
      T.pinfo.LAMEqss[N][U] = C.global_gain, T.pinfo.LAMEmainbits[N][U] = C.part2_3_length + C.part2_length, T.pinfo.LAMEsfbits[N][U] = C.part2_length, T.pinfo.over[N][U] = s0.over_count, T.pinfo.max_noise[N][U] = s0.max_noise * 10, T.pinfo.over_noise[N][U] = s0.over_noise * 10, T.pinfo.tot_noise[N][U] = s0.tot_noise * 10, T.pinfo.over_SSD[N][U] = s0.over_SSD;
    };
  }
  return we = c, we;
}
var pe, la;
function Da() {
  if (la)
    return pe;
  la = 1;
  var m = Q0, x = m.System, y = m.Arrays, K = m.new_int, i0 = m.assert, P = t1(), z = ke, D = He, W = qa();
  function f0() {
    var R = null;
    this.qupvt = null, this.setModules = function(T) {
      this.qupvt = T, R = T;
    };
    function c(T) {
      this.bits = 0 | T;
    }
    var H = [
      [0, 0],
      /* 0 bands */
      [0, 0],
      /* 1 bands */
      [0, 0],
      /* 2 bands */
      [0, 0],
      /* 3 bands */
      [0, 0],
      /* 4 bands */
      [0, 1],
      /* 5 bands */
      [1, 1],
      /* 6 bands */
      [1, 1],
      /* 7 bands */
      [1, 2],
      /* 8 bands */
      [2, 2],
      /* 9 bands */
      [2, 3],
      /* 10 bands */
      [2, 3],
      /* 11 bands */
      [3, 4],
      /* 12 bands */
      [3, 4],
      /* 13 bands */
      [3, 4],
      /* 14 bands */
      [4, 5],
      /* 15 bands */
      [4, 5],
      /* 16 bands */
      [4, 6],
      /* 17 bands */
      [5, 6],
      /* 18 bands */
      [5, 6],
      /* 19 bands */
      [5, 7],
      /* 20 bands */
      [6, 7],
      /* 21 bands */
      [6, 7]
      /* 22 bands */
    ];
    function n0(T, s, n, r, i, f) {
      var q = 0.5946 / s;
      for (T = T >> 1; T-- != 0; )
        i[f++] = q > n[r++] ? 0 : 1, i[f++] = q > n[r++] ? 0 : 1;
    }
    function Q(T, s, n, r, i, f) {
      T = T >> 1;
      var q = T % 2;
      for (T = T >> 1; T-- != 0; ) {
        var g, p, G, s0, h0, S0, M0, R0;
        g = n[r++] * s, p = n[r++] * s, h0 = 0 | g, G = n[r++] * s, S0 = 0 | p, s0 = n[r++] * s, M0 = 0 | G, g += R.adj43[h0], R0 = 0 | s0, p += R.adj43[S0], i[f++] = 0 | g, G += R.adj43[M0], i[f++] = 0 | p, s0 += R.adj43[R0], i[f++] = 0 | G, i[f++] = 0 | s0;
      }
      if (q != 0) {
        var g, p, h0, S0;
        g = n[r++] * s, p = n[r++] * s, h0 = 0 | g, S0 = 0 | p, g += R.adj43[h0], p += R.adj43[S0], i[f++] = 0 | g, i[f++] = 0 | p;
      }
    }
    function t0(T, s, n, r, i) {
      var f, q, g = 0, p, G = 0, s0 = 0, h0 = 0, S0 = s, M0 = 0, R0 = S0, A0 = 0, w0 = T, $0 = 0;
      for (p = i != null && r.global_gain == i.global_gain, r.block_type == P.SHORT_TYPE ? q = 38 : q = 21, f = 0; f <= q; f++) {
        var f1 = -1;
        if ((p || r.block_type == P.NORM_TYPE) && (f1 = r.global_gain - (r.scalefac[f] + (r.preflag != 0 ? R.pretab[f] : 0) << r.scalefac_scale + 1) - r.subblock_gain[r.window[f]] * 8), i0(r.width[f] >= 0), p && i.step[f] == f1)
          G != 0 && (Q(
            G,
            n,
            w0,
            $0,
            R0,
            A0
          ), G = 0), s0 != 0 && (n0(
            s0,
            n,
            w0,
            $0,
            R0,
            A0
          ), s0 = 0);
        else {
          var t = r.width[f];
          if (g + r.width[f] > r.max_nonzero_coeff) {
            var _;
            _ = r.max_nonzero_coeff - g + 1, y.fill(s, r.max_nonzero_coeff, 576, 0), t = _, t < 0 && (t = 0), f = q + 1;
          }
          if (G == 0 && s0 == 0 && (R0 = S0, A0 = M0, w0 = T, $0 = h0), i != null && i.sfb_count1 > 0 && f >= i.sfb_count1 && i.step[f] > 0 && f1 >= i.step[f] ? (G != 0 && (Q(
            G,
            n,
            w0,
            $0,
            R0,
            A0
          ), G = 0, R0 = S0, A0 = M0, w0 = T, $0 = h0), s0 += t) : (s0 != 0 && (n0(
            s0,
            n,
            w0,
            $0,
            R0,
            A0
          ), s0 = 0, R0 = S0, A0 = M0, w0 = T, $0 = h0), G += t), t <= 0) {
            s0 != 0 && (n0(
              s0,
              n,
              w0,
              $0,
              R0,
              A0
            ), s0 = 0), G != 0 && (Q(
              G,
              n,
              w0,
              $0,
              R0,
              A0
            ), G = 0);
            break;
          }
        }
        f <= q && (M0 += r.width[f], h0 += r.width[f], g += r.width[f]);
      }
      G != 0 && (Q(
        G,
        n,
        w0,
        $0,
        R0,
        A0
      ), G = 0), s0 != 0 && (n0(
        s0,
        n,
        w0,
        $0,
        R0,
        A0
      ), s0 = 0);
    }
    function j(T, s, n) {
      var r = 0, i = 0;
      do {
        var f = T[s++], q = T[s++];
        r < f && (r = f), i < q && (i = q);
      } while (s < n);
      return r < i && (r = i), r;
    }
    function M(T, s, n, r, i, f) {
      var q = z.ht[r].xlen * 65536 + z.ht[i].xlen, g = 0, p;
      do {
        var G = T[s++], s0 = T[s++];
        G != 0 && (G > 14 && (G = 15, g += q), G *= 16), s0 != 0 && (s0 > 14 && (s0 = 15, g += q), G += s0), g += z.largetbl[G];
      } while (s < n);
      return p = g & 65535, g >>= 16, g > p && (g = p, r = i), f.bits += g, r;
    }
    function v(T, s, n, r) {
      var i = 0, f = z.ht[1].hlen;
      do {
        var q = T[s + 0] * 2 + T[s + 1];
        s += 2, i += f[q];
      } while (s < n);
      return r.bits += i, 1;
    }
    function h(T, s, n, r, i) {
      var f = 0, q, g = z.ht[r].xlen, p;
      r == 2 ? p = z.table23 : p = z.table56;
      do {
        var G = T[s + 0] * g + T[s + 1];
        s += 2, f += p[G];
      } while (s < n);
      return q = f & 65535, f >>= 16, f > q && (f = q, r++), i.bits += f, r;
    }
    function A(T, s, n, r, i) {
      var f = 0, q = 0, g = 0, p = z.ht[r].xlen, G = z.ht[r].hlen, s0 = z.ht[r + 1].hlen, h0 = z.ht[r + 2].hlen;
      do {
        var S0 = T[s + 0] * p + T[s + 1];
        s += 2, f += G[S0], q += s0[S0], g += h0[S0];
      } while (s < n);
      var M0 = r;
      return f > q && (f = q, M0++), f > g && (f = g, M0 = r + 2), i.bits += f, M0;
    }
    var e = [
      1,
      2,
      5,
      7,
      7,
      10,
      10,
      13,
      13,
      13,
      13,
      13,
      13,
      13,
      13
    ];
    function l(T, s, n, r) {
      var i = j(T, s, n);
      switch (i) {
        case 0:
          return i;
        case 1:
          return v(T, s, n, r);
        case 2:
        case 3:
          return h(
            T,
            s,
            n,
            e[i - 1],
            r
          );
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
          return A(
            T,
            s,
            n,
            e[i - 1],
            r
          );
        default:
          if (i > W.IXMAX_VAL)
            return r.bits = W.LARGE_BITS, -1;
          i -= 15;
          var f;
          for (f = 24; f < 32 && !(z.ht[f].linmax >= i); f++)
            ;
          var q;
          for (q = f - 8; q < 24 && !(z.ht[q].linmax >= i); q++)
            ;
          return M(T, s, n, q, f, r);
      }
    }
    this.noquant_count_bits = function(T, s, n) {
      var r = s.l3_enc, i = Math.min(576, s.max_nonzero_coeff + 2 >> 1 << 1);
      for (n != null && (n.sfb_count1 = 0); i > 1 && !(r[i - 1] | r[i - 2]); i -= 2)
        ;
      s.count1 = i;
      for (var f = 0, q = 0; i > 3; i -= 4) {
        var g;
        if (((r[i - 1] | r[i - 2] | r[i - 3] | r[i - 4]) & 2147483647) > 1)
          break;
        g = ((r[i - 4] * 2 + r[i - 3]) * 2 + r[i - 2]) * 2 + r[i - 1], f += z.t32l[g], q += z.t33l[g];
      }
      var p = f;
      if (s.count1table_select = 0, f > q && (p = q, s.count1table_select = 1), s.count1bits = p, s.big_values = i, i == 0)
        return p;
      if (s.block_type == P.SHORT_TYPE)
        f = 3 * T.scalefac_band.s[3], f > s.big_values && (f = s.big_values), q = s.big_values;
      else if (s.block_type == P.NORM_TYPE) {
        if (f = s.region0_count = T.bv_scf[i - 2], q = s.region1_count = T.bv_scf[i - 1], i0(f + q + 2 < P.SBPSY_l), q = T.scalefac_band.l[f + q + 2], f = T.scalefac_band.l[f + 1], q < i) {
          var G = new c(p);
          s.table_select[2] = l(r, q, i, G), p = G.bits;
        }
      } else
        s.region0_count = 7, s.region1_count = P.SBMAX_l - 1 - 7 - 1, f = T.scalefac_band.l[7 + 1], q = i, f > q && (f = q);
      if (f = Math.min(f, i), q = Math.min(q, i), 0 < f) {
        var G = new c(p);
        s.table_select[0] = l(r, 0, f, G), p = G.bits;
      }
      if (f < q) {
        var G = new c(p);
        s.table_select[1] = l(r, f, q, G), p = G.bits;
      }
      if (T.use_best_huffman == 2 && (s.part2_3_length = p, best_huffman_divide(T, s), p = s.part2_3_length), n != null && s.block_type == P.NORM_TYPE) {
        for (var s0 = 0; T.scalefac_band.l[s0] < s.big_values; )
          s0++;
        n.sfb_count1 = s0;
      }
      return p;
    }, this.count_bits = function(T, s, n, r) {
      var i = n.l3_enc, f = W.IXMAX_VAL / R.IPOW20(n.global_gain);
      if (n.xrpow_max > f)
        return W.LARGE_BITS;
      if (t0(s, i, R.IPOW20(n.global_gain), n, r), T.substep_shaping & 2)
        for (var q = 0, g = n.global_gain + n.scalefac_scale, p = 0.634521682242439 / R.IPOW20(g), G = 0; G < n.sfbmax; G++) {
          var s0 = n.width[G];
          if (T.pseudohalf[G] == 0)
            q += s0;
          else {
            var h0;
            for (h0 = q, q += s0; h0 < q; ++h0)
              i[h0] = s[h0] >= p ? i[h0] : 0;
          }
        }
      return this.noquant_count_bits(T, n, r);
    };
    function B(T, s, n, r, i, f, q) {
      for (var g = s.big_values, p = 0; p <= 7 + 15; p++)
        r[p] = W.LARGE_BITS;
      for (var p = 0; p < 16; p++) {
        var G = T.scalefac_band.l[p + 1];
        if (G >= g)
          break;
        var s0 = 0, h0 = new c(s0), S0 = l(n, 0, G, h0);
        s0 = h0.bits;
        for (var M0 = 0; M0 < 8; M0++) {
          var R0 = T.scalefac_band.l[p + M0 + 2];
          if (R0 >= g)
            break;
          var A0 = s0;
          h0 = new c(A0);
          var w0 = l(n, G, R0, h0);
          A0 = h0.bits, r[p + M0] > A0 && (r[p + M0] = A0, i[p + M0] = p, f[p + M0] = S0, q[p + M0] = w0);
        }
      }
    }
    function V(T, s, n, r, i, f, q, g) {
      for (var p = s.big_values, G = 2; G < P.SBMAX_l + 1; G++) {
        var s0 = T.scalefac_band.l[G];
        if (s0 >= p)
          break;
        var h0 = i[G - 2] + s.count1bits;
        if (n.part2_3_length <= h0)
          break;
        var S0 = new c(h0), M0 = l(r, s0, p, S0);
        h0 = S0.bits, !(n.part2_3_length <= h0) && (n.assign(s), n.part2_3_length = h0, n.region0_count = f[G - 2], n.region1_count = G - 2 - f[G - 2], n.table_select[0] = q[G - 2], n.table_select[1] = g[G - 2], n.table_select[2] = M0);
      }
    }
    this.best_huffman_divide = function(T, s) {
      var n = new D(), r = s.l3_enc, i = K(7 + 15 + 1), f = K(7 + 15 + 1), q = K(7 + 15 + 1), g = K(7 + 15 + 1);
      if (!(s.block_type == P.SHORT_TYPE && T.mode_gr == 1)) {
        n.assign(s), s.block_type == P.NORM_TYPE && (B(T, s, r, i, f, q, g), V(
          T,
          n,
          s,
          r,
          i,
          f,
          q,
          g
        ));
        var p = n.big_values;
        if (!(p == 0 || (r[p - 2] | r[p - 1]) > 1) && (p = s.count1 + 2, !(p > 576))) {
          n.assign(s), n.count1 = p;
          for (var G = 0, s0 = 0; p > n.big_values; p -= 4) {
            var h0 = ((r[p - 4] * 2 + r[p - 3]) * 2 + r[p - 2]) * 2 + r[p - 1];
            G += z.t32l[h0], s0 += z.t33l[h0];
          }
          if (n.big_values = p, n.count1table_select = 0, G > s0 && (G = s0, n.count1table_select = 1), n.count1bits = G, n.block_type == P.NORM_TYPE)
            V(
              T,
              n,
              s,
              r,
              i,
              f,
              q,
              g
            );
          else {
            if (n.part2_3_length = G, G = T.scalefac_band.l[7 + 1], G > p && (G = p), G > 0) {
              var S0 = new c(n.part2_3_length);
              n.table_select[0] = l(r, 0, G, S0), n.part2_3_length = S0.bits;
            }
            if (p > G) {
              var S0 = new c(n.part2_3_length);
              n.table_select[1] = l(r, G, p, S0), n.part2_3_length = S0.bits;
            }
            s.part2_3_length > n.part2_3_length && s.assign(n);
          }
        }
      }
    };
    var O = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16], w = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8], L = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4], v0 = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
    f0.slen1_tab = L, f0.slen2_tab = v0;
    function b(T, s) {
      for (var n, r = s.tt[1][T], i = s.tt[0][T], f = 0; f < z.scfsi_band.length - 1; f++) {
        for (n = z.scfsi_band[f]; n < z.scfsi_band[f + 1] && !(i.scalefac[n] != r.scalefac[n] && r.scalefac[n] >= 0); n++)
          ;
        if (n == z.scfsi_band[f + 1]) {
          for (n = z.scfsi_band[f]; n < z.scfsi_band[f + 1]; n++)
            r.scalefac[n] = -1;
          s.scfsi[T][f] = 1;
        }
      }
      var q = 0, g = 0;
      for (n = 0; n < 11; n++)
        r.scalefac[n] != -1 && (g++, q < r.scalefac[n] && (q = r.scalefac[n]));
      for (var p = 0, G = 0; n < P.SBPSY_l; n++)
        r.scalefac[n] != -1 && (G++, p < r.scalefac[n] && (p = r.scalefac[n]));
      for (var f = 0; f < 16; f++)
        if (q < O[f] && p < w[f]) {
          var s0 = L[f] * g + v0[f] * G;
          r.part2_length > s0 && (r.part2_length = s0, r.scalefac_compress = f);
        }
    }
    this.best_scalefac_store = function(T, s, n, r) {
      var i = r.tt[s][n], f, q, g, p, G = 0;
      for (g = 0, f = 0; f < i.sfbmax; f++) {
        var s0 = i.width[f];
        for (g += s0, p = -s0; p < 0 && i.l3_enc[p + g] == 0; p++)
          ;
        p == 0 && (i.scalefac[f] = G = -2);
      }
      if (i.scalefac_scale == 0 && i.preflag == 0) {
        var h0 = 0;
        for (f = 0; f < i.sfbmax; f++)
          i.scalefac[f] > 0 && (h0 |= i.scalefac[f]);
        if (!(h0 & 1) && h0 != 0) {
          for (f = 0; f < i.sfbmax; f++)
            i.scalefac[f] > 0 && (i.scalefac[f] >>= 1);
          i.scalefac_scale = G = 1;
        }
      }
      if (i.preflag == 0 && i.block_type != P.SHORT_TYPE && T.mode_gr == 2) {
        for (f = 11; f < P.SBPSY_l && !(i.scalefac[f] < R.pretab[f] && i.scalefac[f] != -2); f++)
          ;
        if (f == P.SBPSY_l) {
          for (f = 11; f < P.SBPSY_l; f++)
            i.scalefac[f] > 0 && (i.scalefac[f] -= R.pretab[f]);
          i.preflag = G = 1;
        }
      }
      for (q = 0; q < 4; q++)
        r.scfsi[n][q] = 0;
      for (T.mode_gr == 2 && s == 1 && r.tt[0][n].block_type != P.SHORT_TYPE && r.tt[1][n].block_type != P.SHORT_TYPE && (b(n, r), G = 0), f = 0; f < i.sfbmax; f++)
        i.scalefac[f] == -2 && (i.scalefac[f] = 0);
      G != 0 && (T.mode_gr == 2 ? this.scale_bitcount(i) : this.scale_bitcount_lsf(T, i));
    };
    function a(T, s) {
      for (var n = 0; n < s; ++n)
        if (T[n] < 0)
          return !1;
      return !0;
    }
    var S = [
      0,
      18,
      36,
      54,
      54,
      36,
      54,
      72,
      54,
      72,
      90,
      72,
      90,
      108,
      108,
      126
    ], C = [
      0,
      18,
      36,
      54,
      51,
      35,
      53,
      71,
      52,
      70,
      88,
      69,
      87,
      105,
      104,
      122
    ], F = [
      0,
      10,
      20,
      30,
      33,
      21,
      31,
      41,
      32,
      42,
      52,
      43,
      53,
      63,
      64,
      74
    ];
    this.scale_bitcount = function(T) {
      var s, n, r = 0, i = 0, f, q = T.scalefac;
      if (i0(a(q, T.sfbmax)), T.block_type == P.SHORT_TYPE)
        f = S, T.mixed_block_flag != 0 && (f = C);
      else if (f = F, T.preflag == 0) {
        for (n = 11; n < P.SBPSY_l && !(q[n] < R.pretab[n]); n++)
          ;
        if (n == P.SBPSY_l)
          for (T.preflag = 1, n = 11; n < P.SBPSY_l; n++)
            q[n] -= R.pretab[n];
      }
      for (n = 0; n < T.sfbdivide; n++)
        r < q[n] && (r = q[n]);
      for (; n < T.sfbmax; n++)
        i < q[n] && (i = q[n]);
      for (T.part2_length = W.LARGE_BITS, s = 0; s < 16; s++)
        r < O[s] && i < w[s] && T.part2_length > f[s] && (T.part2_length = f[s], T.scalefac_compress = s);
      return T.part2_length == W.LARGE_BITS;
    };
    var N = [
      [15, 15, 7, 7],
      [15, 15, 7, 0],
      [7, 3, 0, 0],
      [15, 31, 31, 0],
      [7, 7, 7, 0],
      [3, 3, 0, 0]
    ];
    this.scale_bitcount_lsf = function(T, s) {
      var n, r, i, f, q, g, p, G, s0 = K(4), h0 = s.scalefac;
      for (s.preflag != 0 ? n = 2 : n = 0, p = 0; p < 4; p++)
        s0[p] = 0;
      if (s.block_type == P.SHORT_TYPE) {
        r = 1;
        var S0 = R.nr_of_sfb_block[n][r];
        for (G = 0, i = 0; i < 4; i++)
          for (f = S0[i] / 3, p = 0; p < f; p++, G++)
            for (q = 0; q < 3; q++)
              h0[G * 3 + q] > s0[i] && (s0[i] = h0[G * 3 + q]);
      } else {
        r = 0;
        var S0 = R.nr_of_sfb_block[n][r];
        for (G = 0, i = 0; i < 4; i++)
          for (f = S0[i], p = 0; p < f; p++, G++)
            h0[G] > s0[i] && (s0[i] = h0[G]);
      }
      for (g = !1, i = 0; i < 4; i++)
        s0[i] > N[n][i] && (g = !0);
      if (!g) {
        var M0, R0, A0, w0;
        for (s.sfb_partition_table = R.nr_of_sfb_block[n][r], i = 0; i < 4; i++)
          s.slen[i] = U[s0[i]];
        switch (M0 = s.slen[0], R0 = s.slen[1], A0 = s.slen[2], w0 = s.slen[3], n) {
          case 0:
            s.scalefac_compress = (M0 * 5 + R0 << 4) + (A0 << 2) + w0;
            break;
          case 1:
            s.scalefac_compress = 400 + (M0 * 5 + R0 << 2) + A0;
            break;
          case 2:
            s.scalefac_compress = 500 + M0 * 3 + R0;
            break;
          default:
            x.err.printf(`intensity stereo not implemented yet
`);
            break;
        }
      }
      if (!g)
        for (i0(s.sfb_partition_table != null), s.part2_length = 0, i = 0; i < 4; i++)
          s.part2_length += s.slen[i] * s.sfb_partition_table[i];
      return g;
    };
    var U = [
      0,
      1,
      2,
      2,
      3,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      4,
      4,
      4,
      4
    ];
    this.huffman_init = function(T) {
      for (var s = 2; s <= 576; s += 2) {
        for (var n = 0, r; T.scalefac_band.l[++n] < s; )
          ;
        for (r = H[n][0]; T.scalefac_band.l[r + 1] > s; )
          r--;
        for (r < 0 && (r = H[n][0]), T.bv_scf[s - 2] = r, r = H[n][1]; T.scalefac_band.l[r + T.bv_scf[s - 2] + 2] > s; )
          r--;
        r < 0 && (r = H[n][1]), T.bv_scf[s - 1] = r;
      }
    };
  }
  return pe = f0, pe;
}
var Ie, oa;
function Xe() {
  if (oa)
    return Ie;
  oa = 1;
  var m = Q0, x = m.System, y = m.Arrays, K = m.new_byte, i0 = m.new_float_n, P = m.new_int, z = m.assert, D = Da(), W = ke, f0 = t1(), R = ue;
  c.EQ = function(H, n0) {
    return Math.abs(H) > Math.abs(n0) ? Math.abs(H - n0) <= Math.abs(H) * 1e-6 : Math.abs(H - n0) <= Math.abs(n0) * 1e-6;
  }, c.NEQ = function(H, n0) {
    return !c.EQ(H, n0);
  };
  function c() {
    var H = Ye(), n0 = this, Q = 32773, t0 = null, j = null, M = null, v = null;
    this.setModules = function(s, n, r, i) {
      t0 = s, j = n, M = r, v = i;
    };
    var h = null, A = 0, e = 0, l = 0;
    this.getframebits = function(s) {
      var n = s.internal_flags, r;
      n.bitrate_index != 0 ? r = W.bitrate_table[s.version][n.bitrate_index] : r = s.brate;
      var i = 0 | (s.version + 1) * 72e3 * r / s.out_samplerate + n.padding;
      return 8 * i;
    };
    function B(s) {
      x.arraycopy(s.header[s.w_ptr].buf, 0, h, e, s.sideinfo_len), e += s.sideinfo_len, A += s.sideinfo_len * 8, s.w_ptr = s.w_ptr + 1 & R.MAX_HEADER_BUF - 1;
    }
    function V(s, n, r) {
      for (; r > 0; ) {
        var i;
        l == 0 && (l = 8, e++, z(e < H.LAME_MAXMP3BUFFER), z(s.header[s.w_ptr].write_timing >= A), s.header[s.w_ptr].write_timing == A && B(s), h[e] = 0), i = Math.min(r, l), r -= i, l -= i, h[e] |= n >> r << l, A += i;
      }
    }
    function O(s, n, r) {
      for (; r > 0; ) {
        var i;
        l == 0 && (l = 8, e++, z(e < H.LAME_MAXMP3BUFFER), h[e] = 0), i = Math.min(r, l), r -= i, l -= i, h[e] |= n >> r << l, A += i;
      }
    }
    function w(s, n) {
      var r = s.internal_flags, i;
      if (n >= 8 && (V(r, 76, 8), n -= 8), n >= 8 && (V(r, 65, 8), n -= 8), n >= 8 && (V(r, 77, 8), n -= 8), n >= 8 && (V(r, 69, 8), n -= 8), n >= 32) {
        var f = M.getLameShortVersion();
        if (n >= 32)
          for (i = 0; i < f.length && n >= 8; ++i)
            n -= 8, V(r, f.charAt(i), 8);
      }
      for (; n >= 1; n -= 1)
        V(r, r.ancillary_flag, 1), r.ancillary_flag ^= s.disable_reservoir ? 0 : 1;
    }
    function L(s, n, r) {
      for (var i = s.header[s.h_ptr].ptr; r > 0; ) {
        var f = Math.min(r, 8 - (i & 7));
        r -= f, s.header[s.h_ptr].buf[i >> 3] |= n >> r << 8 - (i & 7) - f, i += f;
      }
      s.header[s.h_ptr].ptr = i;
    }
    function v0(s, n) {
      s <<= 8;
      for (var r = 0; r < 8; r++)
        s <<= 1, n <<= 1, (n ^ s) & 65536 && (n ^= Q);
      return n;
    }
    this.CRC_writeheader = function(s, n) {
      var r = 65535;
      r = v0(n[2] & 255, r), r = v0(n[3] & 255, r);
      for (var i = 6; i < s.sideinfo_len; i++)
        r = v0(n[i] & 255, r);
      n[4] = byte(r >> 8), n[5] = byte(r & 255);
    };
    function b(s, n) {
      var r = s.internal_flags, i, f, q;
      if (i = r.l3_side, r.header[r.h_ptr].ptr = 0, y.fill(r.header[r.h_ptr].buf, 0, r.sideinfo_len, 0), s.out_samplerate < 16e3 ? L(r, 4094, 12) : L(r, 4095, 12), L(r, s.version, 1), L(r, 4 - 3, 2), L(r, s.error_protection ? 0 : 1, 1), L(r, r.bitrate_index, 4), L(r, r.samplerate_index, 2), L(r, r.padding, 1), L(r, s.extension, 1), L(r, s.mode.ordinal(), 2), L(r, r.mode_ext, 2), L(r, s.copyright, 1), L(r, s.original, 1), L(r, s.emphasis, 2), s.error_protection && L(r, 0, 16), s.version == 1) {
        for (z(i.main_data_begin >= 0), L(r, i.main_data_begin, 9), r.channels_out == 2 ? L(r, i.private_bits, 3) : L(r, i.private_bits, 5), q = 0; q < r.channels_out; q++) {
          var g;
          for (g = 0; g < 4; g++)
            L(r, i.scfsi[q][g], 1);
        }
        for (f = 0; f < 2; f++)
          for (q = 0; q < r.channels_out; q++) {
            var p = i.tt[f][q];
            L(r, p.part2_3_length + p.part2_length, 12), L(r, p.big_values / 2, 9), L(r, p.global_gain, 8), L(r, p.scalefac_compress, 4), p.block_type != f0.NORM_TYPE ? (L(r, 1, 1), L(r, p.block_type, 2), L(r, p.mixed_block_flag, 1), p.table_select[0] == 14 && (p.table_select[0] = 16), L(r, p.table_select[0], 5), p.table_select[1] == 14 && (p.table_select[1] = 16), L(r, p.table_select[1], 5), L(r, p.subblock_gain[0], 3), L(r, p.subblock_gain[1], 3), L(r, p.subblock_gain[2], 3)) : (L(r, 0, 1), p.table_select[0] == 14 && (p.table_select[0] = 16), L(r, p.table_select[0], 5), p.table_select[1] == 14 && (p.table_select[1] = 16), L(r, p.table_select[1], 5), p.table_select[2] == 14 && (p.table_select[2] = 16), L(r, p.table_select[2], 5), z(0 <= p.region0_count && p.region0_count < 16), z(0 <= p.region1_count && p.region1_count < 8), L(r, p.region0_count, 4), L(r, p.region1_count, 3)), L(r, p.preflag, 1), L(r, p.scalefac_scale, 1), L(r, p.count1table_select, 1);
          }
      } else
        for (z(i.main_data_begin >= 0), L(r, i.main_data_begin, 8), L(r, i.private_bits, r.channels_out), f = 0, q = 0; q < r.channels_out; q++) {
          var p = i.tt[f][q];
          L(r, p.part2_3_length + p.part2_length, 12), L(r, p.big_values / 2, 9), L(r, p.global_gain, 8), L(r, p.scalefac_compress, 9), p.block_type != f0.NORM_TYPE ? (L(r, 1, 1), L(r, p.block_type, 2), L(r, p.mixed_block_flag, 1), p.table_select[0] == 14 && (p.table_select[0] = 16), L(r, p.table_select[0], 5), p.table_select[1] == 14 && (p.table_select[1] = 16), L(r, p.table_select[1], 5), L(r, p.subblock_gain[0], 3), L(r, p.subblock_gain[1], 3), L(r, p.subblock_gain[2], 3)) : (L(r, 0, 1), p.table_select[0] == 14 && (p.table_select[0] = 16), L(r, p.table_select[0], 5), p.table_select[1] == 14 && (p.table_select[1] = 16), L(r, p.table_select[1], 5), p.table_select[2] == 14 && (p.table_select[2] = 16), L(r, p.table_select[2], 5), z(0 <= p.region0_count && p.region0_count < 16), z(0 <= p.region1_count && p.region1_count < 8), L(r, p.region0_count, 4), L(r, p.region1_count, 3)), L(r, p.scalefac_scale, 1), L(r, p.count1table_select, 1);
        }
      s.error_protection && CRC_writeheader(r, r.header[r.h_ptr].buf);
      {
        var G = r.h_ptr;
        z(r.header[G].ptr == r.sideinfo_len * 8), r.h_ptr = G + 1 & R.MAX_HEADER_BUF - 1, r.header[r.h_ptr].write_timing = r.header[G].write_timing + n, r.h_ptr == r.w_ptr && x.err.println(`Error: MAX_HEADER_BUF too small in bitstream.c 
`);
      }
    }
    function a(s, n) {
      var r = W.ht[n.count1table_select + 32], i, f = 0, q = n.big_values, g = n.big_values;
      for (z(n.count1table_select < 2), i = (n.count1 - n.big_values) / 4; i > 0; --i) {
        var p = 0, G = 0, s0;
        s0 = n.l3_enc[q + 0], s0 != 0 && (G += 8, n.xr[g + 0] < 0 && p++), s0 = n.l3_enc[q + 1], s0 != 0 && (G += 4, p *= 2, n.xr[g + 1] < 0 && p++), s0 = n.l3_enc[q + 2], s0 != 0 && (G += 2, p *= 2, n.xr[g + 2] < 0 && p++), s0 = n.l3_enc[q + 3], s0 != 0 && (G++, p *= 2, n.xr[g + 3] < 0 && p++), q += 4, g += 4, V(s, p + r.table[G], r.hlen[G]), f += r.hlen[G];
      }
      return f;
    }
    function S(s, n, r, i, f) {
      var q = W.ht[n], g = 0;
      if (n == 0)
        return g;
      for (var p = r; p < i; p += 2) {
        var G = 0, s0 = 0, h0 = q.xlen, S0 = q.xlen, M0 = 0, R0 = f.l3_enc[p], A0 = f.l3_enc[p + 1];
        if (R0 != 0 && (f.xr[p] < 0 && M0++, G--), n > 15) {
          if (R0 > 14) {
            var w0 = R0 - 15;
            z(w0 <= q.linmax), M0 |= w0 << 1, s0 = h0, R0 = 15;
          }
          if (A0 > 14) {
            var $0 = A0 - 15;
            z($0 <= q.linmax), M0 <<= h0, M0 |= $0, s0 += h0, A0 = 15;
          }
          S0 = 16;
        }
        A0 != 0 && (M0 <<= 1, f.xr[p + 1] < 0 && M0++, G--), R0 = R0 * S0 + A0, s0 -= G, G += q.hlen[R0], V(s, q.table[R0], G), V(s, M0, s0), g += G + s0;
      }
      return g;
    }
    function C(s, n) {
      var r = 3 * s.scalefac_band.s[3];
      r > n.big_values && (r = n.big_values);
      var i = S(s, n.table_select[0], 0, r, n);
      return i += S(
        s,
        n.table_select[1],
        r,
        n.big_values,
        n
      ), i;
    }
    function F(s, n) {
      var r, i, f, q;
      r = n.big_values;
      var g = n.region0_count + 1;
      return z(g < s.scalefac_band.l.length), f = s.scalefac_band.l[g], g += n.region1_count + 1, z(g < s.scalefac_band.l.length), q = s.scalefac_band.l[g], f > r && (f = r), q > r && (q = r), i = S(s, n.table_select[0], 0, f, n), i += S(
        s,
        n.table_select[1],
        f,
        q,
        n
      ), i += S(
        s,
        n.table_select[2],
        q,
        r,
        n
      ), i;
    }
    function N(s) {
      var n, r, i, f, q = 0, g = s.internal_flags, p = g.l3_side;
      if (s.version == 1)
        for (n = 0; n < 2; n++)
          for (r = 0; r < g.channels_out; r++) {
            var G = p.tt[n][r], s0 = D.slen1_tab[G.scalefac_compress], h0 = D.slen2_tab[G.scalefac_compress];
            for (f = 0, i = 0; i < G.sfbdivide; i++)
              G.scalefac[i] != -1 && (V(g, G.scalefac[i], s0), f += s0);
            for (; i < G.sfbmax; i++)
              G.scalefac[i] != -1 && (V(g, G.scalefac[i], h0), f += h0);
            z(f == G.part2_length), G.block_type == f0.SHORT_TYPE ? f += C(g, G) : f += F(g, G), f += a(g, G), z(f == G.part2_3_length + G.part2_length), q += f;
          }
      else
        for (n = 0, r = 0; r < g.channels_out; r++) {
          var G = p.tt[n][r], S0, M0, R0 = 0;
          if (z(G.sfb_partition_table != null), f = 0, i = 0, M0 = 0, G.block_type == f0.SHORT_TYPE) {
            for (; M0 < 4; M0++) {
              var A0 = G.sfb_partition_table[M0] / 3, w0 = G.slen[M0];
              for (S0 = 0; S0 < A0; S0++, i++)
                V(
                  g,
                  Math.max(G.scalefac[i * 3 + 0], 0),
                  w0
                ), V(
                  g,
                  Math.max(G.scalefac[i * 3 + 1], 0),
                  w0
                ), V(
                  g,
                  Math.max(G.scalefac[i * 3 + 2], 0),
                  w0
                ), R0 += 3 * w0;
            }
            f += C(g, G);
          } else {
            for (; M0 < 4; M0++) {
              var A0 = G.sfb_partition_table[M0], w0 = G.slen[M0];
              for (S0 = 0; S0 < A0; S0++, i++)
                V(g, Math.max(G.scalefac[i], 0), w0), R0 += w0;
            }
            f += F(g, G);
          }
          f += a(g, G), z(f == G.part2_3_length), z(R0 == G.part2_length), q += R0 + f;
        }
      return q;
    }
    function U() {
      this.total = 0;
    }
    function T(s, n) {
      var r = s.internal_flags, i, f, q, g, p;
      return p = r.w_ptr, g = r.h_ptr - 1, g == -1 && (g = R.MAX_HEADER_BUF - 1), i = r.header[g].write_timing - A, n.total = i, i >= 0 && (f = 1 + g - p, g < p && (f = 1 + g - p + R.MAX_HEADER_BUF), i -= f * 8 * r.sideinfo_len), q = n0.getframebits(s), i += q, n.total += q, n.total % 8 != 0 ? n.total = 1 + n.total / 8 : n.total = n.total / 8, n.total += e + 1, i < 0 && x.err.println(`strange error flushing buffer ... 
`), i;
    }
    this.flush_bitstream = function(s) {
      var n = s.internal_flags, r, i, f = n.h_ptr - 1;
      if (f == -1 && (f = R.MAX_HEADER_BUF - 1), r = n.l3_side, !((i = T(s, new U())) < 0)) {
        if (w(s, i), z(n.header[f].write_timing + this.getframebits(s) == A), n.ResvSize = 0, r.main_data_begin = 0, n.findReplayGain) {
          var q = t0.GetTitleGain(n.rgdata);
          z(NEQ(q, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES)), n.RadioGain = Math.floor(q * 10 + 0.5) | 0;
        }
        n.findPeakSample && (n.noclipGainChange = Math.ceil(Math.log10(n.PeakSample / 32767) * 20 * 10) | 0, n.noclipGainChange > 0 && (EQ(s.scale, 1) || EQ(s.scale, 0)) ? n.noclipScale = Math.floor(32767 / n.PeakSample * 100) / 100 : n.noclipScale = -1);
      }
    }, this.add_dummy_byte = function(s, n, r) {
      for (var i = s.internal_flags, f; r-- > 0; )
        for (O(i, n, 8), f = 0; f < R.MAX_HEADER_BUF; ++f)
          i.header[f].write_timing += 8;
    }, this.format_bitstream = function(s) {
      var n = s.internal_flags, r;
      r = n.l3_side;
      var i = this.getframebits(s);
      w(s, r.resvDrain_pre), b(s, i);
      var f = 8 * n.sideinfo_len;
      if (f += N(s), w(s, r.resvDrain_post), f += r.resvDrain_post, r.main_data_begin += (i - f) / 8, T(s, new U()) != n.ResvSize && x.err.println("Internal buffer inconsistency. flushbits <> ResvSize"), r.main_data_begin * 8 != n.ResvSize && (x.err.printf(
        `bit reservoir error: 
l3_side.main_data_begin: %d 
Resvoir size:             %d 
resv drain (post)         %d 
resv drain (pre)          %d 
header and sideinfo:      %d 
data bits:                %d 
total bits:               %d (remainder: %d) 
bitsperframe:             %d 
`,
        8 * r.main_data_begin,
        n.ResvSize,
        r.resvDrain_post,
        r.resvDrain_pre,
        8 * n.sideinfo_len,
        f - r.resvDrain_post - 8 * n.sideinfo_len,
        f,
        f % 8,
        i
      ), x.err.println("This is a fatal error.  It has several possible causes:"), x.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations"), x.err.println(" 9%%  Your system is overclocked"), x.err.println(" 1%%  bug in LAME encoding library"), n.ResvSize = r.main_data_begin * 8), A > 1e9) {
        var q;
        for (q = 0; q < R.MAX_HEADER_BUF; ++q)
          n.header[q].write_timing -= A;
        A = 0;
      }
      return 0;
    }, this.copy_buffer = function(s, n, r, i, f) {
      var q = e + 1;
      if (q <= 0)
        return 0;
      if (i != 0 && q > i)
        return -1;
      if (x.arraycopy(h, 0, n, r, q), e = -1, l = 0, f != 0) {
        var g = P(1);
        if (g[0] = s.nMusicCRC, v.updateMusicCRC(g, n, r, q), s.nMusicCRC = g[0], q > 0 && (s.VBR_seek_table.nBytesWritten += q), s.decode_on_the_fly) {
          for (var p = i0([2, 1152]), G = q, s0 = -1, h0; s0 != 0; )
            if (s0 = j.hip_decode1_unclipped(
              s.hip,
              n,
              r,
              G,
              p[0],
              p[1]
            ), G = 0, s0 == -1 && (s0 = 0), s0 > 0) {
              if (s.findPeakSample) {
                for (h0 = 0; h0 < s0; h0++)
                  p[0][h0] > s.PeakSample ? s.PeakSample = p[0][h0] : -p[0][h0] > s.PeakSample && (s.PeakSample = -p[0][h0]);
                if (s.channels_out > 1)
                  for (h0 = 0; h0 < s0; h0++)
                    p[1][h0] > s.PeakSample ? s.PeakSample = p[1][h0] : -p[1][h0] > s.PeakSample && (s.PeakSample = -p[1][h0]);
              }
              if (s.findReplayGain && t0.AnalyzeSamples(
                s.rgdata,
                p[0],
                0,
                p[1],
                0,
                s0,
                s.channels_out
              ) == GainAnalysis.GAIN_ANALYSIS_ERROR)
                return -6;
            }
        }
      }
      return q;
    }, this.init_bit_stream_w = function(s) {
      h = K(H.LAME_MAXMP3BUFFER), s.h_ptr = s.w_ptr = 0, s.header[s.h_ptr].write_timing = 0, e = -1, l = 0, A = 0;
    };
  }
  return Ie = c, Ie;
}
var Le, va;
function Ye() {
  if (va)
    return Le;
  va = 1;
  var m = Q0, x = m.System, y = m.VbrMode, K = m.ShortBlock, i0 = m.new_float, P = m.new_int_n, z = m.new_short_n, D = m.assert, W = ur, f0 = cr, R = ue, c = Xr, H = qr, n0 = Ur, Q = Xe(), t0 = ke, j = t1();
  function M() {
    var v = j1, h = this, A = 128 * 1024;
    M.V9 = 410, M.V8 = 420, M.V7 = 430, M.V6 = 440, M.V5 = 450, M.V4 = 460, M.V3 = 470, M.V2 = 480, M.V1 = 490, M.V0 = 500, M.R3MIX = 1e3, M.STANDARD = 1001, M.EXTREME = 1002, M.INSANE = 1003, M.STANDARD_FAST = 1004, M.EXTREME_FAST = 1005, M.MEDIUM = 1006, M.MEDIUM_FAST = 1007;
    var e = 16384 + A;
    M.LAME_MAXMP3BUFFER = e;
    var l, B, V, O, w, L = new W(), v0, b, a;
    this.enc = new j(), this.setModules = function(t, _, d0, E0, V0, N0, y0, T0, F0) {
      l = t, B = _, V = d0, O = E0, w = V0, v0 = N0, b = T0, a = F0, this.enc.setModules(B, L, O, v0);
    };
    function S() {
      this.mask_adjust = 0, this.mask_adjust_short = 0, this.bo_l_weight = i0(j.SBMAX_l), this.bo_s_weight = i0(j.SBMAX_s);
    }
    function C() {
      this.lowerlimit = 0;
    }
    function F(t, _) {
      this.lowpass = _;
    }
    var N = 4294479419;
    function U(t) {
      var _;
      return t.class_id = N, _ = t.internal_flags = new R(), t.mode = v.NOT_SET, t.original = 1, t.in_samplerate = 44100, t.num_channels = 2, t.num_samples = -1, t.bWriteVbrTag = !0, t.quality = -1, t.short_blocks = null, _.subblock_gain = -1, t.lowpassfreq = 0, t.highpassfreq = 0, t.lowpasswidth = -1, t.highpasswidth = -1, t.VBR = y.vbr_off, t.VBR_q = 4, t.ATHcurve = -1, t.VBR_mean_bitrate_kbps = 128, t.VBR_min_bitrate_kbps = 0, t.VBR_max_bitrate_kbps = 0, t.VBR_hard_min = 0, _.VBR_min_bitrate = 1, _.VBR_max_bitrate = 13, t.quant_comp = -1, t.quant_comp_short = -1, t.msfix = -1, _.resample_ratio = 1, _.OldValue[0] = 180, _.OldValue[1] = 180, _.CurrentStep[0] = 4, _.CurrentStep[1] = 4, _.masking_lower = 1, _.nsPsy.attackthre = -1, _.nsPsy.attackthre_s = -1, t.scale = -1, t.athaa_type = -1, t.ATHtype = -1, t.athaa_loudapprox = -1, t.athaa_sensitivity = 0, t.useTemporal = null, t.interChRatio = -1, _.mf_samples_to_encode = j.ENCDELAY + j.POSTDELAY, t.encoder_padding = 0, _.mf_size = j.ENCDELAY - j.MDCTDELAY, t.findReplayGain = !1, t.decode_on_the_fly = !1, _.decode_on_the_fly = !1, _.findReplayGain = !1, _.findPeakSample = !1, _.RadioGain = 0, _.AudiophileGain = 0, _.noclipGainChange = 0, _.noclipScale = -1, t.preset = 0, t.write_id3tag_automatic = !0, 0;
    }
    this.lame_init = function() {
      var t = new f0();
      return U(t), t.lame_allocated_gfp = 1, t;
    };
    function T(t) {
      return t > 1 ? 0 : t <= 0 ? 1 : Math.cos(Math.PI / 2 * t);
    }
    this.nearestBitrateFullIndex = function(t) {
      var _ = [
        8,
        16,
        24,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        160,
        192,
        224,
        256,
        320
      ], d0 = 0, E0 = 0, V0 = 0, N0 = 0;
      N0 = _[16], V0 = 16, E0 = _[16], d0 = 16;
      for (var y0 = 0; y0 < 16; y0++)
        if (Math.max(t, _[y0 + 1]) != t) {
          N0 = _[y0 + 1], V0 = y0 + 1, E0 = _[y0], d0 = y0;
          break;
        }
      return N0 - t > t - E0 ? d0 : V0;
    };
    function s(t, _) {
      var d0 = 44100;
      return _ >= 48e3 ? d0 = 48e3 : _ >= 44100 ? d0 = 44100 : _ >= 32e3 ? d0 = 32e3 : _ >= 24e3 ? d0 = 24e3 : _ >= 22050 ? d0 = 22050 : _ >= 16e3 ? d0 = 16e3 : _ >= 12e3 ? d0 = 12e3 : _ >= 11025 ? d0 = 11025 : _ >= 8e3 && (d0 = 8e3), t == -1 ? d0 : (t <= 15960 && (d0 = 44100), t <= 15250 && (d0 = 32e3), t <= 11220 && (d0 = 24e3), t <= 9970 && (d0 = 22050), t <= 7230 && (d0 = 16e3), t <= 5420 && (d0 = 12e3), t <= 4510 && (d0 = 11025), t <= 3970 && (d0 = 8e3), _ < d0 ? _ > 44100 ? 48e3 : _ > 32e3 ? 44100 : _ > 24e3 ? 32e3 : _ > 22050 ? 24e3 : _ > 16e3 ? 22050 : _ > 12e3 ? 16e3 : _ > 11025 ? 12e3 : _ > 8e3 ? 11025 : 8e3 : d0);
    }
    function n(t, _) {
      switch (t) {
        case 44100:
          return _.version = 1, 0;
        case 48e3:
          return _.version = 1, 1;
        case 32e3:
          return _.version = 1, 2;
        case 22050:
          return _.version = 0, 0;
        case 24e3:
          return _.version = 0, 1;
        case 16e3:
          return _.version = 0, 2;
        case 11025:
          return _.version = 0, 0;
        case 12e3:
          return _.version = 0, 1;
        case 8e3:
          return _.version = 0, 2;
        default:
          return _.version = 0, -1;
      }
    }
    function r(t, _, d0) {
      d0 < 16e3 && (_ = 2);
      for (var E0 = t0.bitrate_table[_][1], V0 = 2; V0 <= 14; V0++)
        t0.bitrate_table[_][V0] > 0 && Math.abs(t0.bitrate_table[_][V0] - t) < Math.abs(E0 - t) && (E0 = t0.bitrate_table[_][V0]);
      return E0;
    }
    function i(t, _, d0) {
      d0 < 16e3 && (_ = 2);
      for (var E0 = 0; E0 <= 14; E0++)
        if (t0.bitrate_table[_][E0] > 0 && t0.bitrate_table[_][E0] == t)
          return E0;
      return -1;
    }
    function f(t, _) {
      var d0 = [
        new F(8, 2e3),
        new F(16, 3700),
        new F(24, 3900),
        new F(32, 5500),
        new F(40, 7e3),
        new F(48, 7500),
        new F(56, 1e4),
        new F(64, 11e3),
        new F(80, 13500),
        new F(96, 15100),
        new F(112, 15600),
        new F(128, 17e3),
        new F(160, 17500),
        new F(192, 18600),
        new F(224, 19400),
        new F(256, 19700),
        new F(320, 20500)
      ], E0 = h.nearestBitrateFullIndex(_);
      t.lowerlimit = d0[E0].lowpass;
    }
    function q(t) {
      var _ = t.internal_flags, d0 = 32, E0 = -1;
      if (_.lowpass1 > 0) {
        for (var V0 = 999, N0 = 0; N0 <= 31; N0++) {
          var y0 = N0 / 31;
          y0 >= _.lowpass2 && (d0 = Math.min(d0, N0)), _.lowpass1 < y0 && y0 < _.lowpass2 && (V0 = Math.min(V0, N0));
        }
        V0 == 999 ? _.lowpass1 = (d0 - 0.75) / 31 : _.lowpass1 = (V0 - 0.75) / 31, _.lowpass2 = d0 / 31;
      }
      if (_.highpass2 > 0 && _.highpass2 < 0.9 * (0.75 / 31) && (_.highpass1 = 0, _.highpass2 = 0, x.err.println(`Warning: highpass filter disabled.  highpass frequency too small
`)), _.highpass2 > 0) {
        for (var T0 = -1, N0 = 0; N0 <= 31; N0++) {
          var y0 = N0 / 31;
          y0 <= _.highpass1 && (E0 = Math.max(E0, N0)), _.highpass1 < y0 && y0 < _.highpass2 && (T0 = Math.max(T0, N0));
        }
        _.highpass1 = E0 / 31, T0 == -1 ? _.highpass2 = (E0 + 0.75) / 31 : _.highpass2 = (T0 + 0.75) / 31;
      }
      for (var N0 = 0; N0 < 32; N0++) {
        var F0, p0, y0 = N0 / 31;
        _.highpass2 > _.highpass1 ? F0 = T((_.highpass2 - y0) / (_.highpass2 - _.highpass1 + 1e-20)) : F0 = 1, _.lowpass2 > _.lowpass1 ? p0 = T((y0 - _.lowpass1) / (_.lowpass2 - _.lowpass1 + 1e-20)) : p0 = 1, _.amp_filter[N0] = F0 * p0;
      }
    }
    function g(t) {
      var _ = t.internal_flags;
      switch (t.quality) {
        default:
        case 9:
          _.psymodel = 0, _.noise_shaping = 0, _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.use_best_huffman = 0, _.full_outer_loop = 0;
          break;
        case 8:
          t.quality = 7;
        case 7:
          _.psymodel = 1, _.noise_shaping = 0, _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.use_best_huffman = 0, _.full_outer_loop = 0;
          break;
        case 6:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 0, _.full_outer_loop = 0;
          break;
        case 5:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 0, _.full_outer_loop = 0;
          break;
        case 4:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
          break;
        case 3:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 1, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
          break;
        case 2:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.substep_shaping == 0 && (_.substep_shaping = 2), _.noise_shaping_amp = 1, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
          break;
        case 1:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.substep_shaping == 0 && (_.substep_shaping = 2), _.noise_shaping_amp = 2, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
          break;
        case 0:
          _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.substep_shaping == 0 && (_.substep_shaping = 2), _.noise_shaping_amp = 2, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
          break;
      }
    }
    function p(t) {
      var _ = t.internal_flags;
      t.frameNum = 0, t.write_id3tag_automatic && b.id3tag_write_v2(t), _.bitrate_stereoMode_Hist = P([16, 4 + 1]), _.bitrate_blockType_Hist = P([16, 4 + 1 + 1]), _.PeakSample = 0, t.bWriteVbrTag && v0.InitVbrTag(t);
    }
    this.lame_init_params = function(t) {
      var _ = t.internal_flags;
      if (_.Class_ID = 0, _.ATH == null && (_.ATH = new c()), _.PSY == null && (_.PSY = new S()), _.rgdata == null && (_.rgdata = new H()), _.channels_in = t.num_channels, _.channels_in == 1 && (t.mode = v.MONO), _.channels_out = t.mode == v.MONO ? 1 : 2, _.mode_ext = j.MPG_MD_MS_LR, t.mode == v.MONO && (t.force_ms = !1), t.VBR == y.vbr_off && t.VBR_mean_bitrate_kbps != 128 && t.brate == 0 && (t.brate = t.VBR_mean_bitrate_kbps), t.VBR == y.vbr_off || t.VBR == y.vbr_mtrh || t.VBR == y.vbr_mt || (t.free_format = !1), t.VBR == y.vbr_off && t.brate == 0 && Q.EQ(t.compression_ratio, 0) && (t.compression_ratio = 11.025), t.VBR == y.vbr_off && t.compression_ratio > 0 && (t.out_samplerate == 0 && (t.out_samplerate = map2MP3Frequency(int(0.97 * t.in_samplerate))), t.brate = 0 | t.out_samplerate * 16 * _.channels_out / (1e3 * t.compression_ratio), _.samplerate_index = n(t.out_samplerate, t), t.free_format || (t.brate = r(
        t.brate,
        t.version,
        t.out_samplerate
      ))), t.out_samplerate != 0 && (t.out_samplerate < 16e3 ? (t.VBR_mean_bitrate_kbps = Math.max(
        t.VBR_mean_bitrate_kbps,
        8
      ), t.VBR_mean_bitrate_kbps = Math.min(
        t.VBR_mean_bitrate_kbps,
        64
      )) : t.out_samplerate < 32e3 ? (t.VBR_mean_bitrate_kbps = Math.max(
        t.VBR_mean_bitrate_kbps,
        8
      ), t.VBR_mean_bitrate_kbps = Math.min(
        t.VBR_mean_bitrate_kbps,
        160
      )) : (t.VBR_mean_bitrate_kbps = Math.max(
        t.VBR_mean_bitrate_kbps,
        32
      ), t.VBR_mean_bitrate_kbps = Math.min(
        t.VBR_mean_bitrate_kbps,
        320
      ))), t.lowpassfreq == 0) {
        var d0 = 16e3;
        switch (t.VBR) {
          case y.vbr_off: {
            var E0 = new C();
            f(E0, t.brate), d0 = E0.lowerlimit;
            break;
          }
          case y.vbr_abr: {
            var E0 = new C();
            f(E0, t.VBR_mean_bitrate_kbps), d0 = E0.lowerlimit;
            break;
          }
          case y.vbr_rh: {
            var V0 = [
              19500,
              19e3,
              18600,
              18e3,
              17500,
              16e3,
              15600,
              14900,
              12500,
              1e4,
              3950
            ];
            if (0 <= t.VBR_q && t.VBR_q <= 9) {
              var N0 = V0[t.VBR_q], y0 = V0[t.VBR_q + 1], T0 = t.VBR_q_frac;
              d0 = linear_int(N0, y0, T0);
            } else
              d0 = 19500;
            break;
          }
          default: {
            var V0 = [
              19500,
              19e3,
              18500,
              18e3,
              17500,
              16500,
              15500,
              14500,
              12500,
              9500,
              3950
            ];
            if (0 <= t.VBR_q && t.VBR_q <= 9) {
              var N0 = V0[t.VBR_q], y0 = V0[t.VBR_q + 1], T0 = t.VBR_q_frac;
              d0 = linear_int(N0, y0, T0);
            } else
              d0 = 19500;
          }
        }
        t.mode == v.MONO && (t.VBR == y.vbr_off || t.VBR == y.vbr_abr) && (d0 *= 1.5), t.lowpassfreq = d0 | 0;
      }
      if (t.out_samplerate == 0 && (2 * t.lowpassfreq > t.in_samplerate && (t.lowpassfreq = t.in_samplerate / 2), t.out_samplerate = s(
        t.lowpassfreq | 0,
        t.in_samplerate
      )), t.lowpassfreq = Math.min(20500, t.lowpassfreq), t.lowpassfreq = Math.min(t.out_samplerate / 2, t.lowpassfreq), t.VBR == y.vbr_off && (t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.brate)), t.VBR == y.vbr_abr && (t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.VBR_mean_bitrate_kbps)), t.bWriteVbrTag || (t.findReplayGain = !1, t.decode_on_the_fly = !1, _.findPeakSample = !1), _.findReplayGain = t.findReplayGain, _.decode_on_the_fly = t.decode_on_the_fly, _.decode_on_the_fly && (_.findPeakSample = !0), _.findReplayGain && l.InitGainAnalysis(_.rgdata, t.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR)
        return t.internal_flags = null, -6;
      switch (_.decode_on_the_fly && !t.decode_only && (_.hip != null && a.hip_decode_exit(_.hip), _.hip = a.hip_decode_init()), _.mode_gr = t.out_samplerate <= 24e3 ? 1 : 2, t.framesize = 576 * _.mode_gr, t.encoder_delay = j.ENCDELAY, _.resample_ratio = t.in_samplerate / t.out_samplerate, t.VBR) {
        case y.vbr_mt:
        case y.vbr_rh:
        case y.vbr_mtrh:
          {
            var F0 = [
              5.7,
              6.5,
              7.3,
              8.2,
              10,
              11.9,
              13,
              14,
              15,
              16.5
            ];
            t.compression_ratio = F0[t.VBR_q];
          }
          break;
        case y.vbr_abr:
          t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.VBR_mean_bitrate_kbps);
          break;
        default:
          t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.brate);
          break;
      }
      if (t.mode == v.NOT_SET && (t.mode = v.JOINT_STEREO), t.highpassfreq > 0 ? (_.highpass1 = 2 * t.highpassfreq, t.highpasswidth >= 0 ? _.highpass2 = 2 * (t.highpassfreq + t.highpasswidth) : _.highpass2 = (1 + 0) * 2 * t.highpassfreq, _.highpass1 /= t.out_samplerate, _.highpass2 /= t.out_samplerate) : (_.highpass1 = 0, _.highpass2 = 0), t.lowpassfreq > 0 ? (_.lowpass2 = 2 * t.lowpassfreq, t.lowpasswidth >= 0 ? (_.lowpass1 = 2 * (t.lowpassfreq - t.lowpasswidth), _.lowpass1 < 0 && (_.lowpass1 = 0)) : _.lowpass1 = (1 - 0) * 2 * t.lowpassfreq, _.lowpass1 /= t.out_samplerate, _.lowpass2 /= t.out_samplerate) : (_.lowpass1 = 0, _.lowpass2 = 0), q(t), _.samplerate_index = n(t.out_samplerate, t), _.samplerate_index < 0)
        return t.internal_flags = null, -1;
      if (t.VBR == y.vbr_off) {
        if (t.free_format)
          _.bitrate_index = 0;
        else if (t.brate = r(
          t.brate,
          t.version,
          t.out_samplerate
        ), _.bitrate_index = i(
          t.brate,
          t.version,
          t.out_samplerate
        ), _.bitrate_index <= 0)
          return t.internal_flags = null, -1;
      } else
        _.bitrate_index = 1;
      t.analysis && (t.bWriteVbrTag = !1), _.pinfo != null && (t.bWriteVbrTag = !1), B.init_bit_stream_w(_);
      for (var p0 = _.samplerate_index + 3 * t.version + 6 * (t.out_samplerate < 16e3 ? 1 : 0), m0 = 0; m0 < j.SBMAX_l + 1; m0++)
        _.scalefac_band.l[m0] = O.sfBandIndex[p0].l[m0];
      for (var m0 = 0; m0 < j.PSFB21 + 1; m0++) {
        var G0 = (_.scalefac_band.l[22] - _.scalefac_band.l[21]) / j.PSFB21, e1 = _.scalefac_band.l[21] + m0 * G0;
        _.scalefac_band.psfb21[m0] = e1;
      }
      _.scalefac_band.psfb21[j.PSFB21] = 576;
      for (var m0 = 0; m0 < j.SBMAX_s + 1; m0++)
        _.scalefac_band.s[m0] = O.sfBandIndex[p0].s[m0];
      for (var m0 = 0; m0 < j.PSFB12 + 1; m0++) {
        var G0 = (_.scalefac_band.s[13] - _.scalefac_band.s[12]) / j.PSFB12, e1 = _.scalefac_band.s[12] + m0 * G0;
        _.scalefac_band.psfb12[m0] = e1;
      }
      _.scalefac_band.psfb12[j.PSFB12] = 192, t.version == 1 ? _.sideinfo_len = _.channels_out == 1 ? 4 + 17 : 4 + 32 : _.sideinfo_len = _.channels_out == 1 ? 4 + 9 : 4 + 17, t.error_protection && (_.sideinfo_len += 2), p(t), _.Class_ID = N;
      {
        var Y0;
        for (Y0 = 0; Y0 < 19; Y0++)
          _.nsPsy.pefirbuf[Y0] = 700 * _.mode_gr * _.channels_out;
        t.ATHtype == -1 && (t.ATHtype = 4);
      }
      switch (D(t.VBR_q <= 9), D(t.VBR_q >= 0), t.VBR) {
        case y.vbr_mt:
          t.VBR = y.vbr_mtrh;
        case y.vbr_mtrh: {
          t.useTemporal == null && (t.useTemporal = !1), V.apply_preset(t, 500 - t.VBR_q * 10, 0), t.quality < 0 && (t.quality = LAME_DEFAULT_QUALITY), t.quality < 5 && (t.quality = 0), t.quality > 5 && (t.quality = 5), _.PSY.mask_adjust = t.maskingadjust, _.PSY.mask_adjust_short = t.maskingadjust_short, t.experimentalY ? _.sfb21_extra = !1 : _.sfb21_extra = t.out_samplerate > 44e3, _.iteration_loop = new VBRNewIterationLoop(w);
          break;
        }
        case y.vbr_rh: {
          V.apply_preset(t, 500 - t.VBR_q * 10, 0), _.PSY.mask_adjust = t.maskingadjust, _.PSY.mask_adjust_short = t.maskingadjust_short, t.experimentalY ? _.sfb21_extra = !1 : _.sfb21_extra = t.out_samplerate > 44e3, t.quality > 6 && (t.quality = 6), t.quality < 0 && (t.quality = LAME_DEFAULT_QUALITY), _.iteration_loop = new VBROldIterationLoop(w);
          break;
        }
        default: {
          var o;
          _.sfb21_extra = !1, t.quality < 0 && (t.quality = LAME_DEFAULT_QUALITY), o = t.VBR, o == y.vbr_off && (t.VBR_mean_bitrate_kbps = t.brate), V.apply_preset(t, t.VBR_mean_bitrate_kbps, 0), t.VBR = o, _.PSY.mask_adjust = t.maskingadjust, _.PSY.mask_adjust_short = t.maskingadjust_short, o == y.vbr_off ? _.iteration_loop = new n0(w) : _.iteration_loop = new ABRIterationLoop(w);
          break;
        }
      }
      if (D(t.scale >= 0), t.VBR != y.vbr_off) {
        if (_.VBR_min_bitrate = 1, _.VBR_max_bitrate = 14, t.out_samplerate < 16e3 && (_.VBR_max_bitrate = 8), t.VBR_min_bitrate_kbps != 0 && (t.VBR_min_bitrate_kbps = r(
          t.VBR_min_bitrate_kbps,
          t.version,
          t.out_samplerate
        ), _.VBR_min_bitrate = i(
          t.VBR_min_bitrate_kbps,
          t.version,
          t.out_samplerate
        ), _.VBR_min_bitrate < 0) || t.VBR_max_bitrate_kbps != 0 && (t.VBR_max_bitrate_kbps = r(
          t.VBR_max_bitrate_kbps,
          t.version,
          t.out_samplerate
        ), _.VBR_max_bitrate = i(
          t.VBR_max_bitrate_kbps,
          t.version,
          t.out_samplerate
        ), _.VBR_max_bitrate < 0))
          return -1;
        t.VBR_min_bitrate_kbps = t0.bitrate_table[t.version][_.VBR_min_bitrate], t.VBR_max_bitrate_kbps = t0.bitrate_table[t.version][_.VBR_max_bitrate], t.VBR_mean_bitrate_kbps = Math.min(
          t0.bitrate_table[t.version][_.VBR_max_bitrate],
          t.VBR_mean_bitrate_kbps
        ), t.VBR_mean_bitrate_kbps = Math.max(
          t0.bitrate_table[t.version][_.VBR_min_bitrate],
          t.VBR_mean_bitrate_kbps
        );
      }
      return t.tune && (_.PSY.mask_adjust += t.tune_value_a, _.PSY.mask_adjust_short += t.tune_value_a), g(t), D(t.scale >= 0), t.athaa_type < 0 ? _.ATH.useAdjust = 3 : _.ATH.useAdjust = t.athaa_type, _.ATH.aaSensitivityP = Math.pow(10, t.athaa_sensitivity / -10), t.short_blocks == null && (t.short_blocks = K.short_block_allowed), t.short_blocks == K.short_block_allowed && (t.mode == v.JOINT_STEREO || t.mode == v.STEREO) && (t.short_blocks = K.short_block_coupled), t.quant_comp < 0 && (t.quant_comp = 1), t.quant_comp_short < 0 && (t.quant_comp_short = 0), t.msfix < 0 && (t.msfix = 0), t.exp_nspsytune = t.exp_nspsytune | 1, t.internal_flags.nsPsy.attackthre < 0 && (t.internal_flags.nsPsy.attackthre = W.NSATTACKTHRE), t.internal_flags.nsPsy.attackthre_s < 0 && (t.internal_flags.nsPsy.attackthre_s = W.NSATTACKTHRE_S), D(t.scale >= 0), t.scale < 0 && (t.scale = 1), t.ATHtype < 0 && (t.ATHtype = 4), t.ATHcurve < 0 && (t.ATHcurve = 4), t.athaa_loudapprox < 0 && (t.athaa_loudapprox = 2), t.interChRatio < 0 && (t.interChRatio = 0), t.useTemporal == null && (t.useTemporal = !0), _.slot_lag = _.frac_SpF = 0, t.VBR == y.vbr_off && (_.slot_lag = _.frac_SpF = (t.version + 1) * 72e3 * t.brate % t.out_samplerate | 0), O.iteration_init(t), L.psymodel_init(t), D(t.scale >= 0), 0;
    };
    function G(t, _) {
      (t.in_buffer_0 == null || t.in_buffer_nsamples < _) && (t.in_buffer_0 = i0(_), t.in_buffer_1 = i0(_), t.in_buffer_nsamples = _);
    }
    this.lame_encode_flush = function(t, _, d0, E0) {
      var V0 = t.internal_flags, N0 = z([2, 1152]), y0 = 0, T0, F0, p0, m0, G0 = V0.mf_samples_to_encode - j.POSTDELAY, e1 = s0(t);
      if (V0.mf_samples_to_encode < 1)
        return 0;
      for (T0 = 0, t.in_samplerate != t.out_samplerate && (G0 += 16 * t.out_samplerate / t.in_samplerate), p0 = t.framesize - G0 % t.framesize, p0 < 576 && (p0 += t.framesize), t.encoder_padding = p0, m0 = (G0 + p0) / t.framesize; m0 > 0 && y0 >= 0; ) {
        var Y0 = e1 - V0.mf_size, o = t.frameNum;
        Y0 *= t.in_samplerate, Y0 /= t.out_samplerate, Y0 > 1152 && (Y0 = 1152), Y0 < 1 && (Y0 = 1), F0 = E0 - T0, E0 == 0 && (F0 = 0), y0 = this.lame_encode_buffer(
          t,
          N0[0],
          N0[1],
          Y0,
          _,
          d0,
          F0
        ), d0 += y0, T0 += y0, m0 -= o != t.frameNum ? 1 : 0;
      }
      if (V0.mf_samples_to_encode = 0, y0 < 0 || (F0 = E0 - T0, E0 == 0 && (F0 = 0), B.flush_bitstream(t), y0 = B.copy_buffer(
        V0,
        _,
        d0,
        F0,
        1
      ), y0 < 0))
        return y0;
      if (d0 += y0, T0 += y0, F0 = E0 - T0, E0 == 0 && (F0 = 0), t.write_id3tag_automatic) {
        if (b.id3tag_write_v1(t), y0 = B.copy_buffer(
          V0,
          _,
          d0,
          F0,
          0
        ), y0 < 0)
          return y0;
        T0 += y0;
      }
      return T0;
    }, this.lame_encode_buffer = function(t, _, d0, E0, V0, N0, y0) {
      var T0 = t.internal_flags, F0 = [null, null];
      if (T0.Class_ID != N)
        return -3;
      if (E0 == 0)
        return 0;
      G(T0, E0), F0[0] = T0.in_buffer_0, F0[1] = T0.in_buffer_1;
      for (var p0 = 0; p0 < E0; p0++)
        F0[0][p0] = _[p0], T0.channels_in > 1 && (F0[1][p0] = d0[p0]);
      return h0(
        t,
        F0[0],
        F0[1],
        E0,
        V0,
        N0,
        y0
      );
    };
    function s0(t) {
      var _ = j.BLKSIZE + t.framesize - j.FFTOFFSET;
      return _ = Math.max(_, 512 + t.framesize - 32), _;
    }
    function h0(t, _, d0, E0, V0, N0, y0) {
      var T0 = t.internal_flags, F0 = 0, p0, m0, G0, e1, Y0, o = [null, null], u = [null, null];
      if (T0.Class_ID != N)
        return -3;
      if (E0 == 0)
        return 0;
      if (Y0 = B.copy_buffer(T0, V0, N0, y0, 0), Y0 < 0)
        return Y0;
      if (N0 += Y0, F0 += Y0, u[0] = _, u[1] = d0, Q.NEQ(t.scale, 0) && Q.NEQ(t.scale, 1))
        for (m0 = 0; m0 < E0; ++m0)
          u[0][m0] *= t.scale, T0.channels_out == 2 && (u[1][m0] *= t.scale);
      if (Q.NEQ(t.scale_left, 0) && Q.NEQ(t.scale_left, 1))
        for (m0 = 0; m0 < E0; ++m0)
          u[0][m0] *= t.scale_left;
      if (Q.NEQ(t.scale_right, 0) && Q.NEQ(t.scale_right, 1))
        for (m0 = 0; m0 < E0; ++m0)
          u[1][m0] *= t.scale_right;
      if (t.num_channels == 2 && T0.channels_out == 1)
        for (m0 = 0; m0 < E0; ++m0)
          u[0][m0] = 0.5 * (u[0][m0] + u[1][m0]), u[1][m0] = 0;
      e1 = s0(t), o[0] = T0.mfbuf[0], o[1] = T0.mfbuf[1];
      for (var E = 0; E0 > 0; ) {
        var I = [null, null], Y = 0, d = 0;
        I[0] = u[0], I[1] = u[1];
        var k = new M0();
        if (f1(
          t,
          o,
          I,
          E,
          E0,
          k
        ), Y = k.n_in, d = k.n_out, T0.findReplayGain && !T0.decode_on_the_fly && l.AnalyzeSamples(
          T0.rgdata,
          o[0],
          T0.mf_size,
          o[1],
          T0.mf_size,
          d,
          T0.channels_out
        ) == GainAnalysis.GAIN_ANALYSIS_ERROR)
          return -6;
        if (E0 -= Y, E += Y, T0.channels_out == 2, T0.mf_size += d, D(T0.mf_size <= R.MFSIZE), T0.mf_samples_to_encode < 1 && (T0.mf_samples_to_encode = j.ENCDELAY + j.POSTDELAY), T0.mf_samples_to_encode += d, T0.mf_size >= e1) {
          var $ = y0 - F0;
          if (y0 == 0 && ($ = 0), p0 = S0(
            t,
            o[0],
            o[1],
            V0,
            N0,
            $
          ), p0 < 0)
            return p0;
          for (N0 += p0, F0 += p0, T0.mf_size -= t.framesize, T0.mf_samples_to_encode -= t.framesize, G0 = 0; G0 < T0.channels_out; G0++)
            for (m0 = 0; m0 < T0.mf_size; m0++)
              o[G0][m0] = o[G0][m0 + t.framesize];
        }
      }
      return F0;
    }
    function S0(t, _, d0, E0, V0, N0) {
      var y0 = h.enc.lame_encode_mp3_frame(
        t,
        _,
        d0,
        E0,
        V0,
        N0
      );
      return t.frameNum++, y0;
    }
    function M0() {
      this.n_in = 0, this.n_out = 0;
    }
    function R0() {
      this.num_used = 0;
    }
    function A0(t, _) {
      return _ != 0 ? A0(_, t % _) : t;
    }
    function w0(t, _, d0) {
      var E0 = Math.PI * _;
      t /= d0, t < 0 && (t = 0), t > 1 && (t = 1);
      var V0 = t - 0.5, N0 = 0.42 - 0.5 * Math.cos(2 * t * Math.PI) + 0.08 * Math.cos(4 * t * Math.PI);
      return Math.abs(V0) < 1e-9 ? E0 / Math.PI : N0 * Math.sin(d0 * E0 * V0) / (Math.PI * d0 * V0);
    }
    function $0(t, _, d0, E0, V0, N0, y0, T0, F0) {
      var p0 = t.internal_flags, m0, G0 = 0, e1, Y0 = t.out_samplerate / A0(t.out_samplerate, t.in_samplerate);
      Y0 > R.BPC && (Y0 = R.BPC);
      var o = Math.abs(p0.resample_ratio - Math.floor(0.5 + p0.resample_ratio)) < 1e-4 ? 1 : 0, u = 1 / p0.resample_ratio;
      u > 1 && (u = 1);
      var E = 31;
      E % 2 == 0 && --E, E += o;
      var I = E + 1;
      if (p0.fill_buffer_resample_init == 0) {
        for (p0.inbuf_old[0] = i0(I), p0.inbuf_old[1] = i0(I), m0 = 0; m0 <= 2 * Y0; ++m0)
          p0.blackfilt[m0] = i0(I);
        for (p0.itime[0] = 0, p0.itime[1] = 0, G0 = 0; G0 <= 2 * Y0; G0++) {
          var Y = 0, d = (G0 - Y0) / (2 * Y0);
          for (m0 = 0; m0 <= E; m0++)
            Y += p0.blackfilt[G0][m0] = w0(
              m0 - d,
              u,
              E
            );
          for (m0 = 0; m0 <= E; m0++)
            p0.blackfilt[G0][m0] /= Y;
        }
        p0.fill_buffer_resample_init = 1;
      }
      var k = p0.inbuf_old[F0];
      for (e1 = 0; e1 < E0; e1++) {
        var $, X;
        if ($ = e1 * p0.resample_ratio, G0 = 0 | Math.floor($ - p0.itime[F0]), E + G0 - E / 2 >= y0)
          break;
        var d = $ - p0.itime[F0] - (G0 + 0.5 * (E % 2));
        X = 0 | Math.floor(d * 2 * Y0 + Y0 + 0.5);
        var e0 = 0;
        for (m0 = 0; m0 <= E; ++m0) {
          var Z = 0 | m0 + G0 - E / 2, a0;
          a0 = Z < 0 ? k[I + Z] : V0[N0 + Z], e0 += a0 * p0.blackfilt[X][m0];
        }
        _[d0 + e1] = e0;
      }
      if (T0.num_used = Math.min(y0, E + G0 - E / 2), p0.itime[F0] += T0.num_used - e1 * p0.resample_ratio, T0.num_used >= I)
        for (m0 = 0; m0 < I; m0++)
          k[m0] = V0[N0 + T0.num_used + m0 - I];
      else {
        var c0 = I - T0.num_used;
        for (m0 = 0; m0 < c0; ++m0)
          k[m0] = k[m0 + T0.num_used];
        for (G0 = 0; m0 < I; ++m0, ++G0)
          k[m0] = V0[N0 + G0];
        D(G0 == T0.num_used);
      }
      return e1;
    }
    function f1(t, _, d0, E0, V0, N0) {
      var y0 = t.internal_flags;
      if (y0.resample_ratio < 0.9999 || y0.resample_ratio > 1.0001)
        for (var T0 = 0; T0 < y0.channels_out; T0++) {
          var F0 = new R0();
          N0.n_out = $0(
            t,
            _[T0],
            y0.mf_size,
            t.framesize,
            d0[T0],
            E0,
            V0,
            F0,
            T0
          ), N0.n_in = F0.num_used;
        }
      else {
        N0.n_out = Math.min(t.framesize, V0), N0.n_in = N0.n_out;
        for (var p0 = 0; p0 < N0.n_out; ++p0)
          _[0][y0.mf_size + p0] = d0[0][E0 + p0], y0.channels_out == 2 && (_[1][y0.mf_size + p0] = d0[1][E0 + p0]);
      }
    }
  }
  return Le = M, Le;
}
var Qr = Q0, x1 = Qr.VbrMode;
function zr() {
  var m = Ye();
  function x(R, c, H, n0, Q, t0, j, M, v, h, A, e, l, B, V) {
    this.vbr_q = R, this.quant_comp = c, this.quant_comp_s = H, this.expY = n0, this.st_lrm = Q, this.st_s = t0, this.masking_adj = j, this.masking_adj_short = M, this.ath_lower = v, this.ath_curve = h, this.ath_sensitivity = A, this.interch = e, this.safejoint = l, this.sfb21mod = B, this.msfix = V;
  }
  function y(R, c, H, n0, Q, t0, j, M, v, h, A, e, l, B) {
    this.quant_comp = c, this.quant_comp_s = H, this.safejoint = n0, this.nsmsfix = Q, this.st_lrm = t0, this.st_s = j, this.nsbass = M, this.scale = v, this.masking_adj = h, this.ath_lower = A, this.ath_curve = e, this.interch = l, this.sfscale = B;
  }
  var K;
  this.setModules = function(R) {
    K = R;
  };
  var i0 = [
    new x(0, 9, 9, 0, 5.2, 125, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, 0.97),
    new x(1, 9, 9, 0, 5.3, 125, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
    new x(2, 9, 9, 0, 5.6, 125, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49),
    new x(3, 9, 9, 1, 5.8, 130, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64),
    new x(4, 9, 9, 1, 6, 135, -0.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79),
    new x(5, 9, 9, 1, 6.4, 140, 0.5, 0.4, -7.5, 4, -12, 2e-4, 0, 0, 1.95),
    new x(6, 9, 9, 1, 6.6, 145, 0.67, 0.65, -14.7, 6.5, -19, 4e-4, 0, 0, 2.3),
    new x(7, 9, 9, 1, 6.6, 145, 0.8, 0.75, -19.7, 8, -22, 6e-4, 0, 0, 2.7),
    new x(8, 9, 9, 1, 6.6, 145, 1.2, 1.15, -27.5, 10, -23, 7e-4, 0, 0, 0),
    new x(9, 9, 9, 1, 6.6, 145, 1.6, 1.6, -36, 11, -25, 8e-4, 0, 0, 0),
    new x(10, 9, 9, 1, 6.6, 145, 2, 2, -36, 12, -25, 8e-4, 0, 0, 0)
  ], P = [
    new x(0, 9, 9, 0, 4.2, 25, -7, -4, 7.5, 1, 0, 0, 2, 26, 0.97),
    new x(1, 9, 9, 0, 4.2, 25, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
    new x(2, 9, 9, 0, 4.2, 25, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49),
    new x(3, 9, 9, 1, 4.2, 25, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64),
    new x(4, 9, 9, 1, 4.2, 25, -2.2, 0.1, 0, 3.5, -8, 0, 2, 0, 1.79),
    new x(5, 9, 9, 1, 4.2, 25, -1, 1.65, -7.7, 4, -12, 2e-4, 0, 0, 1.95),
    new x(6, 9, 9, 1, 4.2, 25, -0, 2.47, -7.7, 6.5, -19, 4e-4, 0, 0, 2),
    new x(7, 9, 9, 1, 4.2, 25, 0.5, 2, -14.5, 8, -22, 6e-4, 0, 0, 2),
    new x(8, 9, 9, 1, 4.2, 25, 1, 2.4, -22, 10, -23, 7e-4, 0, 0, 2),
    new x(9, 9, 9, 1, 4.2, 25, 1.5, 2.95, -30, 11, -25, 8e-4, 0, 0, 2),
    new x(10, 9, 9, 1, 4.2, 25, 2, 2.95, -36, 12, -30, 8e-4, 0, 0, 2)
  ];
  function z(R, c, H) {
    var n0 = R.VBR == x1.vbr_rh ? i0 : P, Q = R.VBR_q_frac, t0 = n0[c], j = n0[c + 1], M = t0;
    t0.st_lrm = t0.st_lrm + Q * (j.st_lrm - t0.st_lrm), t0.st_s = t0.st_s + Q * (j.st_s - t0.st_s), t0.masking_adj = t0.masking_adj + Q * (j.masking_adj - t0.masking_adj), t0.masking_adj_short = t0.masking_adj_short + Q * (j.masking_adj_short - t0.masking_adj_short), t0.ath_lower = t0.ath_lower + Q * (j.ath_lower - t0.ath_lower), t0.ath_curve = t0.ath_curve + Q * (j.ath_curve - t0.ath_curve), t0.ath_sensitivity = t0.ath_sensitivity + Q * (j.ath_sensitivity - t0.ath_sensitivity), t0.interch = t0.interch + Q * (j.interch - t0.interch), t0.msfix = t0.msfix + Q * (j.msfix - t0.msfix), f0(R, M.vbr_q), H != 0 ? R.quant_comp = M.quant_comp : Math.abs(R.quant_comp - -1) > 0 || (R.quant_comp = M.quant_comp), H != 0 ? R.quant_comp_short = M.quant_comp_s : Math.abs(R.quant_comp_short - -1) > 0 || (R.quant_comp_short = M.quant_comp_s), M.expY != 0 && (R.experimentalY = M.expY != 0), H != 0 ? R.internal_flags.nsPsy.attackthre = M.st_lrm : Math.abs(R.internal_flags.nsPsy.attackthre - -1) > 0 || (R.internal_flags.nsPsy.attackthre = M.st_lrm), H != 0 ? R.internal_flags.nsPsy.attackthre_s = M.st_s : Math.abs(R.internal_flags.nsPsy.attackthre_s - -1) > 0 || (R.internal_flags.nsPsy.attackthre_s = M.st_s), H != 0 ? R.maskingadjust = M.masking_adj : Math.abs(R.maskingadjust - 0) > 0 || (R.maskingadjust = M.masking_adj), H != 0 ? R.maskingadjust_short = M.masking_adj_short : Math.abs(R.maskingadjust_short - 0) > 0 || (R.maskingadjust_short = M.masking_adj_short), H != 0 ? R.ATHlower = -M.ath_lower / 10 : Math.abs(-R.ATHlower * 10 - 0) > 0 || (R.ATHlower = -M.ath_lower / 10), H != 0 ? R.ATHcurve = M.ath_curve : Math.abs(R.ATHcurve - -1) > 0 || (R.ATHcurve = M.ath_curve), H != 0 ? R.athaa_sensitivity = M.ath_sensitivity : Math.abs(R.athaa_sensitivity - -1) > 0 || (R.athaa_sensitivity = M.ath_sensitivity), M.interch > 0 && (H != 0 ? R.interChRatio = M.interch : Math.abs(R.interChRatio - -1) > 0 || (R.interChRatio = M.interch)), M.safejoint > 0 && (R.exp_nspsytune = R.exp_nspsytune | M.safejoint), M.sfb21mod > 0 && (R.exp_nspsytune = R.exp_nspsytune | M.sfb21mod << 20), H != 0 ? R.msfix = M.msfix : Math.abs(R.msfix - -1) > 0 || (R.msfix = M.msfix), H == 0 && (R.VBR_q = c, R.VBR_q_frac = Q);
  }
  var D = [
    new y(8, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -30, 11, 12e-4, 1),
    /*   8, impossible to use in stereo */
    new y(16, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -25, 11, 1e-3, 1),
    /*  16 */
    new y(24, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -20, 11, 1e-3, 1),
    /*  24 */
    new y(32, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -15, 11, 1e-3, 1),
    /*  32 */
    new y(40, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -10, 11, 9e-4, 1),
    /*  40 */
    new y(48, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -10, 11, 9e-4, 1),
    /*  48 */
    new y(56, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -6, 11, 8e-4, 1),
    /*  56 */
    new y(64, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -2, 11, 8e-4, 1),
    /*  64 */
    new y(80, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, 0, 8, 7e-4, 1),
    /*  80 */
    new y(96, 9, 9, 0, 2.5, 6.6, 145, 0, 0.95, 0, 1, 5.5, 6e-4, 1),
    /*  96 */
    new y(112, 9, 9, 0, 2.25, 6.6, 145, 0, 0.95, 0, 2, 4.5, 5e-4, 1),
    /* 112 */
    new y(128, 9, 9, 0, 1.95, 6.4, 140, 0, 0.95, 0, 3, 4, 2e-4, 1),
    /* 128 */
    new y(160, 9, 9, 1, 1.79, 6, 135, 0, 0.95, -2, 5, 3.5, 0, 1),
    /* 160 */
    new y(192, 9, 9, 1, 1.49, 5.6, 125, 0, 0.97, -4, 7, 3, 0, 0),
    /* 192 */
    new y(224, 9, 9, 1, 1.25, 5.2, 125, 0, 0.98, -6, 9, 2, 0, 0),
    /* 224 */
    new y(256, 9, 9, 1, 0.97, 5.2, 125, 0, 1, -8, 10, 1, 0, 0),
    /* 256 */
    new y(320, 9, 9, 1, 0.9, 5.2, 125, 0, 1, -10, 12, 0, 0, 0)
    /* 320 */
  ];
  function W(R, c, H) {
    var n0 = c, Q = K.nearestBitrateFullIndex(c);
    if (R.VBR = x1.vbr_abr, R.VBR_mean_bitrate_kbps = n0, R.VBR_mean_bitrate_kbps = Math.min(R.VBR_mean_bitrate_kbps, 320), R.VBR_mean_bitrate_kbps = Math.max(R.VBR_mean_bitrate_kbps, 8), R.brate = R.VBR_mean_bitrate_kbps, R.VBR_mean_bitrate_kbps > 320 && (R.disable_reservoir = !0), D[Q].safejoint > 0 && (R.exp_nspsytune = R.exp_nspsytune | 2), D[Q].sfscale > 0 && (R.internal_flags.noise_shaping = 2), Math.abs(D[Q].nsbass) > 0) {
      var t0 = int(D[Q].nsbass * 4);
      t0 < 0 && (t0 += 64), R.exp_nspsytune = R.exp_nspsytune | t0 << 2;
    }
    return H != 0 ? R.quant_comp = D[Q].quant_comp : Math.abs(R.quant_comp - -1) > 0 || (R.quant_comp = D[Q].quant_comp), H != 0 ? R.quant_comp_short = D[Q].quant_comp_s : Math.abs(R.quant_comp_short - -1) > 0 || (R.quant_comp_short = D[Q].quant_comp_s), H != 0 ? R.msfix = D[Q].nsmsfix : Math.abs(R.msfix - -1) > 0 || (R.msfix = D[Q].nsmsfix), H != 0 ? R.internal_flags.nsPsy.attackthre = D[Q].st_lrm : Math.abs(R.internal_flags.nsPsy.attackthre - -1) > 0 || (R.internal_flags.nsPsy.attackthre = D[Q].st_lrm), H != 0 ? R.internal_flags.nsPsy.attackthre_s = D[Q].st_s : Math.abs(R.internal_flags.nsPsy.attackthre_s - -1) > 0 || (R.internal_flags.nsPsy.attackthre_s = D[Q].st_s), H != 0 ? R.scale = D[Q].scale : Math.abs(R.scale - -1) > 0 || (R.scale = D[Q].scale), H != 0 ? R.maskingadjust = D[Q].masking_adj : Math.abs(R.maskingadjust - 0) > 0 || (R.maskingadjust = D[Q].masking_adj), D[Q].masking_adj > 0 ? H != 0 ? R.maskingadjust_short = D[Q].masking_adj * 0.9 : Math.abs(R.maskingadjust_short - 0) > 0 || (R.maskingadjust_short = D[Q].masking_adj * 0.9) : H != 0 ? R.maskingadjust_short = D[Q].masking_adj * 1.1 : Math.abs(R.maskingadjust_short - 0) > 0 || (R.maskingadjust_short = D[Q].masking_adj * 1.1), H != 0 ? R.ATHlower = -D[Q].ath_lower / 10 : Math.abs(-R.ATHlower * 10 - 0) > 0 || (R.ATHlower = -D[Q].ath_lower / 10), H != 0 ? R.ATHcurve = D[Q].ath_curve : Math.abs(R.ATHcurve - -1) > 0 || (R.ATHcurve = D[Q].ath_curve), H != 0 ? R.interChRatio = D[Q].interch : Math.abs(R.interChRatio - -1) > 0 || (R.interChRatio = D[Q].interch), c;
  }
  this.apply_preset = function(R, c, H) {
    switch (c) {
      case m.R3MIX: {
        c = m.V3, R.VBR = x1.vbr_mtrh;
        break;
      }
      case m.MEDIUM: {
        c = m.V4, R.VBR = x1.vbr_rh;
        break;
      }
      case m.MEDIUM_FAST: {
        c = m.V4, R.VBR = x1.vbr_mtrh;
        break;
      }
      case m.STANDARD: {
        c = m.V2, R.VBR = x1.vbr_rh;
        break;
      }
      case m.STANDARD_FAST: {
        c = m.V2, R.VBR = x1.vbr_mtrh;
        break;
      }
      case m.EXTREME: {
        c = m.V0, R.VBR = x1.vbr_rh;
        break;
      }
      case m.EXTREME_FAST: {
        c = m.V0, R.VBR = x1.vbr_mtrh;
        break;
      }
      case m.INSANE:
        return c = 320, R.preset = c, W(R, c, H), R.VBR = x1.vbr_off, c;
    }
    switch (R.preset = c, c) {
      case m.V9:
        return z(R, 9, H), c;
      case m.V8:
        return z(R, 8, H), c;
      case m.V7:
        return z(R, 7, H), c;
      case m.V6:
        return z(R, 6, H), c;
      case m.V5:
        return z(R, 5, H), c;
      case m.V4:
        return z(R, 4, H), c;
      case m.V3:
        return z(R, 3, H), c;
      case m.V2:
        return z(R, 2, H), c;
      case m.V1:
        return z(R, 1, H), c;
      case m.V0:
        return z(R, 0, H), c;
    }
    return 8 <= c && c <= 320 ? W(R, c, H) : (R.preset = 0, c);
  };
  function f0(R, c) {
    var H = 0;
    return 0 > c && (H = -1, c = 0), 9 < c && (H = -1, c = 9), R.VBR_q = c, R.VBR_q_frac = 0, H;
  }
}
var jr = zr;
function Wr() {
  this.setModules = function(m, x) {
  };
}
var Jr = Wr;
function gr() {
  this.over_noise = 0, this.tot_noise = 0, this.max_noise = 0, this.over_count = 0, this.over_SSD = 0, this.bits = 0;
}
var et = gr, Ga = Q0, ua = Ga.new_float, at = Ga.new_int;
function rt() {
  this.global_gain = 0, this.sfb_count1 = 0, this.step = at(39), this.noise = ua(39), this.noise_log = ua(39);
}
var tt = rt, q1 = Q0, y1 = q1.System, ha = q1.VbrMode, Ce = q1.Util, X1 = q1.Arrays, K1 = q1.new_float, U1 = q1.assert, nt = Jr, Ne = et, st = tt, D0 = t1(), fa = He, ca = ve;
function it() {
  var m;
  this.rv = null;
  var x;
  this.qupvt = null;
  var y, K = new nt(), i0;
  this.setModules = function(M, v, h, A) {
    m = M, x = v, this.rv = v, y = h, this.qupvt = h, i0 = A, K.setModules(y, i0);
  }, this.ms_convert = function(M, v) {
    for (var h = 0; h < 576; ++h) {
      var A = M.tt[v][0].xr[h], e = M.tt[v][1].xr[h];
      M.tt[v][0].xr[h] = (A + e) * (Ce.SQRT2 * 0.5), M.tt[v][1].xr[h] = (A - e) * (Ce.SQRT2 * 0.5);
    }
  };
  function P(M, v, h, A) {
    A = 0;
    for (var e = 0; e <= h; ++e) {
      var l = Math.abs(M.xr[e]);
      A += l, v[e] = Math.sqrt(l * Math.sqrt(l)), v[e] > M.xrpow_max && (M.xrpow_max = v[e]);
    }
    return A;
  }
  this.init_xrpow = function(M, v, h) {
    var A = 0, e = 0 | v.max_nonzero_coeff;
    if (v.xrpow_max = 0, X1.fill(h, e, 576, 0), A = P(v, h, e, A), A > 1e-20) {
      var l = 0;
      M.substep_shaping & 2 && (l = 1);
      for (var B = 0; B < v.psymax; B++)
        M.pseudohalf[B] = l;
      return !0;
    }
    return X1.fill(v.l3_enc, 0, 576, 0), !1;
  };
  function z(M, v) {
    var h = M.ATH, A = v.xr;
    if (v.block_type != D0.SHORT_TYPE)
      for (var e = !1, l = D0.PSFB21 - 1; l >= 0 && !e; l--) {
        var B = M.scalefac_band.psfb21[l], V = M.scalefac_band.psfb21[l + 1], O = y.athAdjust(
          h.adjust,
          h.psfb21[l],
          h.floor
        );
        M.nsPsy.longfact[21] > 1e-12 && (O *= M.nsPsy.longfact[21]);
        for (var w = V - 1; w >= B; w--)
          if (Math.abs(A[w]) < O)
            A[w] = 0;
          else {
            e = !0;
            break;
          }
      }
    else
      for (var L = 0; L < 3; L++)
        for (var e = !1, l = D0.PSFB12 - 1; l >= 0 && !e; l--) {
          var B = M.scalefac_band.s[12] * 3 + (M.scalefac_band.s[13] - M.scalefac_band.s[12]) * L + (M.scalefac_band.psfb12[l] - M.scalefac_band.psfb12[0]), V = B + (M.scalefac_band.psfb12[l + 1] - M.scalefac_band.psfb12[l]), v0 = y.athAdjust(
            h.adjust,
            h.psfb12[l],
            h.floor
          );
          M.nsPsy.shortfact[12] > 1e-12 && (v0 *= M.nsPsy.shortfact[12]);
          for (var w = V - 1; w >= B; w--)
            if (Math.abs(A[w]) < v0)
              A[w] = 0;
            else {
              e = !0;
              break;
            }
        }
  }
  this.init_outer_loop = function(M, v) {
    v.part2_3_length = 0, v.big_values = 0, v.count1 = 0, v.global_gain = 210, v.scalefac_compress = 0, v.table_select[0] = 0, v.table_select[1] = 0, v.table_select[2] = 0, v.subblock_gain[0] = 0, v.subblock_gain[1] = 0, v.subblock_gain[2] = 0, v.subblock_gain[3] = 0, v.region0_count = 0, v.region1_count = 0, v.preflag = 0, v.scalefac_scale = 0, v.count1table_select = 0, v.part2_length = 0, v.sfb_lmax = D0.SBPSY_l, v.sfb_smin = D0.SBPSY_s, v.psy_lmax = M.sfb21_extra ? D0.SBMAX_l : D0.SBPSY_l, v.psymax = v.psy_lmax, v.sfbmax = v.sfb_lmax, v.sfbdivide = 11;
    for (var h = 0; h < D0.SBMAX_l; h++)
      v.width[h] = M.scalefac_band.l[h + 1] - M.scalefac_band.l[h], v.window[h] = 3;
    if (v.block_type == D0.SHORT_TYPE) {
      var A = K1(576);
      v.sfb_smin = 0, v.sfb_lmax = 0, v.mixed_block_flag != 0 && (v.sfb_smin = 3, v.sfb_lmax = M.mode_gr * 2 + 4), v.psymax = v.sfb_lmax + 3 * ((M.sfb21_extra ? D0.SBMAX_s : D0.SBPSY_s) - v.sfb_smin), v.sfbmax = v.sfb_lmax + 3 * (D0.SBPSY_s - v.sfb_smin), v.sfbdivide = v.sfbmax - 18, v.psy_lmax = v.sfb_lmax;
      var e = M.scalefac_band.l[v.sfb_lmax];
      y1.arraycopy(v.xr, 0, A, 0, 576);
      for (var h = v.sfb_smin; h < D0.SBMAX_s; h++)
        for (var l = M.scalefac_band.s[h], B = M.scalefac_band.s[h + 1], V = 0; V < 3; V++)
          for (var O = l; O < B; O++)
            v.xr[e++] = A[3 * O + V];
      for (var w = v.sfb_lmax, h = v.sfb_smin; h < D0.SBMAX_s; h++)
        v.width[w] = v.width[w + 1] = v.width[w + 2] = M.scalefac_band.s[h + 1] - M.scalefac_band.s[h], v.window[w] = 0, v.window[w + 1] = 1, v.window[w + 2] = 2, w += 3;
    }
    v.count1bits = 0, v.sfb_partition_table = y.nr_of_sfb_block[0][0], v.slen[0] = 0, v.slen[1] = 0, v.slen[2] = 0, v.slen[3] = 0, v.max_nonzero_coeff = 575, X1.fill(v.scalefac, 0), z(M, v);
  };
  function D(M) {
    this.ordinal = M;
  }
  D.BINSEARCH_NONE = new D(0), D.BINSEARCH_UP = new D(1), D.BINSEARCH_DOWN = new D(2);
  function W(M, v, h, A, e) {
    var l, B = M.CurrentStep[A], V = !1, O = M.OldValue[A], w = D.BINSEARCH_NONE;
    for (v.global_gain = O, h -= v.part2_length; ; ) {
      var L;
      if (l = i0.count_bits(M, e, v, null), B == 1 || l == h)
        break;
      l > h ? (w == D.BINSEARCH_DOWN && (V = !0), V && (B /= 2), w = D.BINSEARCH_UP, L = B) : (w == D.BINSEARCH_UP && (V = !0), V && (B /= 2), w = D.BINSEARCH_DOWN, L = -B), v.global_gain += L, v.global_gain < 0 && (v.global_gain = 0, V = !0), v.global_gain > 255 && (v.global_gain = 255, V = !0);
    }
    for (U1(v.global_gain >= 0), U1(v.global_gain < 256); l > h && v.global_gain < 255; )
      v.global_gain++, l = i0.count_bits(M, e, v, null);
    return M.CurrentStep[A] = O - v.global_gain >= 4 ? 4 : 2, M.OldValue[A] = v.global_gain, v.part2_3_length = l, l;
  }
  this.trancate_smallspectrums = function(M, v, h, A) {
    var e = K1(ca.SFBMAX);
    if (!(!(M.substep_shaping & 4) && v.block_type == D0.SHORT_TYPE || M.substep_shaping & 128)) {
      y.calc_noise(v, h, e, new Ne(), null);
      for (var B = 0; B < 576; B++) {
        var l = 0;
        v.l3_enc[B] != 0 && (l = Math.abs(v.xr[B])), A[B] = l;
      }
      var B = 0, V = 8;
      v.block_type == D0.SHORT_TYPE && (V = 6);
      do {
        var O, w, L, v0, b = v.width[V];
        if (B += b, !(e[V] >= 1) && (X1.sort(A, B - b, b), !BitStream.EQ(A[B - 1], 0))) {
          O = (1 - e[V]) * h[V], w = 0, v0 = 0;
          do {
            var a;
            for (L = 1; v0 + L < b && !BitStream.NEQ(A[v0 + B - b], A[v0 + B + L - b]); L++)
              ;
            if (a = A[v0 + B - b] * A[v0 + B - b] * L, O < a) {
              v0 != 0 && (w = A[v0 + B - b - 1]);
              break;
            }
            O -= a, v0 += L;
          } while (v0 < b);
          if (!BitStream.EQ(w, 0))
            do
              Math.abs(v.xr[B - b]) <= w && (v.l3_enc[B - b] = 0);
            while (--b > 0);
        }
      } while (++V < v.psymax);
      v.part2_3_length = i0.noquant_count_bits(M, v, null);
    }
  };
  function f0(M) {
    for (var v = 0; v < M.sfbmax; v++)
      if (M.scalefac[v] + M.subblock_gain[M.window[v]] == 0)
        return !1;
    return !0;
  }
  function R(M) {
    return Ce.FAST_LOG10(0.368 + 0.632 * M * M * M);
  }
  function c(M, v) {
    for (var h = 1e-37, A = 0; A < v.psymax; A++)
      h += R(M[A]);
    return Math.max(1e-20, h);
  }
  function H(M, v, h, A, e) {
    var l;
    switch (M) {
      default:
      case 9: {
        v.over_count > 0 ? (l = h.over_SSD <= v.over_SSD, h.over_SSD == v.over_SSD && (l = h.bits < v.bits)) : l = h.max_noise < 0 && h.max_noise * 10 + h.bits <= v.max_noise * 10 + v.bits;
        break;
      }
      case 0:
        l = h.over_count < v.over_count || h.over_count == v.over_count && h.over_noise < v.over_noise || h.over_count == v.over_count && BitStream.EQ(h.over_noise, v.over_noise) && h.tot_noise < v.tot_noise;
        break;
      case 8:
        h.max_noise = c(e, A);
      case 1:
        l = h.max_noise < v.max_noise;
        break;
      case 2:
        l = h.tot_noise < v.tot_noise;
        break;
      case 3:
        l = h.tot_noise < v.tot_noise && h.max_noise < v.max_noise;
        break;
      case 4:
        l = h.max_noise <= 0 && v.max_noise > 0.2 || h.max_noise <= 0 && v.max_noise < 0 && v.max_noise > h.max_noise - 0.2 && h.tot_noise < v.tot_noise || h.max_noise <= 0 && v.max_noise > 0 && v.max_noise > h.max_noise - 0.2 && h.tot_noise < v.tot_noise + v.over_noise || h.max_noise > 0 && v.max_noise > -0.05 && v.max_noise > h.max_noise - 0.1 && h.tot_noise + h.over_noise < v.tot_noise + v.over_noise || h.max_noise > 0 && v.max_noise > -0.1 && v.max_noise > h.max_noise - 0.15 && h.tot_noise + h.over_noise + h.over_noise < v.tot_noise + v.over_noise + v.over_noise;
        break;
      case 5:
        l = h.over_noise < v.over_noise || BitStream.EQ(h.over_noise, v.over_noise) && h.tot_noise < v.tot_noise;
        break;
      case 6:
        l = h.over_noise < v.over_noise || BitStream.EQ(h.over_noise, v.over_noise) && (h.max_noise < v.max_noise || BitStream.EQ(h.max_noise, v.max_noise) && h.tot_noise <= v.tot_noise);
        break;
      case 7:
        l = h.over_count < v.over_count || h.over_noise < v.over_noise;
        break;
    }
    return v.over_count == 0 && (l = l && h.bits < v.bits), l;
  }
  function n0(M, v, h, A, e) {
    var l = M.internal_flags, B;
    v.scalefac_scale == 0 ? B = 1.2968395546510096 : B = 1.6817928305074292;
    for (var V = 0, O = 0; O < v.sfbmax; O++)
      V < h[O] && (V = h[O]);
    var w = l.noise_shaping_amp;
    switch (w == 3 && (e ? w = 2 : w = 1), w) {
      case 2:
        break;
      case 1:
        V > 1 ? V = Math.pow(V, 0.5) : V *= 0.95;
        break;
      case 0:
      default:
        V > 1 ? V = 1 : V *= 0.95;
        break;
    }
    for (var L = 0, O = 0; O < v.sfbmax; O++) {
      var v0 = v.width[O], b;
      if (L += v0, !(h[O] < V)) {
        if (l.substep_shaping & 2 && (l.pseudohalf[O] = l.pseudohalf[O] == 0 ? 1 : 0, l.pseudohalf[O] == 0 && l.noise_shaping_amp == 2))
          return;
        for (v.scalefac[O]++, b = -v0; b < 0; b++)
          A[L + b] *= B, A[L + b] > v.xrpow_max && (v.xrpow_max = A[L + b]);
        if (l.noise_shaping_amp == 2)
          return;
      }
    }
  }
  function Q(M, v) {
    for (var h = 1.2968395546510096, A = 0, e = 0; e < M.sfbmax; e++) {
      var l = M.width[e], B = M.scalefac[e];
      if (M.preflag != 0 && (B += y.pretab[e]), A += l, B & 1) {
        B++;
        for (var V = -l; V < 0; V++)
          v[A + V] *= h, v[A + V] > M.xrpow_max && (M.xrpow_max = v[A + V]);
      }
      M.scalefac[e] = B >> 1;
    }
    M.preflag = 0, M.scalefac_scale = 1;
  }
  function t0(M, v, h) {
    var A, e = v.scalefac;
    for (A = 0; A < v.sfb_lmax; A++)
      if (e[A] >= 16)
        return !0;
    for (var l = 0; l < 3; l++) {
      var B = 0, V = 0;
      for (A = v.sfb_lmax + l; A < v.sfbdivide; A += 3)
        B < e[A] && (B = e[A]);
      for (; A < v.sfbmax; A += 3)
        V < e[A] && (V = e[A]);
      if (!(B < 16 && V < 8)) {
        if (v.subblock_gain[l] >= 7)
          return !0;
        v.subblock_gain[l]++;
        var O = M.scalefac_band.l[v.sfb_lmax];
        for (A = v.sfb_lmax + l; A < v.sfbmax; A += 3) {
          var w, L = v.width[A], v0 = e[A];
          if (v0 = v0 - (4 >> v.scalefac_scale), v0 >= 0) {
            e[A] = v0, O += L * 3;
            continue;
          }
          e[A] = 0;
          {
            var b = 210 + (v0 << v.scalefac_scale + 1);
            w = y.IPOW20(b);
          }
          O += L * (l + 1);
          for (var a = -L; a < 0; a++)
            h[O + a] *= w, h[O + a] > v.xrpow_max && (v.xrpow_max = h[O + a]);
          O += L * (3 - l - 1);
        }
        {
          var w = y.IPOW20(202);
          O += v.width[A] * (l + 1);
          for (var a = -v.width[A]; a < 0; a++)
            h[O + a] *= w, h[O + a] > v.xrpow_max && (v.xrpow_max = h[O + a]);
        }
      }
    }
    return !1;
  }
  function j(M, v, h, A, e) {
    var l = M.internal_flags;
    n0(M, v, h, A, e);
    var B = f0(v);
    return B ? !1 : (l.mode_gr == 2 ? B = i0.scale_bitcount(v) : B = i0.scale_bitcount_lsf(l, v), B ? (l.noise_shaping > 1 && (X1.fill(l.pseudohalf, 0), v.scalefac_scale == 0 ? (Q(v, A), B = !1) : v.block_type == D0.SHORT_TYPE && l.subblock_gain > 0 && (B = t0(l, v, A) || f0(v))), B || (l.mode_gr == 2 ? B = i0.scale_bitcount(v) : B = i0.scale_bitcount_lsf(l, v)), !B) : !0);
  }
  this.outer_loop = function(M, v, h, A, e, l) {
    var B = M.internal_flags, V = new fa(), O = K1(576), w = K1(ca.SFBMAX), L = new Ne(), v0, b = new st(), a = 9999999, S = !1, C = !1, F = 0;
    if (W(B, v, l, e, A), B.noise_shaping == 0)
      return 100;
    y.calc_noise(
      v,
      h,
      w,
      L,
      b
    ), L.bits = v.part2_3_length, V.assign(v);
    var N = 0;
    for (y1.arraycopy(A, 0, O, 0, 576); !S; ) {
      do {
        var U = new Ne(), T, s = 255;
        if (B.substep_shaping & 2 ? T = 20 : T = 3, B.sfb21_extra && (w[V.sfbmax] > 1 || V.block_type == D0.SHORT_TYPE && (w[V.sfbmax + 1] > 1 || w[V.sfbmax + 2] > 1)) || !j(M, V, w, A, C))
          break;
        V.scalefac_scale != 0 && (s = 254);
        var n = l - V.part2_length;
        if (n <= 0)
          break;
        for (; (V.part2_3_length = i0.count_bits(
          B,
          A,
          V,
          b
        )) > n && V.global_gain <= s; )
          V.global_gain++;
        if (V.global_gain > s)
          break;
        if (L.over_count == 0) {
          for (; (V.part2_3_length = i0.count_bits(
            B,
            A,
            V,
            b
          )) > a && V.global_gain <= s; )
            V.global_gain++;
          if (V.global_gain > s)
            break;
        }
        if (y.calc_noise(
          V,
          h,
          w,
          U,
          b
        ), U.bits = V.part2_3_length, v.block_type != D0.SHORT_TYPE ? v0 = M.quant_comp : v0 = M.quant_comp_short, v0 = H(
          v0,
          L,
          U,
          V,
          w
        ) ? 1 : 0, v0 != 0)
          a = v.part2_3_length, L = U, v.assign(V), N = 0, y1.arraycopy(A, 0, O, 0, 576);
        else if (B.full_outer_loop == 0 && (++N > T && L.over_count == 0 || B.noise_shaping_amp == 3 && C && N > 30 || B.noise_shaping_amp == 3 && C && V.global_gain - F > 15))
          break;
      } while (V.global_gain + V.scalefac_scale < 255);
      B.noise_shaping_amp == 3 ? C ? S = !0 : (V.assign(v), y1.arraycopy(O, 0, A, 0, 576), N = 0, F = V.global_gain, C = !0) : S = !0;
    }
    return U1(v.global_gain + v.scalefac_scale <= 255), M.VBR == ha.vbr_rh || M.VBR == ha.vbr_mtrh ? y1.arraycopy(O, 0, A, 0, 576) : B.substep_shaping & 1 && trancate_smallspectrums(B, v, h, A), L.over_count;
  }, this.iteration_finish_one = function(M, v, h) {
    var A = M.l3_side, e = A.tt[v][h];
    i0.best_scalefac_store(M, v, h, A), M.use_best_huffman == 1 && i0.best_huffman_divide(M, e), x.ResvAdjust(M, e);
  }, this.VBR_encode_granule = function(M, v, h, A, e, l, B) {
    var V = M.internal_flags, O = new fa(), w = K1(576), L = B, v0 = B + 1, b = (B + l) / 2, a, S, C = 0, F = V.sfb21_extra;
    U1(L <= LameInternalFlags.MAX_BITS_PER_CHANNEL), X1.fill(O.l3_enc, 0);
    do
      b > L - 42 ? V.sfb21_extra = !1 : V.sfb21_extra = F, S = outer_loop(M, v, h, A, e, b), S <= 0 ? (C = 1, v0 = v.part2_3_length, O.assign(v), y1.arraycopy(A, 0, w, 0, 576), B = v0 - 32, a = B - l, b = (B + l) / 2) : (l = b + 32, a = B - l, b = (B + l) / 2, C != 0 && (C = 2, v.assign(O), y1.arraycopy(w, 0, A, 0, 576)));
    while (a > 12);
    V.sfb21_extra = F, C == 2 && y1.arraycopy(O.l3_enc, 0, v.l3_enc, 0, 576), U1(v.part2_3_length <= L);
  }, this.get_framebits = function(M, v) {
    var h = M.internal_flags;
    h.bitrate_index = h.VBR_min_bitrate;
    var A = m.getframebits(M);
    h.bitrate_index = 1, A = m.getframebits(M);
    for (var e = 1; e <= h.VBR_max_bitrate; e++) {
      h.bitrate_index = e;
      var l = new MeanBits(A);
      v[e] = x.ResvFrameBegin(M, l), A = l.bits;
    }
  }, this.VBR_old_prepare = function(M, v, h, A, e, l, B, V, O) {
    var w = M.internal_flags, L, v0 = 0, b = 1, a = 0;
    w.bitrate_index = w.VBR_max_bitrate;
    var S = x.ResvFrameBegin(M, new MeanBits(0)) / w.mode_gr;
    get_framebits(M, l);
    for (var C = 0; C < w.mode_gr; C++) {
      var F = y.on_pe(M, v, V[C], S, C, 0);
      w.mode_ext == D0.MPG_MD_MS_LR && (ms_convert(w.l3_side, C), y.reduce_side(V[C], h[C], S, F));
      for (var N = 0; N < w.channels_out; ++N) {
        var U = w.l3_side.tt[C][N];
        U.block_type != D0.SHORT_TYPE ? (v0 = 1.28 / (1 + Math.exp(3.5 - v[C][N] / 300)) - 0.05, L = w.PSY.mask_adjust - v0) : (v0 = 2.56 / (1 + Math.exp(3.5 - v[C][N] / 300)) - 0.14, L = w.PSY.mask_adjust_short - v0), w.masking_lower = Math.pow(
          10,
          L * 0.1
        ), init_outer_loop(w, U), O[C][N] = y.calc_xmin(
          M,
          A[C][N],
          U,
          e[C][N]
        ), O[C][N] != 0 && (b = 0), B[C][N] = 126, a += V[C][N];
      }
    }
    for (var C = 0; C < w.mode_gr; C++)
      for (var N = 0; N < w.channels_out; N++)
        a > l[w.VBR_max_bitrate] && (V[C][N] *= l[w.VBR_max_bitrate], V[C][N] /= a), B[C][N] > V[C][N] && (B[C][N] = V[C][N]);
    return b;
  }, this.bitpressure_strategy = function(M, v, h, A) {
    for (var e = 0; e < M.mode_gr; e++)
      for (var l = 0; l < M.channels_out; l++) {
        for (var B = M.l3_side.tt[e][l], V = v[e][l], O = 0, w = 0; w < B.psy_lmax; w++)
          V[O++] *= 1 + 0.029 * w * w / D0.SBMAX_l / D0.SBMAX_l;
        if (B.block_type == D0.SHORT_TYPE)
          for (var w = B.sfb_smin; w < D0.SBMAX_s; w++)
            V[O++] *= 1 + 0.029 * w * w / D0.SBMAX_s / D0.SBMAX_s, V[O++] *= 1 + 0.029 * w * w / D0.SBMAX_s / D0.SBMAX_s, V[O++] *= 1 + 0.029 * w * w / D0.SBMAX_s / D0.SBMAX_s;
        A[e][l] = 0 | Math.max(
          h[e][l],
          0.9 * A[e][l]
        );
      }
  }, this.VBR_new_prepare = function(M, v, h, A, e, l) {
    var B = M.internal_flags, V = 1, O = 0, w = 0, L;
    if (M.free_format) {
      B.bitrate_index = 0;
      var v0 = new MeanBits(O);
      L = x.ResvFrameBegin(M, v0), O = v0.bits, e[0] = L;
    } else {
      B.bitrate_index = B.VBR_max_bitrate;
      var v0 = new MeanBits(O);
      x.ResvFrameBegin(M, v0), O = v0.bits, get_framebits(M, e), L = e[B.VBR_max_bitrate];
    }
    for (var b = 0; b < B.mode_gr; b++) {
      y.on_pe(M, v, l[b], O, b, 0), B.mode_ext == D0.MPG_MD_MS_LR && ms_convert(B.l3_side, b);
      for (var a = 0; a < B.channels_out; ++a) {
        var S = B.l3_side.tt[b][a];
        B.masking_lower = Math.pow(
          10,
          B.PSY.mask_adjust * 0.1
        ), init_outer_loop(B, S), y.calc_xmin(
          M,
          h[b][a],
          S,
          A[b][a]
        ) != 0 && (V = 0), w += l[b][a];
      }
    }
    for (var b = 0; b < B.mode_gr; b++)
      for (var a = 0; a < B.channels_out; a++)
        w > L && (l[b][a] *= L, l[b][a] /= w);
    return V;
  }, this.calc_target_bits = function(M, v, h, A, e, l) {
    var B = M.internal_flags, V = B.l3_side, O, w, L, v0, b = 0;
    B.bitrate_index = B.VBR_max_bitrate;
    var a = new MeanBits(b);
    for (l[0] = x.ResvFrameBegin(M, a), b = a.bits, B.bitrate_index = 1, b = m.getframebits(M) - B.sideinfo_len * 8, e[0] = b / (B.mode_gr * B.channels_out), b = M.VBR_mean_bitrate_kbps * M.framesize * 1e3, B.substep_shaping & 1 && (b *= 1.09), b /= M.out_samplerate, b -= B.sideinfo_len * 8, b /= B.mode_gr * B.channels_out, O = 0.93 + 0.07 * (11 - M.compression_ratio) / (11 - 5.5), O < 0.9 && (O = 0.9), O > 1 && (O = 1), w = 0; w < B.mode_gr; w++) {
      var S = 0;
      for (L = 0; L < B.channels_out; L++) {
        if (A[w][L] = int(O * b), v[w][L] > 700) {
          var C = int((v[w][L] - 700) / 1.4), F = V.tt[w][L];
          A[w][L] = int(O * b), F.block_type == D0.SHORT_TYPE && C < b / 2 && (C = b / 2), C > b * 3 / 2 ? C = b * 3 / 2 : C < 0 && (C = 0), A[w][L] += C;
        }
        A[w][L] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (A[w][L] = LameInternalFlags.MAX_BITS_PER_CHANNEL), S += A[w][L];
      }
      if (S > LameInternalFlags.MAX_BITS_PER_GRANULE)
        for (L = 0; L < B.channels_out; ++L)
          A[w][L] *= LameInternalFlags.MAX_BITS_PER_GRANULE, A[w][L] /= S;
    }
    if (B.mode_ext == D0.MPG_MD_MS_LR)
      for (w = 0; w < B.mode_gr; w++)
        y.reduce_side(
          A[w],
          h[w],
          b * B.channels_out,
          LameInternalFlags.MAX_BITS_PER_GRANULE
        );
    for (v0 = 0, w = 0; w < B.mode_gr; w++)
      for (L = 0; L < B.channels_out; L++)
        A[w][L] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (A[w][L] = LameInternalFlags.MAX_BITS_PER_CHANNEL), v0 += A[w][L];
    if (v0 > l[0])
      for (w = 0; w < B.mode_gr; w++)
        for (L = 0; L < B.channels_out; L++)
          A[w][L] *= l[0], A[w][L] /= v0;
  };
}
var _t = it, lt = Q0, ma = lt.assert;
function ot() {
  var m;
  this.setModules = function(x) {
    m = x;
  }, this.ResvFrameBegin = function(x, y) {
    var K = x.internal_flags, i0, P = K.l3_side, z = m.getframebits(x);
    y.bits = (z - K.sideinfo_len * 8) / K.mode_gr;
    var D = 8 * 256 * K.mode_gr - 8;
    x.brate > 320 ? i0 = 8 * int(x.brate * 1e3 / (x.out_samplerate / 1152) / 8 + 0.5) : (i0 = 8 * 1440, x.strict_ISO && (i0 = 8 * int(32e4 / (x.out_samplerate / 1152) / 8 + 0.5))), K.ResvMax = i0 - z, K.ResvMax > D && (K.ResvMax = D), (K.ResvMax < 0 || x.disable_reservoir) && (K.ResvMax = 0);
    var W = y.bits * K.mode_gr + Math.min(K.ResvSize, K.ResvMax);
    return W > i0 && (W = i0), ma(K.ResvMax % 8 == 0), ma(K.ResvMax >= 0), P.resvDrain_pre = 0, K.pinfo != null && (K.pinfo.mean_bits = y.bits / 2, K.pinfo.resvsize = K.ResvSize), W;
  }, this.ResvMaxBits = function(x, y, K, i0) {
    var P = x.internal_flags, z, D = P.ResvSize, W = P.ResvMax;
    i0 != 0 && (D += y), P.substep_shaping & 1 && (W *= 0.9), K.bits = y, D * 10 > W * 9 ? (z = D - W * 9 / 10, K.bits += z, P.substep_shaping |= 128) : (z = 0, P.substep_shaping &= 127, !x.disable_reservoir && !(P.substep_shaping & 1) && (K.bits -= 0.1 * y));
    var f0 = D < P.ResvMax * 6 / 10 ? D : P.ResvMax * 6 / 10;
    return f0 -= z, f0 < 0 && (f0 = 0), f0;
  }, this.ResvAdjust = function(x, y) {
    x.ResvSize -= y.part2_3_length + y.part2_length;
  }, this.ResvFrameEnd = function(x, y) {
    var K, i0 = x.l3_side;
    x.ResvSize += y * x.mode_gr;
    var P = 0;
    i0.resvDrain_post = 0, i0.resvDrain_pre = 0, (K = x.ResvSize % 8) != 0 && (P += K), K = x.ResvSize - P - x.ResvMax, K > 0 && (P += K);
    {
      var z = Math.min(i0.main_data_begin * 8, P) / 8;
      i0.resvDrain_pre += 8 * z, P -= 8 * z, x.ResvSize -= 8 * z, i0.main_data_begin -= z;
    }
    i0.resvDrain_post += P, x.ResvSize -= P;
  };
}
var vt = ot;
function ut() {
  var m = "http://www.mp3dev.org/", x = 3, y = 98, K = 4, i0 = 0, P = 93;
  this.getLameVersion = function() {
    return x + "." + y + "." + K;
  }, this.getLameShortVersion = function() {
    return x + "." + y + "." + K;
  }, this.getLameVeryShortVersion = function() {
    return "LAME" + x + "." + y + "r";
  }, this.getPsyVersion = function() {
    return i0 + "." + P;
  }, this.getLameUrl = function() {
    return m;
  }, this.getLameOsBitness = function() {
    return "32bits";
  };
}
var ht = ut, D1 = Q0, ft = D1.System, Ve = D1.VbrMode, ba = D1.ShortBlock, ct = D1.Arrays, se = D1.new_byte, mt = D1.assert;
Q1.NUMTOCENTRIES = 100;
Q1.MAXFRAMESIZE = 2880;
function Q1() {
  var m, x, y;
  this.setModules = function(b, a, S) {
    m = b, x = a, y = S;
  };
  var K = 1, i0 = 2, P = 4, z = 8, D = Q1.NUMTOCENTRIES, W = Q1.MAXFRAMESIZE, f0 = D + 4 + 4 + 4 + 4 + 4, R = f0 + 9 + 1 + 1 + 8 + 1 + 1 + 3 + 1 + 1 + 2 + 4 + 2 + 2, c = 128, H = 64, n0 = 32, Q = null, t0 = "Xing", j = "Info", M = [
    0,
    49345,
    49537,
    320,
    49921,
    960,
    640,
    49729,
    50689,
    1728,
    1920,
    51009,
    1280,
    50625,
    50305,
    1088,
    52225,
    3264,
    3456,
    52545,
    3840,
    53185,
    52865,
    3648,
    2560,
    51905,
    52097,
    2880,
    51457,
    2496,
    2176,
    51265,
    55297,
    6336,
    6528,
    55617,
    6912,
    56257,
    55937,
    6720,
    7680,
    57025,
    57217,
    8e3,
    56577,
    7616,
    7296,
    56385,
    5120,
    54465,
    54657,
    5440,
    55041,
    6080,
    5760,
    54849,
    53761,
    4800,
    4992,
    54081,
    4352,
    53697,
    53377,
    4160,
    61441,
    12480,
    12672,
    61761,
    13056,
    62401,
    62081,
    12864,
    13824,
    63169,
    63361,
    14144,
    62721,
    13760,
    13440,
    62529,
    15360,
    64705,
    64897,
    15680,
    65281,
    16320,
    16e3,
    65089,
    64001,
    15040,
    15232,
    64321,
    14592,
    63937,
    63617,
    14400,
    10240,
    59585,
    59777,
    10560,
    60161,
    11200,
    10880,
    59969,
    60929,
    11968,
    12160,
    61249,
    11520,
    60865,
    60545,
    11328,
    58369,
    9408,
    9600,
    58689,
    9984,
    59329,
    59009,
    9792,
    8704,
    58049,
    58241,
    9024,
    57601,
    8640,
    8320,
    57409,
    40961,
    24768,
    24960,
    41281,
    25344,
    41921,
    41601,
    25152,
    26112,
    42689,
    42881,
    26432,
    42241,
    26048,
    25728,
    42049,
    27648,
    44225,
    44417,
    27968,
    44801,
    28608,
    28288,
    44609,
    43521,
    27328,
    27520,
    43841,
    26880,
    43457,
    43137,
    26688,
    30720,
    47297,
    47489,
    31040,
    47873,
    31680,
    31360,
    47681,
    48641,
    32448,
    32640,
    48961,
    32e3,
    48577,
    48257,
    31808,
    46081,
    29888,
    30080,
    46401,
    30464,
    47041,
    46721,
    30272,
    29184,
    45761,
    45953,
    29504,
    45313,
    29120,
    28800,
    45121,
    20480,
    37057,
    37249,
    20800,
    37633,
    21440,
    21120,
    37441,
    38401,
    22208,
    22400,
    38721,
    21760,
    38337,
    38017,
    21568,
    39937,
    23744,
    23936,
    40257,
    24320,
    40897,
    40577,
    24128,
    23040,
    39617,
    39809,
    23360,
    39169,
    22976,
    22656,
    38977,
    34817,
    18624,
    18816,
    35137,
    19200,
    35777,
    35457,
    19008,
    19968,
    36545,
    36737,
    20288,
    36097,
    19904,
    19584,
    35905,
    17408,
    33985,
    34177,
    17728,
    34561,
    18368,
    18048,
    34369,
    33281,
    17088,
    17280,
    33601,
    16640,
    33217,
    32897,
    16448
  ];
  function v(b, a) {
    if (b.nVbrNumFrames++, b.sum += a, b.seen++, !(b.seen < b.want) && (b.pos < b.size && (b.bag[b.pos] = b.sum, b.pos++, b.seen = 0), b.pos == b.size)) {
      for (var S = 1; S < b.size; S += 2)
        b.bag[S / 2] = b.bag[S];
      b.want *= 2, b.pos /= 2;
    }
  }
  function h(b, a) {
    if (!(b.pos <= 0))
      for (var S = 1; S < D; ++S) {
        var C = S / D, F, N, U = 0 | Math.floor(C * b.pos);
        U > b.pos - 1 && (U = b.pos - 1), F = b.bag[U], N = b.sum;
        var T = 0 | 256 * F / N;
        T > 255 && (T = 255), a[S] = 255 & T;
      }
  }
  this.addVbrFrame = function(b) {
    var a = b.internal_flags, S = Tables.bitrate_table[b.version][a.bitrate_index];
    mt(a.VBR_seek_table.bag != null), v(a.VBR_seek_table, S);
  };
  function A(b, a) {
    var S = b[a + 0] & 255;
    return S <<= 8, S |= b[a + 1] & 255, S <<= 8, S |= b[a + 2] & 255, S <<= 8, S |= b[a + 3] & 255, S;
  }
  function e(b, a, S) {
    b[a + 0] = 255 & (S >> 24 & 255), b[a + 1] = 255 & (S >> 16 & 255), b[a + 2] = 255 & (S >> 8 & 255), b[a + 3] = 255 & (S & 255);
  }
  function l(b, a, S) {
    b[a + 0] = 255 & (S >> 8 & 255), b[a + 1] = 255 & (S & 255);
  }
  function B(b, a) {
    return new String(b, a, t0.length(), Q).equals(t0) || new String(b, a, j.length(), Q).equals(j);
  }
  function V(b, a, S) {
    return 255 & (b << a | S & ~(-1 << a));
  }
  function O(b, a) {
    var S = b.internal_flags;
    a[0] = V(a[0], 8, 255), a[1] = V(a[1], 3, 7), a[1] = V(
      a[1],
      1,
      b.out_samplerate < 16e3 ? 0 : 1
    ), a[1] = V(a[1], 1, b.version), a[1] = V(a[1], 2, 4 - 3), a[1] = V(a[1], 1, b.error_protection ? 0 : 1), a[2] = V(a[2], 4, S.bitrate_index), a[2] = V(a[2], 2, S.samplerate_index), a[2] = V(a[2], 1, 0), a[2] = V(a[2], 1, b.extension), a[3] = V(a[3], 2, b.mode.ordinal()), a[3] = V(a[3], 2, S.mode_ext), a[3] = V(a[3], 1, b.copyright), a[3] = V(a[3], 1, b.original), a[3] = V(a[3], 2, b.emphasis), a[0] = 255;
    var C = 255 & (a[1] & 241), F;
    b.version == 1 ? F = c : b.out_samplerate < 16e3 ? F = n0 : F = H, b.VBR == Ve.vbr_off && (F = b.brate);
    var N;
    b.free_format ? N = 0 : N = 255 & 16 * m.BitrateIndex(
      F,
      b.version,
      b.out_samplerate
    ), b.version == 1 ? (a[1] = 255 & (C | 10), C = 255 & (a[2] & 13), a[2] = 255 & (N | C)) : (a[1] = 255 & (C | 2), C = 255 & (a[2] & 13), a[2] = 255 & (N | C));
  }
  this.getVbrTag = function(b) {
    var a = new VBRTagData(), S = 0;
    a.flags = 0;
    var C = b[S + 1] >> 3 & 1, F = b[S + 2] >> 2 & 3, N = b[S + 3] >> 6 & 3, U = b[S + 2] >> 4 & 15;
    if (U = Tables.bitrate_table[C][U], b[S + 1] >> 4 == 14 ? a.samprate = Tables.samplerate_table[2][F] : a.samprate = Tables.samplerate_table[C][F], C != 0 ? N != 3 ? S += 32 + 4 : S += 17 + 4 : N != 3 ? S += 17 + 4 : S += 9 + 4, !B(b, S))
      return null;
    S += 4, a.hId = C;
    var T = a.flags = A(b, S);
    if (S += 4, T & K && (a.frames = A(b, S), S += 4), T & i0 && (a.bytes = A(b, S), S += 4), T & P) {
      if (a.toc != null)
        for (var s = 0; s < D; s++)
          a.toc[s] = b[S + s];
      S += D;
    }
    a.vbrScale = -1, T & z && (a.vbrScale = A(b, S), S += 4), a.headersize = (C + 1) * 72e3 * U / a.samprate, S += 21;
    var n = b[S + 0] << 4;
    n += b[S + 1] >> 4;
    var r = (b[S + 1] & 15) << 8;
    return r += b[S + 2] & 255, (n < 0 || n > 3e3) && (n = -1), (r < 0 || r > 3e3) && (r = -1), a.encDelay = n, a.encPadding = r, a;
  }, this.InitVbrTag = function(b) {
    var a = b.internal_flags, S;
    b.version == 1 ? S = c : b.out_samplerate < 16e3 ? S = n0 : S = H, b.VBR == Ve.vbr_off && (S = b.brate);
    var C = (b.version + 1) * 72e3 * S / b.out_samplerate, F = a.sideinfo_len + R;
    if (a.VBR_seek_table.TotalFrameSize = C, C < F || C > W) {
      b.bWriteVbrTag = !1;
      return;
    }
    a.VBR_seek_table.nVbrNumFrames = 0, a.VBR_seek_table.nBytesWritten = 0, a.VBR_seek_table.sum = 0, a.VBR_seek_table.seen = 0, a.VBR_seek_table.want = 1, a.VBR_seek_table.pos = 0, a.VBR_seek_table.bag == null && (a.VBR_seek_table.bag = new int[400](), a.VBR_seek_table.size = 400);
    var N = se(W);
    O(b, N);
    for (var U = a.VBR_seek_table.TotalFrameSize, T = 0; T < U; ++T)
      x.add_dummy_byte(b, N[T] & 255, 1);
  };
  function w(b, a) {
    var S = a ^ b;
    return a = a >> 8 ^ M[S & 255], a;
  }
  this.updateMusicCRC = function(b, a, S, C) {
    for (var F = 0; F < C; ++F)
      b[0] = w(a[S + F], b[0]);
  };
  function L(b, a, S, C, F) {
    var N = b.internal_flags, U = 0, T = b.encoder_delay, s = b.encoder_padding, n = 100 - 10 * b.VBR_q - b.quality, r = y.getLameVeryShortVersion(), i, f = 0, q, g = [1, 5, 3, 2, 4, 0, 3], p = 0 | (b.lowpassfreq / 100 + 0.5 > 255 ? 255 : b.lowpassfreq / 100 + 0.5), G = 0, s0 = 0, h0 = 0, S0 = b.internal_flags.noise_shaping, M0 = 0, R0 = 0, A0 = 0, w0 = 0, $0 = 0, f1 = (b.exp_nspsytune & 1) != 0, t = (b.exp_nspsytune & 2) != 0, _ = !1, d0 = !1, E0 = b.internal_flags.nogap_total, V0 = b.internal_flags.nogap_current, N0 = b.ATHtype, y0 = 0, T0;
    switch (b.VBR) {
      case vbr_abr:
        T0 = b.VBR_mean_bitrate_kbps;
        break;
      case vbr_off:
        T0 = b.brate;
        break;
      default:
        T0 = b.VBR_min_bitrate_kbps;
    }
    switch (b.VBR.ordinal() < g.length ? i = g[b.VBR.ordinal()] : i = 0, q = 16 * f + i, N.findReplayGain && (N.RadioGain > 510 && (N.RadioGain = 510), N.RadioGain < -510 && (N.RadioGain = -510), s0 = 8192, s0 |= 3072, N.RadioGain >= 0 ? s0 |= N.RadioGain : (s0 |= 512, s0 |= -N.RadioGain)), N.findPeakSample && (G = Math.abs(0 | N.PeakSample / 32767 * Math.pow(2, 23) + 0.5)), E0 != -1 && (V0 > 0 && (d0 = !0), V0 < E0 - 1 && (_ = !0)), y0 = N0 + ((f1 ? 1 : 0) << 4) + ((t ? 1 : 0) << 5) + ((_ ? 1 : 0) << 6) + ((d0 ? 1 : 0) << 7), n < 0 && (n = 0), b.mode) {
      case MONO:
        M0 = 0;
        break;
      case STEREO:
        M0 = 1;
        break;
      case DUAL_CHANNEL:
        M0 = 2;
        break;
      case JOINT_STEREO:
        b.force_ms ? M0 = 4 : M0 = 3;
        break;
      case NOT_SET:
      default:
        M0 = 7;
        break;
    }
    b.in_samplerate <= 32e3 ? A0 = 0 : b.in_samplerate == 48e3 ? A0 = 2 : b.in_samplerate > 48e3 ? A0 = 3 : A0 = 1, (b.short_blocks == ba.short_block_forced || b.short_blocks == ba.short_block_dispensed || b.lowpassfreq == -1 && b.highpassfreq == -1 || /* "-k" */
    b.scale_left < b.scale_right || b.scale_left > b.scale_right || b.disable_reservoir && b.brate < 320 || b.noATH || b.ATHonly || N0 == 0 || b.in_samplerate <= 32e3) && (R0 = 1), w0 = S0 + (M0 << 2) + (R0 << 5) + (A0 << 6), $0 = N.nMusicCRC, e(S, C + U, n), U += 4;
    for (var F0 = 0; F0 < 9; F0++)
      S[C + U + F0] = 255 & r.charAt(F0);
    U += 9, S[C + U] = 255 & q, U++, S[C + U] = 255 & p, U++, e(
      S,
      C + U,
      G
    ), U += 4, l(
      S,
      C + U,
      s0
    ), U += 2, l(
      S,
      C + U,
      h0
    ), U += 2, S[C + U] = 255 & y0, U++, T0 >= 255 ? S[C + U] = 255 : S[C + U] = 255 & T0, U++, S[C + U] = 255 & T >> 4, S[C + U + 1] = 255 & (T << 4) + (s >> 8), S[C + U + 2] = 255 & s, U += 3, S[C + U] = 255 & w0, U++, S[C + U++] = 0, l(S, C + U, b.preset), U += 2, e(S, C + U, a), U += 4, l(S, C + U, $0), U += 2;
    for (var p0 = 0; p0 < U; p0++)
      F = w(S[C + p0], F);
    return l(S, C + U, F), U += 2, U;
  }
  function v0(b) {
    b.seek(0);
    var a = se(10);
    b.readFully(a);
    var S;
    return new String(a, "ISO-8859-1").startsWith("ID3") ? S = 0 : S = ((a[6] & 127) << 21 | (a[7] & 127) << 14 | (a[8] & 127) << 7 | a[9] & 127) + a.length, S;
  }
  this.getLameTagFrame = function(b, a) {
    var S = b.internal_flags;
    if (!b.bWriteVbrTag || S.Class_ID != Lame.LAME_ID || S.VBR_seek_table.pos <= 0)
      return 0;
    if (a.length < S.VBR_seek_table.TotalFrameSize)
      return S.VBR_seek_table.TotalFrameSize;
    ct.fill(a, 0, S.VBR_seek_table.TotalFrameSize, 0), O(b, a);
    var C = se(D);
    if (b.free_format)
      for (var F = 1; F < D; ++F)
        C[F] = 255 & 255 * F / 100;
    else
      h(S.VBR_seek_table, C);
    var N = S.sideinfo_len;
    b.error_protection && (N -= 2), b.VBR == Ve.vbr_off ? (a[N++] = 255 & j.charAt(0), a[N++] = 255 & j.charAt(1), a[N++] = 255 & j.charAt(2), a[N++] = 255 & j.charAt(3)) : (a[N++] = 255 & t0.charAt(0), a[N++] = 255 & t0.charAt(1), a[N++] = 255 & t0.charAt(2), a[N++] = 255 & t0.charAt(3)), e(a, N, K + i0 + P + z), N += 4, e(a, N, S.VBR_seek_table.nVbrNumFrames), N += 4;
    var U = S.VBR_seek_table.nBytesWritten + S.VBR_seek_table.TotalFrameSize;
    e(a, N, 0 | U), N += 4, ft.arraycopy(C, 0, a, N, C.length), N += C.length, b.error_protection && x.CRC_writeheader(S, a);
    for (var T = 0, F = 0; F < N; F++)
      T = w(a[F], T);
    return N += L(b, U, a, N, T), S.VBR_seek_table.TotalFrameSize;
  }, this.putVbrTag = function(b, a) {
    var S = b.internal_flags;
    if (S.VBR_seek_table.pos <= 0 || (a.seek(a.length()), a.length() == 0))
      return -1;
    var C = v0(a);
    a.seek(C);
    var F = se(W), N = getLameTagFrame(b, F);
    return N > F.length ? -1 : (N < 1 || a.write(F, 0, N), 0);
  };
}
var bt = Q1, $a = Q0, da = $a.new_byte, dt = $a.assert, St = Ye(), At = jr, Rt = ka, xt = qa(), Mt = _t, Et = Da(), Bt = vt, Tt = j1, yt = Xe();
t1();
var wt = ht, pt = bt;
function It() {
  this.setModules = function(m, x) {
  };
}
function Lt() {
  this.setModules = function(m, x, y) {
  };
}
function Ct() {
}
function Nt() {
  this.setModules = function(m, x) {
  };
}
function Vt(m, x, y) {
  arguments.length != 3 && (console.error("WARN: Mp3Encoder(channels, samplerate, kbps) not specified"), m = 1, x = 44100, y = 128);
  var K = new St(), i0 = new It(), P = new Rt(), z = new yt(), D = new At(), W = new xt(), f0 = new Mt(), R = new pt(), c = new wt(), H = new Nt(), n0 = new Bt(), Q = new Et(), t0 = new Lt(), j = new Ct();
  K.setModules(P, z, D, W, f0, R, c, H, j), z.setModules(P, j, c, R), H.setModules(z, c), D.setModules(K), f0.setModules(z, n0, W, Q), W.setModules(Q, n0, K.enc.psy), n0.setModules(z), Q.setModules(W), R.setModules(K, z, c), i0.setModules(t0, j), t0.setModules(c, H, D);
  var M = K.lame_init();
  M.num_channels = m, M.in_samplerate = x, M.brate = y, M.mode = Tt.STEREO, M.quality = 3, M.bWriteVbrTag = !1, M.disable_reservoir = !0, M.write_id3tag_automatic = !1, K.lame_init_params(M);
  var v = 1152, h = 0 | 1.25 * v + 7200, A = da(h);
  this.encodeBuffer = function(e, l) {
    m == 1 && (l = e), dt(e.length == l.length), e.length > v && (v = e.length, h = 0 | 1.25 * v + 7200, A = da(h));
    var B = K.lame_encode_buffer(M, e, l, e.length, A, 0, h);
    return new Int8Array(A.subarray(0, B));
  }, this.flush = function() {
    var e = K.lame_encode_flush(M, A, 0, h);
    return new Int8Array(A.subarray(0, e));
  };
}
function M1() {
  this.dataOffset = 0, this.dataLen = 0, this.channels = 0, this.sampleRate = 0;
}
function he(m) {
  return m.charCodeAt(0) << 24 | m.charCodeAt(1) << 16 | m.charCodeAt(2) << 8 | m.charCodeAt(3);
}
M1.RIFF = he("RIFF");
M1.WAVE = he("WAVE");
M1.fmt_ = he("fmt ");
M1.data = he("data");
M1.readHeader = function(m) {
  var x = new M1(), y = m.getUint32(0, !1);
  if (M1.RIFF == y && (m.getUint32(4, !0), M1.WAVE == m.getUint32(8, !1) && M1.fmt_ == m.getUint32(12, !1))) {
    var K = m.getUint32(16, !0), i0 = 16 + 4;
    switch (K) {
      case 16:
      case 18:
        x.channels = m.getUint16(i0 + 2, !0), x.sampleRate = m.getUint32(i0 + 4, !0);
        break;
      default:
        throw "extended fmt chunk not implemented";
    }
    i0 += K;
    for (var P = M1.data, z = 0; P != y && (y = m.getUint32(i0, !1), z = m.getUint32(i0 + 4, !0), P != y); )
      i0 += z + 8;
    return x.dataLen = z, x.dataOffset = i0 + 8, x;
  }
};
var Ht = Vt;
const Ot = (m, x) => {
  const y = Math.floor(x * 0.05), K = [];
  let i0 = 0;
  for (let P = 0; P < m.length; P += 1)
    for (let z = 0; z < m[P].length; z += 1)
      i0 += m[P][z] ** 2, z % y === 0 && (i0 = Math.sqrt(i0 / y), K.push(i0), i0 = 0);
  return K.sort((P, z) => P - z), K[Math.floor(K.length * 0.95)];
};
function Ft(m, x) {
  for (let y = 0; y < m.length; y++) {
    const K = Math.max(-1, Math.min(1, m[y]));
    x[y] = K < 0 ? K * 32768 : K * 32767;
  }
}
function kt(m) {
  const x = new Int16Array(m.length);
  return Ft(m, x), x;
}
var ie, Pa, _e, Za, le, Ka;
class Xt {
  constructor({
    bitRate: x = 128,
    sampleRate: y = 44100,
    gain: K = 0.2517610306326151
  } = {}) {
    /**
     * calculate average gain from samples
     */
    g1(this, ie);
    g1(this, _e);
    /**
     *  flushes encoder, creates Blob from buffer and resets buffer
     * @return {module:buffer.Blob}
     */
    g1(this, le);
    this.bitRate = x, this.sampleRate = y, this.encoder = new Ht(1, this.sampleRate, this.bitRate), this.gain = K, this.buffer = [], this.samples = [];
  }
  /**
   * @param arrayBuffer {ArrayBuffer} audio sample from recording
   */
  encode(x) {
    const y = new Float32Array(x);
    this.samples.push(y);
  }
  /**
   * @return {module:buffer.Blob}
   */
  finish() {
    return ee(this, ie, Pa).call(this), ee(this, _e, Za).call(this), ee(this, le, Ka).call(this);
  }
}
ie = new WeakSet(), Pa = function() {
  const x = Ot(this.samples, this.sampleRate), K = this.gain / x;
  for (let i0 = 0; i0 < this.samples.length; i0 += 1)
    for (let P = 0; P < this.samples[i0].length; P += 1)
      this.samples[i0][P] *= K;
}, _e = new WeakSet(), Za = function() {
  this.samples.map((y) => {
    const K = kt(y);
    let i0 = K.length;
    for (let P = 0; i0 >= 0; P += 1152) {
      const z = K.subarray(P, P + 1152), D = this.encoder.encodeBuffer(z);
      this.buffer.push(D), i0 -= 1152;
    }
  });
}, le = new WeakSet(), Ka = function() {
  this.buffer.push(this.encoder.flush());
  const x = new Blob(this.buffer, { type: "audio/mpeg" });
  return this.buffer = [], x;
};
function Yt(m) {
  const x = /* @__PURE__ */ new Date(null);
  return x.setSeconds(m), x.toISOString().substr(14, 5);
}
var qt = function() {
  var m = this, x = m.$createElement, y = m._self._c || x;
  return y("svg", { attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" } }, [y("path", { attrs: { d: "M19.172 10.192c1.527.721 1.527 2.895 0 3.616l-9.818 4.638A2 2 0 0 1 6.5 16.638V7.362a2 2 0 0 1 2.854-1.808l9.818 4.638Z", fill: "currentColor" } })]);
};
const Dt = { name: "play", render: qt };
var Gt = function() {
  var m = this, x = m.$createElement, y = m._self._c || x;
  return y("svg", { attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" } }, [y("path", { attrs: { d: "M8 5.75a3.75 3.75 0 1 1 7.5 0v5a3.75 3.75 0 1 1-7.5 0v-5Z", fill: "currentColor" } }), m._v(" "), y("path", { attrs: { d: "M13 19.411V22h-2.5v-2.588A8.752 8.752 0 0 1 3 10.75h2.5a6.25 6.25 0 0 0 12.5 0h2.5a8.753 8.753 0 0 1-7.5 8.66Z", fill: "currentColor" } })]);
};
const $t = { name: "record", render: Gt };
var Pt = function() {
  var m = this, x = m.$createElement, y = m._self._c || x;
  return y("svg", { attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" } }, [y("rect", { attrs: { x: "4", y: "4", width: "16", height: "16", rx: "2", fill: "currentColor" } })]);
};
const Zt = { name: "stop", render: Pt }, Kt = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <style lang="text/css">
    .line-1 {
      animation: pulse 0.9s infinite;
      animation-delay: 0.15s;
    }
    .line-2 {
      animation: pulse 0.9s infinite;
      animation-delay: 0.3s;
    }
    .line-3 {
      animation: pulse 0.9s infinite;
      animation-delay: 0.45s;
    }
    .line-4 {
      animation: pulse 0.9s infinite;
      animation-delay: 0.6s;
    }
    .line-5 {
      animation: pulse 0.9s infinite;
      animation-delay: 0.75s;
    }

    @keyframes pulse {
      0% {
        transform: scaleY(1);
        transform-origin: 50% 50%;
      }

      50% {
        transform: scaleY(.6);
        transform-origin: 50% 50%;
      }

      100% {
        transform: scaleY(1);
        transform-origin: 50% 50%;
      }
    }
  </style>
  <g stroke-width="2" stroke="currentColor">
    <line class="line-1" x1="4" y1="10" x2="4" y2="14"/>
    <line class="line-2" x1="8" y1="2" x2="8" y2="22"/>
    <line class="line-3" x1="12" y1="8" x2="12" y2="16"/>
    <line class="line-4" x1="16" y1="6" x2="16" y2="18"/>
    <line class="line-5" x1="20" y1="10" x2="20" y2="14"/>
  </g>
</svg>
`, Ut = "_textPrimary_o2rzl_8", Qt = "_buttons_o2rzl_12", zt = "_button_o2rzl_12", jt = "_buttonIcon_o2rzl_35", Wt = "_buttonLabel_o2rzl_69", Jt = "_btnRecording_o2rzl_75", gt = "_isRecording_o2rzl_87", e2 = "_pulsate_o2rzl_1", a2 = "_duration_o2rzl_107", r2 = {
  textPrimary: Ut,
  buttons: Qt,
  button: zt,
  buttonIcon: jt,
  buttonLabel: Wt,
  btnRecording: Jt,
  isRecording: gt,
  pulsate: e2,
  duration: a2
}, t2 = {
  name: "AudioRecorder",
  components: {
    AudioPlayer: ga,
    PlayIcon: Dt,
    RecordIcon: $t,
    StopIcon: Zt
  },
  props: {
    value: {
      type: [Object, Blob],
      default: void 0
    },
    max: {
      type: Number,
      default: void 0
    },
    bitRate: {
      type: Number,
      default: 128
    },
    sampleRate: {
      type: Number,
      default: 44100
    },
    playLabel: {
      type: String,
      default: "Play"
    },
    recordLabel: {
      type: String,
      default: "Record"
    },
    stopLabel: {
      type: String,
      default: "Stop"
    },
    buttonClass: {
      type: String,
      default: void 0
    },
    gain: {
      type: Number,
      default: 0.2517610306326151
    }
  },
  data() {
    return {
      recorder: null,
      stream: null,
      encoder: null,
      startedAt: null,
      isRecording: !1,
      duration: 0,
      recordingTimer: null,
      WaveformIcon: Kt
    };
  },
  computed: {
    recording: {
      get() {
        return this.value || null;
      },
      set(m) {
        this.$emit("input", m), this.$emit("update:value", m);
      }
    },
    recordingSrc() {
      if (this.recording)
        return URL.createObjectURL(this.recording);
    }
  },
  watch: {
    recording() {
      this.updateDuration();
    }
  },
  mounted() {
    this.updateDuration();
  },
  beforeDestroy() {
    this.stop(), this.teardown();
  },
  methods: {
    formatDuration: Yt,
    async setup() {
      this.recorder || navigator.mediaDevices && navigator.mediaDevices.getUserMedia && (this.stream = await navigator.mediaDevices.getUserMedia({
        audio: !0,
        video: !1
      }), this.recorder = new er(this.stream), this.recorder.onStart = () => {
        this.recording = null, this.isRecording = !0, this.startedAt = /* @__PURE__ */ new Date(), this.duration = 0, this.encoder = new Xt({ bitRate: this.bitRate, sampleRate: this.recorder.sampleRate, gain: this.gain });
      }, this.recorder.onStop = () => {
        this.isRecording = !1, this.recording = this.encoder.finish();
      }, this.recorder.onAudioProcess = (m) => {
        this.recorder && (this.max && this.recorder.currentTime >= this.max && this.stop(), this.duration = this.recorder.currentTime, this.encoder.encode(m));
      });
    },
    teardown() {
      this.stream && this.stream.getTracks().forEach((m) => m.stop()), this.recorder && (this.recorder.state === "recording" && this.recorder.stop(), this.recorder = null);
    },
    async record() {
      await this.setup(), this.recorder.state === "recording" && this.recorder.stop(), this.recorder.start();
    },
    stop() {
      this.recordingTimer && clearTimeout(this.recordingTimer), this.recorder.state === "recording" && this.recorder.stop(), this.$refs.player && this.$refs.player.stop(), this.teardown();
    },
    async updateDuration() {
      if (!this.recording) {
        this.duration = 0;
        return;
      }
      const x = await new AudioContext().decodeAudioData(await this.recording.arrayBuffer());
      this.duration = Math.round(x.duration);
    }
  }
};
var n2 = function() {
  var x = this, y = x._self._c;
  return y("section", [y("div", { class: x.$style.buttons, attrs: { role: "group" } }, [y("AudioPlayer", { ref: "player", attrs: { src: x.recordingSrc }, scopedSlots: x._u([{ key: "default", fn: function({ play: K, isPlaying: i0 }) {
    return [y("button", { class: [x.buttonClass, x.$style.button], attrs: { type: "button", disabled: !x.recording }, on: { click: K } }, [y("span", { class: x.$style.buttonIcon }, [i0 ? y("span", { domProps: { innerHTML: x._s(x.WaveformIcon) } }) : y("PlayIcon")], 1), y("span", { class: x.$style.buttonLabel, domProps: { textContent: x._s(x.playLabel) } })])];
  } }]) }), y("button", { class: [x.buttonClass, x.$style.button, x.$style.btnRecording, x.isRecording && x.$style.isRecording], attrs: { type: "button" }, on: { click: function(K) {
    x.isRecording ? x.stop() : x.record();
  } } }, [y("span", { class: x.$style.buttonIcon }, [y("RecordIcon")], 1), y("span", { class: x.$style.buttonLabel, domProps: { textContent: x._s(x.recordLabel) } })]), y("button", { class: [x.buttonClass, x.$style.button], attrs: { type: "button", disabled: !x.isRecording }, on: { click: x.stop } }, [y("span", { class: x.$style.buttonIcon }, [y("StopIcon")], 1), y("span", { class: x.$style.buttonLabel, domProps: { textContent: x._s(x.stopLabel) } })])], 1), x._t("duration", function() {
    return [y("div", { class: [x.$style.duration, x.isRecording && x.$style.textPrimary] }, [x._v(" " + x._s(x.formatDuration(x.duration)) + " ")])];
  }, { duration: x.formatDuration(x.duration), isRecording: x.isRecording })], 2);
}, s2 = [];
const Sa = {
  $style: r2
};
function i2(m) {
  for (var x in Sa)
    this[x] = Sa[x];
}
var _2 = /* @__PURE__ */ Aa(
  t2,
  n2,
  s2,
  !1,
  i2,
  null,
  null,
  null
);
const o2 = _2.exports;
export {
  ga as AudioPlayer,
  o2 as AudioRecorder,
  Ot as calculateAverageGain
};
